import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Cookie from 'js-cookie';
import { v4 } from 'uuid';
import { parseHostname, Environment } from 'shared';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _wrapNativeSuper from '@babel/runtime/helpers/wrapNativeSuper';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import styled, { css, ThemeContext, keyframes, useTheme, createGlobalStyle } from 'styled-components';
import _merge from 'lodash/merge';
import React, { useState, useCallback, useMemo, useEffect, useLayoutEffect, useContext, useRef, Fragment, Children } from 'react';
import copy from 'copy-to-clipboard';
import hljs from 'highlight.js/lib/core';
import plaintext from 'highlight.js/lib/languages/plaintext';
import markdown from 'highlight.js/lib/languages/markdown';
import json from 'highlight.js/lib/languages/json';
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';
import cssLang from 'highlight.js/lib/languages/css';
import less from 'highlight.js/lib/languages/less';
import swift from 'highlight.js/lib/languages/swift';
import objectivec from 'highlight.js/lib/languages/objectivec';
import python from 'highlight.js/lib/languages/python';
import php from 'highlight.js/lib/languages/php';
import perl from 'highlight.js/lib/languages/perl';
import java from 'highlight.js/lib/languages/java';
import { useHistory } from 'react-router';
import { format, parseISO } from 'date-fns';
import QueryString from 'query-string';
import _mergeWith from 'lodash/mergeWith';
import _isArray from 'lodash/isArray';
import { normalize as normalize$1, schema } from 'normalizr';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import tinycolor from '@ctrl/tinycolor';
import _extends from '@babel/runtime/helpers/extends';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { createPortal } from 'react-dom';
import ReactMarkdown from 'react-markdown';
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough';
import { gfmFromMarkdown, gfmToMarkdown } from 'mdast-util-gfm';
import remarkBreaks from 'remark-breaks';
import AutosizeTextarea from 'react-autosize-textarea';
import lottie from 'lottie-web';
import { useCombobox } from 'downshift';
import ReactModal from 'react-modal';
import reboot, { defaultRebootTheme } from 'styled-reboot';

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var mobileBreakpoint = "768px";
var mobileBreakpointRuleDown = "@media screen and (max-width: ".concat(mobileBreakpoint, ")");
var mobileBreakpointRuleUp = "@media screen and (min-width: ".concat(mobileBreakpoint, ")");

/**
 * Color object contains base colors, extend named theme colors below:
 * IE:
 * const color = {
 *  red: "#FF0000",
 * }
 * color.primary = color.red;
 */
var color = {
  success: "#00C851",
  info: "#3769E4",
  infoLight: "#F5F9FF",
  infoDark: "#2A57C8",
  warning: "#FFAC26",
  warningLight: "#FFFCF5",
  warningDark: "#E7AF41",
  error: "#C83434",
  errorLight: "#FFF7F7",
  errorDark: "#B12424",
  neutral: "#757575",
  neutralLight: "#FAFAFA",
  neutralDark: "#616161",
  green: "#6BBC19",
  red: "#DD0000",
  gallerySelection: "#E9EEF4",
  focus: "#5586FF",
  toolbarBackground: "rgba(255, 255, 255, 0.98)",
  modalOverlay: "rgba(42, 42, 42, 0.9)",
  // Brand blue
  blue700: "#3534C4",
  blue600: "#3E3FD1",
  blue500: "#4349DC",
  blue400: "#6066E3",
  blue300: "#6066E3",
  blue200: "#A3A6EF",
  blue100: "#C8C9F5",
  // Brand red
  red700: "#BD1759",
  red600: "#D31A5F",
  red500: "#E41D61",
  red400: "#E73F78",
  red300: "#EC6190",
  red200: "#F18EAF",
  red100: "#C8C9F5",
  // Brand yellow
  yellow700: "#3534c4",
  yellow600: "#3e3fd1",
  yellow500: "#4349dc",
  yellow400: "#6066e3",
  yellow300: "#6066e3",
  yellow200: "#a3a6ef",
  yellow100: "#c8c9f5",
  // Brand neutral
  neutral900: "#242425",
  neutral800: "#58595A",
  neutral700: "#767678",
  neutral600: "#A3A4A6",
  neutral500: "#D4D5D7",
  neutral400: "#E1E2E4",
  neutral300: "#EEEFF0",
  neutral200: "#FAFAFA",
  neutral100: "#FFFFFF"
};
color.primaryDarkest = color.blue700;
color.primaryDark = color.blue600;
color.primary = color.blue500;
color.primaryLight = color.blue400;
color.primaryLighter = color.blue300;
color.primaryExtraLight = color.blue200;
color.primaryLightest = color.blue100;
color.secondaryDarkest = color.red700;
color.secondaryDark = color.red600;
color.secondary = color.red500;
color.secondaryLight = color.red400;
color.secondaryLighter = color.red300;
color.secondaryExtraLight = color.red200;
color.secondaryLightest = color.red100;
color.tertiaryDarkest = color.yellow700;
color.tertiaryDark = color.yellow600;
color.tertiary = color.yellow500;
color.tertiaryLight = color.yellow400;
color.tertiaryLighter = color.yellow300;
color.tertiaryExtraLight = color.yellow200;
color.tertiaryLightest = color.yellow100;
color.black = color.neutral900;
color.grayDarkest = color.neutral800;
color.grayDarker = color.neutral700;
color.grayDark = color.neutral600;
color.gray = color.neutral500;
color.grayLight = color.neutral400;
color.grayLighter = color.neutral300;
color.grayLightest = color.neutral200;
color.white = color.neutral100;
color.neutralLoader = color.neutral600;
color.border = color.neutral400;
color.panelBackground = color.neutral200;
var boxShadow = {
  panel: "0 10px 20px rgba(0, 0, 0, 0.2)",
  component: "0px 1px 1px rgba(42, 42, 42, 0.05)",
  card: "0px 4px 16px rgba(42, 42, 42, 0.12);",
  image: "0px 2px 6px rgba(42, 42, 42, 0.14), 0px 6px 20px rgba(0, 0, 0, 0.08);",
  button: "0px 1px 2px rgba(42, 42, 42, 0.12), 0px 2px 8px rgba(42, 42, 42, 0.08);"
};
var borderRadius = {
  small: "4px",
  medium: "8px",
  large: "12px",
  pill: "100px",
  //Keeping old "default" for compatibility
  default: "4px"
};
var border = {
  default: "1px solid ".concat(color.grayLight),
  grayDashed: "1px dashed ".concat(color.grayLight),
  warning: "1px solid rgba(255, 172, 38, 0.6)"
};
var ellipsis = css(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var ellipsisObject = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
};
var zIndex = {
  inspectorView: 900,
  assetOverlay: 1000,
  modalWrapper: 20000,
  modal: 999
};
var fontStyles = {
  s76: _defineProperty({
    fontSize: "76px",
    lineHeight: "96px"
  }, mobileBreakpointRuleDown, {
    fontSize: "48px",
    lineHeight: "64px"
  }),
  s48: _defineProperty({
    fontSize: "48px",
    lineHeight: "64px"
  }, mobileBreakpointRuleDown, {
    fontSize: "28px",
    lineHeight: "40px"
  }),
  s36: {
    fontSize: "36px",
    lineHeight: "56px"
  },
  s28: _defineProperty({
    fontSize: "28px",
    lineHeight: "40px"
  }, mobileBreakpointRuleDown, {
    fontSize: "24px",
    lineHeight: "32px"
  }),
  s22: _defineProperty({
    fontSize: "22px",
    lineHeight: "32px"
  }, mobileBreakpointRuleDown, {
    fontSize: "20px",
    lineHeight: "32px"
  }),
  s20: {
    fontSize: "20px",
    lineHeight: "32px"
  },
  s18: {
    fontSize: "18px",
    lineHeight: "24px"
  },
  s16: {
    fontSize: "16px",
    lineHeight: "24px"
  },
  s14: {
    fontSize: "14px",
    lineHeight: "24px"
  },
  s12: {
    fontSize: "12px",
    lineHeight: "16px"
  },
  s11: {
    fontSize: "11px",
    lineHeight: "16px"
  },
  italic: {
    fontStyle: "italic"
  }
};
var fontWeight = {
  light: {
    fontWeight: 300
  },
  regular: {
    fontWeight: "normal"
  },
  medium: {
    fontWeight: 500
  },
  semibold: {
    fontWeight: 600
  },
  bold: {
    fontWeight: 700
  },
  extraBold: {
    fontWeight: 800
  },
  black: {
    fontWeight: 900
  }
};
var fontFamily = {
  inter: {
    fontFamily: "'Inter', sans-serif"
  },
  mono: {
    fontFamily: "'Source Code Pro', monospace"
  },
  texta: {
    fontFamily: "'Texta Alt', serif"
  }
};

/**
 * The font object contains all styles both as nested groups for access in code
 * as well as dot seperated strings for access via component props
 *
 * Access via code
 * ```
 * import { font } from './styles'
 * const myStyle = css`
 *  ${font.ui.title}
 * `
 * ```
 *
 * Access via props
 * ```
 * <MyComponent font="ui.title" />
 * ```
 */
var font = {};
font.ui = {
  /** Marketing and 404 */
  mediumTitle: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s48), fontWeight.bold), fontFamily.inter),
  pageTitle: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s28), fontWeight.extraBold), fontFamily.inter),
  title: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s20), fontWeight.extraBold), fontFamily.inter),
  subtitle: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s18), fontWeight.light), fontFamily.inter),
  mediumSubtitle: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s28), fontWeight.medium), fontFamily.inter),
  regular: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s14), fontWeight.regular), fontFamily.inter),
  regularSemiBold: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s14), fontWeight.semibold), fontFamily.inter),
  regularBold: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s14), fontWeight.bold), fontFamily.inter),
  small: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s12), fontWeight.regular), fontFamily.inter),
  smallBold: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s12), fontWeight.semibold), fontFamily.inter),
  tiny: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s11), fontWeight.regular), fontFamily.inter)
};
font.themeOverrides = {
  scher: {
    "ui.mediumTitle": _defineProperty({
      fontSize: "76px",
      letterSpacing: "-.03em"
    }, mobileBreakpointRuleDown, {
      fontSize: "40px"
    }),
    "ui.mediumSubtitle": _defineProperty({
      fontSize: "48px",
      letterSpacing: "-.02em"
    }, mobileBreakpointRuleDown, {
      fontSize: "32px"
    }),
    "ui.pageTitle": _defineProperty({
      fontSize: "28px",
      letterSpacing: "-.02em"
    }, mobileBreakpointRuleDown, {
      fontSize: "28px"
    }),
    "ui.title": {
      fontSize: "24px"
    },
    "ui.subtitle": _defineProperty({
      fontSize: "24px"
    }, mobileBreakpointRuleDown, {
      fontSize: "20px"
    }),
    "gallery.title": {
      fontSize: "48px",
      fontWeight: 600,
      letterSpacing: "-0.021em",
      lineHeight: 1
    }
  },
  wyman: {
    "ui.mediumTitle": _defineProperty({
      fontSize: "52px",
      fontWeight: 700,
      letterSpacing: "-.015em"
    }, mobileBreakpointRuleDown, {
      fontSize: "36px"
    }),
    "ui.mediumSubtitle": {
      letterSpacing: "-.015em"
    },
    "ui.pageTitle": _defineProperty({
      fontSize: "24px",
      fontWeight: 600,
      letterSpacing: "-.015em"
    }, mobileBreakpointRuleDown, {
      fontSize: "24px"
    }),
    "ui.title": {
      fontWeight: 500,
      letterSpacing: "-.015em"
    },
    "ui.subtitle": {
      fontWeight: 400,
      letterSpacing: "-.015em"
    }
  }
};
font.classic = {
  title: _objectSpread$j(_objectSpread$j({}, font.ui.title), {}, {
    fontWeight: 600,
    letterSpacing: "-.0125em",
    lineHeight: 1.5
  })
};
font.gallery = {
  /** Main gallery tites (e.g. section name) */
  title: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s36), fontWeight.black), fontFamily.inter),
  /** Heading items */
  heading: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s28), fontWeight.semibold), fontFamily.inter),
  /** Markdown h1 */
  h1: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s22), fontWeight.semibold), fontFamily.inter),
  /** Markdown h2 */
  h2: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s16), fontWeight.semibold), fontFamily.inter),
  /** Markdown body */
  regular: _objectSpread$j(_objectSpread$j(_objectSpread$j({}, fontStyles.s14), fontWeight.regular), fontFamily.inter),
  /** Code */
  code: _objectSpread$j(_objectSpread$j({}, fontStyles.s14), fontFamily.mono)
};

/**
 * Marketing fonts
 */
font.marketing = {
  /** H1 Text */
  h1: _objectSpread$j(_objectSpread$j(_defineProperty({
    fontSize: "64px",
    lineHeight: "64px",
    letterSpacing: "-1.5px"
  }, mobileBreakpointRuleDown, {
    fontSize: "48px",
    lineHeight: "48px",
    letterSpacing: "-1.25px"
  }), fontWeight.black), fontFamily.texta),
  /** H2 Text */
  h2: _objectSpread$j(_objectSpread$j({
    fontSize: "48px",
    lineHeight: "48px",
    letterSpacing: "-1.25px"
  }, fontWeight.black), fontFamily.texta),
  /** H3 Text */
  h3: _objectSpread$j(_objectSpread$j({
    fontSize: "36px",
    lineHeight: "36px",
    letterSpacing: "-0.5px"
  }, fontWeight.black), fontFamily.texta),
  /** H4 Text */
  h4: _objectSpread$j(_objectSpread$j({
    fontSize: "28px",
    lineHeight: "28px",
    letterSpacing: "0"
  }, fontWeight.black), fontFamily.texta),
  /** H5 Text */
  h5: _objectSpread$j(_objectSpread$j({
    fontSize: "24px",
    lineHeight: "24px",
    letterSpacing: "1px"
  }, fontWeight.medium), fontFamily.texta),
  /** Subtitle 1 */
  subtitle1: _objectSpread$j(_objectSpread$j({
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0"
  }, fontWeight.black), fontFamily.texta),
  /** Subtitle 2 */
  subtitle2: _objectSpread$j(_objectSpread$j({
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0"
  }, fontWeight.black), fontFamily.texta),
  /** Body Large */
  bodyLarge: _objectSpread$j(_objectSpread$j({
    fontSize: "20px",
    lineHeight: "32px",
    letterSpacing: "-0.25px"
  }, fontWeight.light), fontFamily.inter),
  /** Body Regular */
  regular: _objectSpread$j(_objectSpread$j({
    fontSize: "16px",
    lineHeight: "28px",
    letterSpacing: "0px"
  }, fontWeight.regular), fontFamily.inter),
  /** Body Regular Bold */
  regularBold: _objectSpread$j(_objectSpread$j({
    fontSize: "16px",
    lineHeight: "28px",
    letterSpacing: "0px"
  }, fontWeight.bold), fontFamily.inter),
  /** Nav Link */
  navLink: _objectSpread$j(_objectSpread$j({
    fontSize: "14px",
    lineHeight: "16px"
  }, fontWeight.medium), fontFamily.inter),
  /** Nav Link */
  textLink: _objectSpread$j(_objectSpread$j({
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: ".5px"
  }, fontWeight.semibold), fontFamily.inter),
  /** Caption */
  caption: _objectSpread$j(_objectSpread$j({
    fontSize: "11px",
    lineHeight: "16px"
  }, fontWeight.regular), fontFamily.inter)
};
font.blog = {
  h1: _objectSpread$j(_objectSpread$j(_defineProperty({
    fontSize: "32px",
    lineHeight: "48px",
    letterSpacing: ".25px"
  }, mobileBreakpointRuleDown, {
    fontSize: "28px",
    lineHeight: "42px",
    letterSpacing: ".25px"
  }), fontWeight.bold), fontFamily.texta),
  h2: _objectSpread$j(_objectSpread$j(_defineProperty({
    fontSize: "24px",
    lineHeight: "36px",
    letterSpacing: "0.25px"
  }, mobileBreakpointRuleDown, {
    fontSize: "20px",
    lineHeight: "30px",
    letterSpacing: "0.25px"
  }), fontWeight.bold), fontFamily.texta),
  h3: _objectSpread$j(_objectSpread$j(_defineProperty({
    fontSize: "20px",
    lineHeight: 1.5,
    letterSpacing: "0.25px"
  }, mobileBreakpointRuleDown, {
    fontSize: "20px",
    lineHeight: 1.5,
    letterSpacing: "0.25px"
  }), fontWeight.bold), fontFamily.texta),
  figcaption: _objectSpread$j(_objectSpread$j({
    fontSize: "11px",
    lineHeight: 1.2,
    letterSpacing: "0.08px"
  }, fontWeight.regular), fontFamily.inter)
};
Object.keys(font).forEach(function (groupKey) {
  var g = font[groupKey];
  Object.keys(g).forEach(function (styleKey) {
    font["".concat(groupKey, ".").concat(styleKey)] = font[groupKey][styleKey];
  });
});
var transition = ".5s ease";
var space$1 = {
  none: "0",
  xxs: "2px",
  xs: "4px",
  s: "8px",
  m: "16px",
  l: "24px",
  xl: "40px",
  xxl: "80px",
  xxxl: "120px"
};
var Devices = {
  mobile: 0,
  tablet: 1,
  desktop: 2,
  mediaQueryForDevice: function mediaQueryForDevice(device) {
    switch (device) {
      case Devices.mobile:
      case Devices.tablet:
        return mobileBreakpointRuleDown;
      default:
        return "@media(min-width: ".concat(mobileBreakpoint, ")");
    }
  }
};

/**
 * Spacing values for responsive layouts
 *
 * [<768, 769-1280, >1280]
 */
var spacing = {
  none: [0, 0, 0],
  xxs: [2, 2, 2],
  xs: [4, 4, 4],
  s: [4, 4, 8],
  m: [8, 8, 16],
  l: [16, 24, 24],
  xl: [24, 32, 40],
  xxl: [40, 60, 80],
  xxxl: [80, 100, 120]
};
Object.keys(spacing).forEach(function (k) {
  var negValues = spacing[k].map(function (v) {
    return -Math.abs(v);
  });
  spacing["-".concat(k)] = negValues;
});
var properties = {
  a: [""],
  t: ["Top"],
  b: ["Bottom"],
  r: ["Right"],
  l: ["Left"],
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
var makeSpacingRule = function makeSpacingRule(propertyType, propertyAspects, spacingKey) {
  var _spacing$spacingKey = _slicedToArray(spacing[spacingKey], 2),
    mobilePx = _spacing$spacingKey[0],
    desktopPx = _spacing$spacingKey[1];
  return _objectSpread$j(_objectSpread$j({}, propertyAspects.reduce(function (obj, asp) {
    obj["".concat(propertyType).concat(asp)] = "".concat(mobilePx, "px");
    return obj;
  }, {})), {}, _defineProperty({}, mobileBreakpointRuleUp, _objectSpread$j({}, propertyAspects.reduce(function (obj, asp) {
    obj["".concat(propertyType).concat(asp)] = "".concat(desktopPx, "px");
    return obj;
  }, {}))));
};

/**
 * These are populated as
 * {
 *  a: {
 *    none: { margin: 0, @media(...) }
 *    xxs: { margin: 2, @media(...) }
 *  },
 *  t: {
 *    none: { margin-top: 0, @media(...) }
 *    xxs: { margin: 2, @media(...) }
 *  },
 * }
 */
var padding = {};
var margin = {};
Object.entries(properties).forEach(function (p) {
  var pKey = p[0],
    pVal = p[1];
  padding[pKey] = {};
  margin[pKey] = {};
  Object.keys(spacing).forEach(function (spacingKey) {
    padding[pKey][spacingKey] = makeSpacingRule("padding", pVal, spacingKey);
    margin[pKey][spacingKey] = makeSpacingRule("margin", pVal, spacingKey);
  });
});

/**
 * Defined breakpoints to use for styled-component media query helper
 */
var bp = {
  xs: 500,
  s: 768,
  m: 1024,
  l: 1200,
  xl: 1400
};

/**
 * Creates declarative media queries for use within styled components
 * Ex:
 * const Wrapper = styled.div`
 *  background: black;
 *  ${mq.s`
 *    background: red;
 *  `}
 *  ${mq.l_up`
 *    background: blue;
 *  `}
 * `
 */

var mq = Object.keys(bp).reduce(function (acc, label) {
  acc[label] = function (style) {
    return css(["@media screen and (max-width:", "px){", ";}"], bp[label], style);
  };
  acc["".concat(label, "_up")] = function (style) {
    return css(["@media screen and (min-width:", "px){", ";}"], bp[label], style);
  };
  return acc;
}, {});

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Devices: Devices,
  border: border,
  borderRadius: borderRadius,
  boxShadow: boxShadow,
  color: color,
  ellipsis: ellipsis,
  ellipsisObject: ellipsisObject,
  font: font,
  fontFamily: fontFamily,
  fontStyles: fontStyles,
  margin: margin,
  mq: mq,
  padding: padding,
  space: space$1,
  spacing: spacing,
  transition: transition,
  zIndex: zIndex
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

var CustomFieldTypes;
(function (CustomFieldTypes) {
  CustomFieldTypes["text"] = "text";
  CustomFieldTypes["number"] = "number";
  CustomFieldTypes["date"] = "date";
  CustomFieldTypes["checklist"] = "checklist";
  CustomFieldTypes["select"] = "select";
})(CustomFieldTypes || (CustomFieldTypes = {}));
var CustomFieldOperation;
(function (CustomFieldOperation) {
  CustomFieldOperation["add"] = "add";
  CustomFieldOperation["remove"] = "remove";
  CustomFieldOperation["set"] = "set";
})(CustomFieldOperation || (CustomFieldOperation = {}));
var SpacePermission;
(function (SpacePermission) {
  SpacePermission["searchAssets"] = "search_assets";
  SpacePermission["viewMembers"] = "view_members";
  SpacePermission["delete"] = "delete";
  SpacePermission["manageBilling"] = "manage_billing";
  SpacePermission["manageResources"] = "manage_resources";
  SpacePermission["revokeInvitation"] = "revoke_invitation";
  SpacePermission["removeUser"] = "remove_user";
  SpacePermission["removeSelf"] = "remove_self";
  SpacePermission["edit"] = "edit";
  SpacePermission["createKit"] = "create_kit";
  SpacePermission["inviteUser"] = "invite_user";
  SpacePermission["changeUserRole"] = "change_user_role";
  SpacePermission["viewAnalytics"] = "view_analytics";
  SpacePermission["viewAdvancedAnalytics"] = "view_advanced_analytics";
  SpacePermission["manageExports"] = "manage_exports";
  SpacePermission["manageBrandPortal"] = "manage_brand_portal";
  SpacePermission["manageApiTokens"] = "manage_api_tokens";
  SpacePermission["managePasswordAccess"] = "manage_password_access";
  SpacePermission["managePublicAccess"] = "manage_public_access";
  SpacePermission["manageSEO"] = "manage_seo";
  SpacePermission["manageViews"] = "manage_views";
  SpacePermission["createKitCollection"] = "create_kit_collection";
  SpacePermission["editKitCollection"] = "edit_kit_collection";
  SpacePermission["viewAssetLibrary"] = "view_asset_library";
  SpacePermission["createAsset"] = "create_asset";
  SpacePermission["manageTags"] = "manage_tags";
  SpacePermission["viewFields"] = "view_fields";
  SpacePermission["editFields"] = "edit_fields";
  SpacePermission["manageCustomTheme"] = "manage_custom_theme";
  SpacePermission["manageCustomThemeFonts"] = "manage_custom_theme_font";
  SpacePermission["manageCustomThemeAppearance"] = "manage_custom_theme_appearance";
  SpacePermission["manageCustomDomain"] = "manage_custom_domain";
  SpacePermission["configureSSO"] = "configure_sso";
})(SpacePermission || (SpacePermission = {}));
var SpaceThemeNames;
(function (SpaceThemeNames) {
  SpaceThemeNames["classic"] = "classic";
  SpaceThemeNames["scher"] = "scher";
  SpaceThemeNames["wyman"] = "wyman";
})(SpaceThemeNames || (SpaceThemeNames = {}));
var SpaceThemeHeaderTitleOptions;
(function (SpaceThemeHeaderTitleOptions) {
  SpaceThemeHeaderTitleOptions["space_name"] = "space_name";
  SpaceThemeHeaderTitleOptions["logo"] = "logo_only";
  SpaceThemeHeaderTitleOptions["no_title"] = "no_title";
})(SpaceThemeHeaderTitleOptions || (SpaceThemeHeaderTitleOptions = {}));
var KitPermission;
(function (KitPermission) {
  KitPermission["view"] = "view";
  KitPermission["searchAssets"] = "search_assets";
  KitPermission["favorite"] = "favorite";
  KitPermission["changeOwnStatus"] = "change_own_status";
  KitPermission["viewAllContent"] = "view_all_content";
  KitPermission["edit"] = "edit";
  KitPermission["delete"] = "delete";
  KitPermission["changeMemberRole"] = "change_member_role";
  KitPermission["editContent"] = "edit_content";
  KitPermission["manage"] = "manage";
  KitPermission["manageExports"] = "manage_exports";
  KitPermission["manageSharelinks"] = "manage_sharelinks";
  KitPermission["managePublicAccess"] = "manage_public_access";
  KitPermission["managePasswordAccess"] = "manage_password_access";
  KitPermission["manageSEO"] = "manage_seo";
  KitPermission["managePortalAccess"] = "manage_portal_access";
})(KitPermission || (KitPermission = {}));
/** SEARCH **/

var SearchFilterTypes;
(function (SearchFilterTypes) {
  SearchFilterTypes["kit"] = "kit";
  SearchFilterTypes["type"] = "type";
  SearchFilterTypes["orientation"] = "orientation";
  SearchFilterTypes["tag"] = "tag";
  SearchFilterTypes["after"] = "after";
  SearchFilterTypes["before"] = "before";
  SearchFilterTypes["name"] = "name";
  SearchFilterTypes["uploader"] = "uploader";
  SearchFilterTypes["date"] = "date";
  SearchFilterTypes["text"] = "text";
  SearchFilterTypes["token"] = "token";
  SearchFilterTypes["field-text"] = "field-text";
  SearchFilterTypes["field-date"] = "field-date";
  SearchFilterTypes["field-number"] = "field-number";
  SearchFilterTypes["field-checklist"] = "field-checklist";
  SearchFilterTypes["field-select"] = "field-select";
})(SearchFilterTypes || (SearchFilterTypes = {}));
var SearchOperators;
(function (SearchOperators) {
  SearchOperators["eq"] = "eq";
  SearchOperators["lt"] = "lt";
  SearchOperators["gt"] = "gt";
  SearchOperators["lte"] = "lte";
  SearchOperators["gte"] = "gte";
})(SearchOperators || (SearchOperators = {}));

var _themeVals;
function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// MARK : Themes
// -------------------------------------------------------------------------------
function getThemeName(props) {
  var _props$theme;
  return (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName) || SpaceThemeNames.classic;
}

// MARK : Colors
/*-------------------------------------------------------------------------------*/

function getColor(propValue) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (propValue) {
    if (color[propValue]) {
      return color[propValue];
    }
    return propValue;
  }
  return fallback ? getColor(fallback) : null;
}
function getPrimaryColor(props) {
  if (props.theme.primaryColor) return props.theme.primaryColor;
  return color.primary;
}
function getPrimaryColorTint(props) {
  if (props.theme.primaryColorTint) return props.theme.primaryColorTint;
  return "#fff";
}
function replaceColors(str) {
  if (!str) return str;
  return str.split(" ").map(function (comp) {
    return color[comp] || comp;
  }).join(" ");
}
function getShadow(propValue, def) {
  return propValue && (boxShadow[propValue] || replaceColors(propValue)) || (def ? getShadow(def) : null);
}

// MARK : Fonts
/*-------------------------------------------------------------------------------*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFont(propValue, def, props) {
  if (propValue) {
    if (font[propValue]) {
      /**
       * Get the default font object based on the prop value passed.
       * If there is an override or theme font accessible in props, replace font family.
       * NOTE: We may need some font style map if we support multiple fonts in the future.
       */
      var fontObject = _objectSpread$i({}, font[propValue]);
      var customFontFamily = getCustomFontFamily(props);
      var themeOverrides = getThemeFontOverrides(propValue, def, props);
      if (customFontFamily) fontObject.fontFamily = customFontFamily;
      return _merge(fontObject, themeOverrides);
    }
    if (typeof propValue === "string") {
      console.error("Invalid font name ".concat(propValue));
    }
    return propValue;
  }
  return def ? getFont(def, null, props) : null;
}
function getThemeFontOverrides(propValue, def, props) {
  var _props$theme2, _font$themeOverrides$;
  var key = propValue || def;
  var themeName = props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.themeName;
  if (themeName && (_font$themeOverrides$ = font.themeOverrides[themeName]) !== null && _font$themeOverrides$ !== void 0 && _font$themeOverrides$[key]) return font.themeOverrides[props.theme.themeName][key];
  return {};
}
function getCustomFontFamily(props) {
  var _props$font, _props$theme3, _props$theme3$fonts, _props$theme3$fonts$s;
  if ((props === null || props === void 0 ? void 0 : props.as) === "code" || props !== null && props !== void 0 && (_props$font = props.font) !== null && _props$font !== void 0 && _props$font.includes("code")) return fontFamily.mono.fontFamily;
  if (props !== null && props !== void 0 && (_props$theme3 = props.theme) !== null && _props$theme3 !== void 0 && (_props$theme3$fonts = _props$theme3.fonts) !== null && _props$theme3$fonts !== void 0 && (_props$theme3$fonts$s = _props$theme3$fonts.system) !== null && _props$theme3$fonts$s !== void 0 && _props$theme3$fonts$s.family) {
    return "\"".concat(props.theme.fonts.system.family, "\", sans-serif");
  }
  return undefined;
}

// MARK : Borders
/*-------------------------------------------------------------------------------*/

var themeVals = (_themeVals = {}, _defineProperty(_themeVals, SpaceThemeNames.classic, {
  borderRadius: "small"
}), _defineProperty(_themeVals, SpaceThemeNames.scher, {
  borderRadius: "pill"
}), _defineProperty(_themeVals, SpaceThemeNames.wyman, {
  borderRadius: "medium"
}), _themeVals);
function getBorderRadius(propValue) {
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return themeVals[propValue] && borderRadius[themeVals[propValue].borderRadius] || propValue && (borderRadius[propValue] || cssVal(propValue)) || (def ? getBorderRadius(def) : null);
}

/**
 *
 * @param {string} propValue the desired border value
 * @param {string=} def a default border value if propValue is not defined (optional)
 *
 * Attampts to replace any values in the border definition with a color value
 * This allows for values like `1px solid grayLight` where grayLight will be replaced with
 * the predefined color vlaue.
 */
function getBorder(propValue) {
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (propValue) {
    if (border[propValue]) {
      return border[propValue];
    }
    return replaceColors(propValue);
  }
  return def ? getBorder(def) : null;
}

// MARK : Spacing
/*-------------------------------------------------------------------------------*/

function getZIndex(propValue) {
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return propValue && zIndex[propValue] || propValue || (def ? getZIndex(def) : null);
}
function getResponsiveSpacing(device, val) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var values = spacing[val] || spacing[fallback];
  if (values) {
    return cssVal(values[device === null ? Devices.desktop : device]);
  }
  return cssVal(val) || cssVal(fallback);
}
function cssVal(val) {
  if (val === "") return null;
  if (val === null) return null;
  var num = Number(val);
  return Number.isNaN(num) ? val : "".concat(val, "px");
}
function flexCSS(props) {
  return css(["flex:", ";flex-basis:", ";flex-grow:", ";flex-shrink:", ";", ""], props.flex, props.flexBasis, props.flexGrow, props.flexShrink, getVariations(props, flexCSS));
}
function positioningCSS(props) {
  function getPositionSpacing(device) {
    return css(["padding:", ";padding-left:", ";padding-right:", ";padding-bottom:", ";padding-top:", ";margin:", ";margin-left:", ";margin-right:", ";margin-bottom:", ";margin-top:", ";top:", ";left:", ";right:", ";bottom:", ";"], getResponsiveSpacing(device, props.p), getResponsiveSpacing(device, props.pl, props.px), getResponsiveSpacing(device, props.pr, props.px), getResponsiveSpacing(device, props.pb, props.py), getResponsiveSpacing(device, props.pt, props.py), getResponsiveSpacing(device, props.m), getResponsiveSpacing(device, props.ml, props.mx), getResponsiveSpacing(device, props.mr, props.mx), getResponsiveSpacing(device, props.mb, props.my), getResponsiveSpacing(device, props.mt, props.my), getResponsiveSpacing(device, props.top), getResponsiveSpacing(device, props.left), getResponsiveSpacing(device, props.right), getResponsiveSpacing(device, props.bottom));
  }
  return css(["", " width:", ";height:", ";max-width:", ";max-height:", ";min-width:", ";min-height:", ";text-align:", ";justify-self:", ";align-self:", ";z-index:", ";transform:", ";order:", ";position:", ";display:", ";overflow:", ";", "{", "}", "{", "}", ""], getPositionSpacing(Devices.desktop), props.width && cssVal(props.width), props.height && cssVal(props.height), props.maxWidth && cssVal(props.maxWidth), props.maxHeight && cssVal(props.maxHeight), props.minWidth && cssVal(props.minWidth), props.minHeight && cssVal(props.minHeight), props.textAlign, props.justifySelf, props.alignSelf, getZIndex(props.zIndex), props.transform, props.order, props.position, props.display, props.overflow, Devices.mediaQueryForDevice(Devices.tablet), getPositionSpacing(Devices.tablet), Devices.mediaQueryForDevice(Devices.mobile), getPositionSpacing(Devices.mobile), getVariations(props, positioningCSS));
}
function borderCSS(props) {
  return css(["border-radius:", ";border:", ";border-top:", ";border-left:", ";border-right:", ";border-bottom:", ";", ""], getBorderRadius(props.borderRadius), getBorder(props.border), getBorder(props.borderTop), getBorder(props.borderLeft), getBorder(props.borderRight), getBorder(props.borderBottom), getVariations(props, borderCSS));
}
function transitionCSS(props) {
  return css(["transition:", ";transition-property:", ";transition-duration:", ";transition-timing-function:", ";transition-delay:", ";", ""], props.transition, props.transitionProperty, props.transitionDuration, props.transitionTimingFunction, props.transitionDelay, getVariations(props, transitionCSS));
}
function getVariations(props, render) {
  var keys = Object.keys(props.variations || {});
  return keys.reduce(function (res, key) {
    var val = render(props.variations[key]);
    if (key.startsWith("mq")) {
      var size = key.split(".")[1];
      res.push(mq[size](val));
    } else {
      res.push(css(["", "{", "}"], key, val));
    }
    return res;
  }, []);
}
var centered = css(["position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);"]);
var Sticky = styled.div.withConfig({
  displayName: "utils__Sticky"
})(["position:sticky;top:0;"]);

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Sticky: Sticky,
  borderCSS: borderCSS,
  centered: centered,
  cssVal: cssVal,
  flexCSS: flexCSS,
  getBorder: getBorder,
  getBorderRadius: getBorderRadius,
  getColor: getColor,
  getCustomFontFamily: getCustomFontFamily,
  getFont: getFont,
  getPrimaryColor: getPrimaryColor,
  getPrimaryColorTint: getPrimaryColorTint,
  getShadow: getShadow,
  getThemeName: getThemeName,
  getVariations: getVariations,
  positioningCSS: positioningCSS,
  transitionCSS: transitionCSS
});

function variableStyle$2(props) {
  return css(["background-color:", ";background-image:", ";background-size:", ";background-position:", ";overflow:", ";box-shadow:", ";", ";", ""], getColor(props.background), props.backgroundImage, props.backgroundSize, props.backgroundPosition, props.overflow, getShadow(props.boxShadow), props.aspectRatio && "&:before {\n      content: \"\";\n      display: block;\n      padding-top: ".concat(props.aspectRatio, "%;\n    }"), getVariations(props, variableStyle$2));
}
var Box = styled.div.withConfig({
  displayName: "Box"
})(["box-sizing:border-box;", " ", " ", " ", " ", ""], variableStyle$2, positioningCSS, flexCSS, borderCSS, transitionCSS);
Box.defaultProps = {
  position: "relative"
};
var Box$1 = Box;

var _excluded$r = ["id"];
function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var elementFonts = {
  h1: "ui.mediumTitle",
  h2: "ui.title",
  h3: "ui.regularBold",
  h4: "ui.regularBold",
  label: "ui.smallBold",
  code: "gallery.code"
};
function getFontName(props) {
  return props.font || elementFonts[props.as] || "ui.regular";
}
var Text = styled.p.attrs(function (_ref) {
  var id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded$r);
  var ellipsisStyles = props.truncate ? ellipsisObject : {};
  return {
    "data-testid": id || props["data-testid"],
    as: props.as,
    style: _objectSpread$h(_objectSpread$h({}, ellipsisStyles), {}, {
      display: props.display,
      boxSizing: "border-box",
      backgroundColor: getColor(props.background),
      textAlign: props.textAlign,
      fontStyle: props.fontStyle,
      letterSpacing: props.letterSpacing,
      lineHeight: props.lineHeight,
      textDecoration: props.textDecoration,
      textTransform: props.textTransform,
      color: getColor(props.color, "black")
    })
  };
}).withConfig({
  displayName: "Text"
})(["", ";", " ", " ", " ", ""], function (props) {
  return getFont(getFontName(props), "ui.regular", props);
}, function (props) {
  return positioningCSS(_objectSpread$h({
    m: "none"
  }, props));
}, borderCSS, flexCSS, transitionCSS);

function variableStyle$1(props) {
  return css(["flex-wrap:", ";flex-direction:", ";align-items:", ";justify-content:", ";gap:", ";", ""], props.flexWrap, props.flexDirection, props.alignItems, props.justifyContent, props.gap, getVariations(props, variableStyle$1));
}
var Flex = styled(Box$1).withConfig({
  displayName: "Flex"
})(["display:flex;", ""], variableStyle$1);
var Flex$1 = Flex;

var iconIndex = {
  "action.add": "24x24",
  "action.add-circle": "24x24",
  "action.checkbox-checked": "24x24",
  "action.checkbox-unchecked": "24x24",
  "action.clear": "24x24",
  "action.close": "24x24",
  "action.copy": "24x24",
  "action.download": "24x24",
  "action.dropper": "24x24",
  "action.edit": "24x24",
  "action.expand": "24x24",
  "action.external-link": "24x24",
  "action.filter": "24x24",
  "action.link": "24x24",
  "action.logout": "24x24",
  "action.maximize": "24x24",
  "action.minimize": "24x24",
  "action.play": "24x24",
  "action.radio-deselected": "24x24",
  "action.radio-selected": "24x24",
  "action.reorder": "24x24",
  "action.table-sort-ascending": "24x24",
  "action.table-sort-descending": "24x24",
  "action.trash": "24x24",
  "action.copy_to": "24x24",
  "action.move_to": "24x24",
  "action.add-to": "24x24",
  "action.drag-handler": "24x24",
  "action.checkbox-indeterminate": "24x24",
  "action.add_16": "16x16",
  "action.add-circle_16": "16x16",
  "action.checkbox-checked_16": "16x16",
  "action.checkbox-unchecked_16": "16x16",
  "action.clear_16": "16x16",
  "action.close_16": "16x16",
  "action.copy_16": "16x16",
  "action.download_16": "16x16",
  "action.dropper_16": "16x16",
  "action.edit_16": "16x16",
  "action.expand_16": "16x16",
  "action.external-link_16": "16x16",
  "action.filter_16": "16x16",
  "action.link_16": "16x16",
  "action.logout_16": "16x16",
  "action.maximize_16": "16x16",
  "action.minimize_16": "16x16",
  "action.play_16": "16x16",
  "action.radio-deselected_16": "16x16",
  "action.radio-selected_16": "16x16",
  "action.reorder_16": "16x16",
  "action.table-sort-ascending_16": "16x16",
  "action.table-sort-descending_16": "16x16",
  "action.trash_16": "16x16",
  "action.copy_to_16": "16x16",
  "action.move_to_16": "16x16",
  "action.add-to_16": "16x16",
  "action.drag-handler_16": "16x16",
  "action.checkbox-indeterminate_16": "16x16",
  "content.audio": "24x24",
  "content.code": "24x24",
  "content.color": "24x24",
  "content.file": "24x24",
  "content.file-document": "24x24",
  "content.file-graphic": "24x24",
  "content.font": "24x24",
  "content.guide": "24x24",
  "content.heading": "24x24",
  "content.kit": "24x24",
  "content.note": "24x24",
  "content.section": "24x24",
  "content.supporting-image": "24x24",
  "content.version": "24x24",
  "content.audio_16": "16x16",
  "content.code_16": "16x16",
  "content.color_16": "16x16",
  "content.file_16": "16x16",
  "content.file-document_16": "16x16",
  "content.file-graphic_16": "16x16",
  "content.font_16": "16x16",
  "content.guide_16": "16x16",
  "content.heading_16": "16x16",
  "content.kit_16": "16x16",
  "content.note_16": "16x16",
  "content.section_16": "16x16",
  "content.supporting-image_16": "16x16",
  "content.version_16": "16x16",
  "empty-state.assets": "24x24",
  "empty-state.supporting": "24x24",
  "info.building": "24x24",
  "info.check-circle": "24x24",
  "info.checkmark": "24x24",
  "info.cloud-download": "24x24",
  "info.code-android": "24x24",
  "info.code-apple": "24x24",
  "info.code-web": "24x24",
  "info.component": "24x24",
  "info.error": "24x24",
  "info.figma": "24x24",
  "info.frame": "24x24",
  "info.globe": "24x24",
  "info.globe-lock": "24x24",
  "info.group": "24x24",
  "info.history": "24x24",
  "info.info": "24x24",
  "info.lock-closed": "24x24",
  "info.lock-open": "24x24",
  "info.sketch": "24x24",
  "info.spinner": "24x24",
  "info.star": "24x24",
  "info.star-filled": "24x24",
  "info.upload": "24x24",
  "info.warning": "24x24",
  "info.help": "24x24",
  "info.building_16": "16x16",
  "info.check-circle_16": "16x16",
  "info.checkmark_16": "16x16",
  "info.cloud-download_16": "16x16",
  "info.code-android_16": "16x16",
  "info.code-apple_16": "16x16",
  "info.code-web_16": "16x16",
  "info.component_16": "16x16",
  "info.error_16": "16x16",
  "info.figma_16": "16x16",
  "info.frame_16": "16x16",
  "info.globe_16": "16x16",
  "info.globe-lock_16": "16x16",
  "info.group_16": "16x16",
  "info.history_16": "16x16",
  "info.info_16": "16x16",
  "info.lock-closed_16": "16x16",
  "info.lock-open_16": "16x16",
  "info.sketch_16": "16x16",
  "info.spinner_16": "16x16",
  "info.star_16": "16x16",
  "info.star-filled_16": "16x16",
  "info.upload_16": "16x16",
  "info.warning_16": "16x16",
  "info.help_16": "16x16",
  "logo.full": "75x35",
  "logo.mark": "24x24",
  "logo.mark_16": "16x16",
  "marketing.asset-library": "24x24",
  "marketing.design-system": "24x24",
  "marketing.distribution": "24x24",
  "marketing.security": "24x24",
  "marketing.storage": "24x24",
  "marketing.style-guide": "24x24",
  "marketing.support": "24x24",
  "marketing.terms": "24x24",
  "marketing.usage": "24x24",
  "marketing.asset-library_16": "16x16",
  "marketing.design-system_16": "16x16",
  "marketing.distribution_16": "16x16",
  "marketing.security_16": "16x16",
  "marketing.storage_16": "16x16",
  "marketing.style-guide_16": "16x16",
  "marketing.support_16": "16x16",
  "marketing.terms_16": "16x16",
  "marketing.usage_16": "16x16",
  "navigation.chart": "24x24",
  "navigation.chevron-down": "24x24",
  "navigation.chevron-left": "24x24",
  "navigation.chevron-right": "24x24",
  "navigation.chevron-up": "24x24",
  "navigation.credit-card": "24x24",
  "navigation.kit-menu": "24x24",
  "navigation.layout-detailed": "24x24",
  "navigation.layout-simple": "24x24",
  "navigation.mail": "24x24",
  "navigation.menu": "24x24",
  "navigation.overflow": "24x24",
  "navigation.privacy": "24x24",
  "navigation.search": "24x24",
  "navigation.settings": "24x24",
  "navigation.user": "24x24",
  "navigation.user-group": "24x24",
  "navigation.chart_16": "16x16",
  "navigation.chevron-down_16": "16x16",
  "navigation.chevron-left_16": "16x16",
  "navigation.chevron-right_16": "16x16",
  "navigation.chevron-up_16": "16x16",
  "navigation.credit-card_16": "16x16",
  "navigation.kit-menu_16": "16x16",
  "navigation.layout-detailed_16": "16x16",
  "navigation.layout-simple_16": "16x16",
  "navigation.mail_16": "16x16",
  "navigation.menu_16": "16x16",
  "navigation.overflow_16": "16x16",
  "navigation.privacy_16": "16x16",
  "navigation.search_16": "16x16",
  "navigation.settings_16": "16x16",
  "navigation.user_16": "16x16",
  "navigation.user-group_16": "16x16",
  "social.facebook": "24x24",
  "social.twitter": "24x24",
  "social.facebook_16": "16x16",
  "social.twitter_16": "16x16",
  "integrations.google-drive": "24x24",
  "integrations.dropbox": "24x24",
  "integrations.google-signin": "24x24",
  "integrations.google-drive_16": "16x16",
  "integrations.dropbox_16": "16x16",
  "integrations.google-signin_16": "16x16"
};

var legacyNames = {
  plus: "action.add",
  "checkbox-checked": "action.checkbox-checked",
  "checkbox-unchecked": "action.checkbox-unchecked",
  clear: "action.clear",
  close: "action.close",
  clipboard: "action.copy",
  download: "action.download",
  editable: "action.edit",
  "badge-icon": "action.expand",
  "external-link": "action.external-link",
  link: "action.link",
  logout: "action.logout",
  maximize: "action.maximize",
  minimize: "action.minimize",
  "play-video": "action.play",
  "radio-unchecked": "action.radio-deselected",
  "radio-checked": "action.radio-selected",
  "action.table-sort-default": "action.expand",
  "table-sort-default": "action.expand",
  "table-sort-ascending": "action.table-sort-ascending",
  "table-sort-descending": "action.table-sort-descending",
  "icon-reorder": "action.reorder",
  trash: "action.trash",
  code: "content.code",
  color: "content.color",
  "text-file": "content.file-document",
  "graphic-file": "content.file-graphic",
  "icon-file": "content.file",
  "icon-font": "content.font",
  "icon-guide": "content.guide",
  "icon-heading": "content.heading",
  "big-kit": "content.kit",
  kit: "content.kit",
  "icon-text": "content.note",
  "icon-support-image": "content.supporting-image",
  version: "content.version",
  "empty-section": "empty-state.assets",
  building: "info.building",
  "checkmark-circle": "info.check-circle",
  checkmark: "info.checkmark",
  info: "info.info",
  error: "info.error",
  warning: "info.warning",
  "warning-filled": "info.warning",
  "globe-lock": "info.globe-lock",
  globe: "info.globe",
  lock: "info.lock-closed",
  "lock-fill": "info.lock-open",
  "lock-open": "info.lock-open",
  spinner: "info.spinner",
  "star-filled": "info.star-filled",
  star: "info.star",
  logo: "logo.full",
  brandmark: "logo.mark",
  "store-logo": "logo.store",
  "icon-asset-library": "marketing.asset-library",
  "icon-design-system": "marketing.design-system",
  "icon-distribution": "marketing.distribution",
  "icon-enterprise-security": "marketing.security",
  "icon-storage": "marketing.storage",
  "icon-style-guide": "marketing.style-guide",
  "icon-enterprise-support": "marketing.support",
  "icon-enterprise-terms": "marketing.terms",
  "icon-curation": "content.guide",
  "icon-usage": "marketing.usage",
  "triangle-collapsed": "navigation.chevron-right",
  "triangle-expanded": "navigation.chevron-down",
  "triangle-double": "action.expand",
  "triangle-double-small": "action.expand_16",
  "arrow-down": "navigation.chevron-down",
  "arrow-left": "navigation.chevron-left",
  "arrow-right": "navigation.chevron-right",
  "triangle-left": "navigation.chevron-left",
  "triangle-right": "navigation.chevron-right",
  "arrow-right-full": "navigation.chevron-right",
  billing: "navigation.credit-card",
  overview: "navigation.kit-menu",
  "layout-detailed": "navigation.layout-detailed",
  "layout-simple": "navigation.layout-simple",
  mail: "navigation.mail",
  menu: "navigation.menu",
  overflow: "navigation.overflow",
  eye: "navigation.privacy",
  search: "navigation.search",
  settings: "navigation.settings",
  users: "navigation.user-group",
  user: "navigation.user",
  profile: "navigation.user",
  facebook: "social.facebook",
  twitter: "social.twitter"
};

var coverStyle = css(["position:absolute;top:50%;left:50%;transform:translateY(-50%) translateX(-50%);max-height:100%;max-width:100%;"]);
var IconSvg = styled.svg.withConfig({
  displayName: "Icon__IconSvg"
})(["cursor:", ";fill:", ";", ";", ";user-select:none;", " ", " flex-shrink:0;"], function (props) {
  return getCursorStyle(props);
}, function (props) {
  return getColor(props.disabled ? "grayDark" : props.fill);
}, function (props) {
  return getSizeStyle(props);
}, function (props) {
  return props.coverParent ? coverStyle : null;
}, positioningCSS, flexCSS);
var getSizeStyle = function getSizeStyle(_ref) {
  var iconId = _ref.iconId,
    size = _ref.size,
    width = _ref.width,
    height = _ref.height;
  var w = width || size,
    h = height || size;

  // Adjust one dimension (x) based on the alternate dimension (y)
  // pX: the provided dimension to adjust
  // x: the actual dimension of the icon
  // pY: the provided alternate dimension
  // y: the actual alternate dimension
  function adjustDimension(pX, x, pY, y) {
    if (pX) return pX;
    return pY ? Math.round(x * (pY / y)) : x;
  }
  if (!w || !h) {
    var dims = iconIndex[iconId];
    if (dims) {
      var _dims$split$map = dims.split("x").map(Number),
        _dims$split$map2 = _slicedToArray(_dims$split$map, 2),
        actualWidth = _dims$split$map2[0],
        actualHeight = _dims$split$map2[1];
      w = adjustDimension(w, actualWidth, h, actualHeight);
      h = adjustDimension(h, actualHeight, w, actualWidth);
    } else {
      console.warn("Icon id ".concat(iconId, " not found"));
    }
  }
  return {
    width: cssVal(w),
    height: cssVal(h)
  };
};
var getCursorStyle = function getCursorStyle(_ref2) {
  var onClick = _ref2.onClick,
    disabled = _ref2.disabled;
  if (disabled) return "not-allowed";
  if (onClick) return "pointer";
  return null;
};
function resolveIconId(id, _ref3) {
  var size = _ref3.size,
    width = _ref3.width;
  if (cssVal(size || width) === "16px") {
    var smallId = "".concat(id, "_16");
    return iconIndex[smallId] ? smallId : id;
  }
  return id;
}
function getViewBox(iconId) {
  var dims = iconIndex[iconId];
  if (dims) {
    var _dims$split$map3 = dims.split("x").map(Number),
      _dims$split$map4 = _slicedToArray(_dims$split$map3, 2),
      w = _dims$split$map4[0],
      h = _dims$split$map4[1];
    return [0, 0, w, h].join(" ");
  }
  console.warn("Unexpected icon ID ".concat(iconId, ". This id does not exist."));
  return "0 0 24 24";
}
var Icon = function Icon(props) {
  var id = props.id,
    iconId = props.iconId,
    title = props.title,
    onClick = props.onClick,
    disabled = props.disabled;
  var _iconId = legacyNames[iconId] || iconId;
  var resolvedId = resolveIconId(_iconId, props);
  var viewBox = props.viewBox || getViewBox(resolvedId);
  return /*#__PURE__*/React.createElement(IconSvg, _extends({
    "data-testid": id
  }, props, {
    iconId: resolvedId,
    viewBox: viewBox,
    onClick: disabled ? null : onClick,
    role: "img"
  }), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(resolvedId)
  }));
};
Icon.defaultProps = {
  style: {},
  disabled: false,
  coverParent: false
};
var Icon$1 = Icon;

function isBrowser() {
  return typeof window !== "undefined";
}

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var LinkWrapper = function LinkWrapper(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? undefined : _ref$link,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? undefined : _ref$title,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? undefined : _ref$target,
    children = _ref.children,
    style = _ref.style;
  // line height stops the a tag from doing weird things
  var linkProps = {
    target: undefined,
    rel: undefined,
    disabled: disabled,
    title: title,
    style: _objectSpread$g({
      lineHeight: 0,
      textDecoration: "none"
    }, style)
  };
  function isSameHost() {
    if (isBrowser()) {
      var _window, _window$location;
      return link.includes((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.host);
    }
    return false;
  }
  function isLingoHost() {
    return link.includes(".lingoapp.com");
  }
  function isSpecialScheme() {
    var specialSchemes = ["mailto:", "tel:", "sms:"];
    return specialSchemes.some(function (s) {
      return link.startsWith(s);
    });
  }
  var role = "externalLink",
    url = link;
  if (!link) {
    role = "action";
  } else if (isSpecialScheme() || target) {
    role = "externalLink";
    linkProps.target = target || "_blank";
    linkProps.rel = "nofollow noopener noreferrer";
  } else if ((isSameHost() || link.startsWith("/")) && link.includes("#")) {
    if (isSameHost()) {
      // Removes host from url (Workaround for internal markdown links passed into HashLink)
      //eslint-disable-next-line no-useless-escape
      url = url.replace(/^.*\/\/[^\/]+/, "");
    }
    role = "internalHashLink";
  } else if (link.startsWith("/") || link.startsWith("#")) {
    role = "internalLink";
  } else if (isSameHost()) {
    role = "internalLink";
    var idx = link.indexOf(window.location.host) + window.location.host.length;
    url = link.substring(idx);
  } else {
    role = "externalLink";
    if (!isLingoHost()) {
      // Open non-lingo links in a new window
      linkProps.target = "_blank";
      linkProps.rel = "nofollow noopener noreferrer";
    }
    if (!link.includes("//")) {
      url = "//".concat(link);
    }
  }
  switch (role) {
    case "externalLink":
      return /*#__PURE__*/React.createElement("a", _extends({}, linkProps, {
        href: url
      }), children);
    case "internalLink":
      return /*#__PURE__*/React.createElement(Link, _extends({}, linkProps, {
        to: url
      }), children);
    case "internalHashLink":
      return /*#__PURE__*/React.createElement(HashLink, _extends({}, linkProps, {
        to: url
      }), children);
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
};
var LinkWrapper$1 = LinkWrapper;

var _excluded$q = ["id", "innerRef", "type", "text", "icon", "iconBefore", "onClick", "onDoubleClick", "buttonStyle", "link", "title", "newWindow", "truncate", "size", "themeOverrides"];
var _buttonHeights;
function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ButtonStyle;
(function (ButtonStyle) {
  ButtonStyle["primary"] = "primary";
  ButtonStyle["secondary"] = "secondary";
  ButtonStyle["tertiary"] = "tertiary";
  ButtonStyle["outline"] = "outline";
})(ButtonStyle || (ButtonStyle = {}));
var ButtonSize;
(function (ButtonSize) {
  ButtonSize["small"] = "small";
  ButtonSize["regular"] = "regular";
})(ButtonSize || (ButtonSize = {}));
var buttonHeights$1 = (_buttonHeights = {}, _defineProperty(_buttonHeights, ButtonSize.regular, "36px"), _defineProperty(_buttonHeights, ButtonSize.small, "28px"), _buttonHeights);
function getTintColor(props) {
  var _props$themeOverrides;
  var hover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var color = getColor(props.tintColor);
  if (color) return color;
  var theme = _objectSpread$f(_objectSpread$f({}, props.theme), props.themeOverrides);
  switch (props.buttonStyle) {
    case "primary":
      return hover ? null : getColor(theme.primaryColorTint, "white");
    case "secondary":
      return hover ? null : getColor("black");
    case "tertiary":
      return hover ? getColor(theme.primaryColorDark, "primaryDark") : getColor(theme.primaryColor, "primary");
    case "outline":
      if (hover) return getColor("black");
      return getColor(((_props$themeOverrides = props.themeOverrides) === null || _props$themeOverrides === void 0 ? void 0 : _props$themeOverrides.outlineStyle) === "dark" ? "white" : "black");
    default:
      return getColor("black");
  }
}
function getBackgroundColor(props, hover) {
  var color = getColor(props.background);
  if (color) return color;
  var theme = _objectSpread$f(_objectSpread$f({}, props.theme), props.themeOverrides);
  switch (props.buttonStyle) {
    case "primary":
      return hover ? getColor(theme.primaryColorDark, "primaryDark") : getColor(theme.primaryColor, "primary");
    case "secondary":
      return hover ? getColor("gray") : getColor("grayLight");
    case "outline":
      return hover ? getColor("grayLighter") : "transparent";
    case "tertiary":
    default:
      return null;
  }
}
var ButtonBase = styled.button.withConfig({
  displayName: "Button__ButtonBase"
})(["background:", ";color:", ";border:none;border-radius:", ";", ";cursor:pointer;pointer-events:", ";transition:background ", ",opacity ", ",color ", ",text-decoration ", ",box-shadow ", ";opacity:", ";height:", ";user-select:none;box-shadow:none;span{font-family:", ";}div,svg,span{pointer-events:none;}svg{fill:", ";transition:fill ", ";}&:hover{background:", ";color:", ";svg{fill:", ";}}"], function (props) {
  return getBackgroundColor(props, false);
}, function (props) {
  return getTintColor(props);
}, function (props) {
  var _props$theme;
  return getBorderRadius(props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default");
}, function (props) {
  return getFont(props.fontStyle, props.size === "small" ? "ui.smallBold" : "ui.regularSemiBold");
}, function (props) {
  return props.disabled ? "none" : null;
}, transition, transition, transition, transition, transition, function (props) {
  return props.disabled ? ".5" : "1";
}, function (props) {
  return buttonHeights$1[props.size];
}, function (props) {
  return getCustomFontFamily(props);
}, function (props) {
  return getTintColor(props, false);
}, transition, function (props) {
  return getBackgroundColor(props, true);
}, function (props) {
  return getTintColor(props, true);
}, function (props) {
  return getTintColor(props, true);
});
var Wrapped = styled(ButtonBase).attrs(_objectSpread$f({}, ellipsis)).withConfig({
  displayName: "Button__Wrapped"
})(["width:", ";", " ", " ", ""], function (props) {
  if (props.fullWidth) return "100%";
  if (props.iconOnly) return buttonHeights$1[props.size];
}, function (props) {
  return props.iconOnly ? null : positioningCSS({
    px: props.size === "small" ? "m" : "l",
    py: "xs"
  });
}, positioningCSS, flexCSS);
var Outline = styled(ButtonBase).attrs(_objectSpread$f({}, ellipsis)).withConfig({
  displayName: "Button__Outline"
})(["background:", ";border:1px solid ", ";width:", ";", " ", " ", " &:hover{background:", ";}"], function (props) {
  return getBackgroundColor(props, false);
}, function (props) {
  var _props$themeOverrides2;
  if ((_props$themeOverrides2 = props.themeOverrides) !== null && _props$themeOverrides2 !== void 0 && _props$themeOverrides2.outlineStyle) {
    var _props$themeOverrides3;
    return getColor(((_props$themeOverrides3 = props.themeOverrides) === null || _props$themeOverrides3 === void 0 ? void 0 : _props$themeOverrides3.outlineStyle) === "dark" ? "white" : "black");
  }
  return getColor("black");
}, function (props) {
  if (props.fullWidth) return "100%";
  if (props.iconOnly) return buttonHeights$1[props.size];
}, function (props) {
  return props.iconOnly ? null : positioningCSS({
    px: "m",
    py: "xs"
  });
}, positioningCSS, flexCSS, function (props) {
  return getBackgroundColor(props, true);
});
var Tertiary = styled(ButtonBase).withConfig({
  displayName: "Button__Tertiary"
})(["", " background:none;padding:0;height:auto;min-width:0;", ";", " ", " &:hover{text-decoration:underline;}"], ellipsis, function (props) {
  return getFont(props.fontStyle, props.size === "small" ? "ui.small" : "ui.regular");
}, positioningCSS, flexCSS);
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    innerRef = props.innerRef,
    type = props.type,
    text = props.text,
    icon = props.icon,
    iconBefore = props.iconBefore,
    onClick = props.onClick,
    onDoubleClick = props.onDoubleClick,
    buttonStyle = props.buttonStyle,
    link = props.link,
    title = props.title,
    newWindow = props.newWindow,
    truncate = props.truncate,
    size = props.size,
    themeOverrides = props.themeOverrides,
    style = _objectWithoutProperties(props, _excluded$q);
  var iconOnly = !(text && text.length) && icon,
    linkProps = {
      disabled: props.disabled,
      link: link,
      target: newWindow ? "_blank" : undefined,
      // allow setting overflow hidden for tertiary buttons to truncate buttons
      style: _objectSpread$f({
        flexShrink: style.flexShrink
      }, buttonStyle === "tertiary" && truncate ? {
        overflow: "hidden"
      } : {})
    };
  function renderContent() {
    if (!icon && !iconBefore) return /*#__PURE__*/React.createElement("span", null, text);
    var truncateCss = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
    return /*#__PURE__*/React.createElement(Flex$1, {
      justifyContent: "center",
      alignItems: "center"
    }, iconBefore && /*#__PURE__*/React.createElement(Icon$1, {
      size: size === "small" ? "16" : "24",
      mr: "xs",
      iconId: iconBefore
    }), text && /*#__PURE__*/React.createElement("span", {
      style: truncate && truncateCss
    }, text), icon && /*#__PURE__*/React.createElement(Icon$1, {
      size: size === "small" ? "16" : "24",
      ml: text ? "xs" : null,
      iconId: icon
    }));
  }
  function renderInner() {
    var buttonProps = _objectSpread$f(_objectSpread$f({}, style), {}, {
      ref: ref || innerRef,
      buttonStyle: buttonStyle,
      type: type,
      title: title,
      iconOnly: iconOnly,
      size: size,
      onClick: onClick,
      disabled: props.disabled,
      onDoubleClick: onDoubleClick,
      truncate: truncate,
      themeOverrides: themeOverrides
    });
    switch (buttonStyle) {
      case "tertiary":
        return /*#__PURE__*/React.createElement(Tertiary, _extends({
          "data-testid": id
        }, buttonProps), renderContent());
      case "outline":
        return /*#__PURE__*/React.createElement(Outline, _extends({
          "data-testid": id
        }, buttonProps), renderContent());
      default:
        return /*#__PURE__*/React.createElement(Wrapped, _extends({
          "data-testid": id
        }, buttonProps), renderContent());
    }
  }
  return /*#__PURE__*/React.createElement(LinkWrapper$1, linkProps, renderInner());
});
Button.defaultProps = {
  buttonStyle: ButtonStyle.primary,
  type: "button",
  size: ButtonSize.regular,
  themeOverrides: {}
};
Button.displayName = "Button";
var Button$1 = Button;

var _typeDisplayNames;
var AssetType = /*#__PURE__*/function () {
  function AssetType() {
    _classCallCheck(this, AssetType);
  }
  _createClass(AssetType, null, [{
    key: "displayName",
    value:
    // Motion

    // Audio

    // Generic

    function displayName(type) {
      return typeDisplayNames[type] || (type || "").replace("_", " ").toLowerCase();
    }
  }]);
  return AssetType;
}();
_defineProperty(AssetType, "png", "PNG");
_defineProperty(AssetType, "jpg", "JPG");
_defineProperty(AssetType, "gif", "GIF");
_defineProperty(AssetType, "svg", "SVG");
_defineProperty(AssetType, "pdf", "PDF");
_defineProperty(AssetType, "eps", "EPS");
_defineProperty(AssetType, "tiff", "TIFF");
_defineProperty(AssetType, "color", "COLOR");
_defineProperty(AssetType, "textStyle", "TEXT_STYLE");
_defineProperty(AssetType, "sketchLayer", "SKETCH_LAYER");
_defineProperty(AssetType, "sketchSymbol", "SKETCH_SYMBOL");
_defineProperty(AssetType, "sketchLayerStyle", "SKETCH_LAYER_STYLE");
_defineProperty(AssetType, "sketchTextStyle", "SKETCH_TEXT_STYLE");
_defineProperty(AssetType, "mov", "MOV");
_defineProperty(AssetType, "mp4", "MP4");
_defineProperty(AssetType, "lottie", "LOTTIE");
_defineProperty(AssetType, "wav", "WAV");
_defineProperty(AssetType, "flac", "FLAC");
_defineProperty(AssetType, "m4a", "M4A");
_defineProperty(AssetType, "mp3", "MP3");
_defineProperty(AssetType, "ogg", "OGG");
_defineProperty(AssetType, "ai", "AI");
_defineProperty(AssetType, "txt", "TXT");
_defineProperty(AssetType, "docx", "DOCX");
_defineProperty(AssetType, "dotx", "DOTX");
_defineProperty(AssetType, "indd", "INDD");
_defineProperty(AssetType, "keynoteTheme", "KEYNOTE_THEME");
_defineProperty(AssetType, "keynote", "KEYNOTE");
_defineProperty(AssetType, "pagesTemplate", "PAGES_TEMPLATE");
_defineProperty(AssetType, "pages", "PAGES");
_defineProperty(AssetType, "potx", "POTX");
_defineProperty(AssetType, "pptx", "PPTX");
_defineProperty(AssetType, "psd", "PSD");
_defineProperty(AssetType, "zip", "ZIP");
_defineProperty(AssetType, "genericTypes", new Set([AssetType.ai, AssetType.txt, AssetType.docx, AssetType.dotx, AssetType.indd, AssetType.keynoteTheme, AssetType.keynote, AssetType.pagesTemplate, AssetType.pages, AssetType.potx, AssetType.pptx, AssetType.psd, AssetType.zip]));
_defineProperty(AssetType, "textTypes", new Set([AssetType.txt, AssetType.docx, AssetType.dotx, AssetType.pagesTemplate, AssetType.pages, AssetType.zip]));
_defineProperty(AssetType, "graphicTypes", new Set([AssetType.ai, AssetType.indd, AssetType.keynoteTheme, AssetType.keynote, AssetType.potx, AssetType.pptx, AssetType.psd]));
_defineProperty(AssetType, "sketchTypes", new Set([AssetType.sketchLayerStyle, AssetType.sketchLayer, AssetType.sketchSymbol, AssetType.sketchTextStyle]));
_defineProperty(AssetType, "videoTypes", new Set([AssetType.mov, AssetType.mp4]));
_defineProperty(AssetType, "motionTypes", new Set([].concat(_toConsumableArray(AssetType.videoTypes), [AssetType.lottie, AssetType.gif])));
_defineProperty(AssetType, "audioTypes", new Set([AssetType.wav, AssetType.flac, AssetType.m4a, AssetType.mp3, AssetType.ogg]));
var typeDisplayNames = (_typeDisplayNames = {}, _defineProperty(_typeDisplayNames, AssetType.ai, "Illustrator"), _defineProperty(_typeDisplayNames, AssetType.color, "Color"), _defineProperty(_typeDisplayNames, AssetType.docx, "Word"), _defineProperty(_typeDisplayNames, AssetType.dotx, "Word template"), _defineProperty(_typeDisplayNames, AssetType.eps, "EPS"), _defineProperty(_typeDisplayNames, AssetType.flac, "FLAC"), _defineProperty(_typeDisplayNames, AssetType.gif, "GIF"), _defineProperty(_typeDisplayNames, AssetType.indd, "InDesign"), _defineProperty(_typeDisplayNames, AssetType.jpg, "JPG"), _defineProperty(_typeDisplayNames, AssetType.keynoteTheme, "Keynote theme"), _defineProperty(_typeDisplayNames, AssetType.keynote, "Keynote"), _defineProperty(_typeDisplayNames, AssetType.lottie, "Lottie"), _defineProperty(_typeDisplayNames, AssetType.mov, "MOV"), _defineProperty(_typeDisplayNames, AssetType.mp3, "MP3"), _defineProperty(_typeDisplayNames, AssetType.mp4, "MP4"), _defineProperty(_typeDisplayNames, AssetType.m4a, "M4A"), _defineProperty(_typeDisplayNames, AssetType.ogg, "OGG"), _defineProperty(_typeDisplayNames, AssetType.pagesTemplate, "Pages template"), _defineProperty(_typeDisplayNames, AssetType.pages, "Pages"), _defineProperty(_typeDisplayNames, AssetType.pdf, "PDF"), _defineProperty(_typeDisplayNames, AssetType.png, "PNG"), _defineProperty(_typeDisplayNames, AssetType.potx, "PowerPoint template"), _defineProperty(_typeDisplayNames, AssetType.pptx, "PowerPoint"), _defineProperty(_typeDisplayNames, AssetType.psd, "Photoshop"), _defineProperty(_typeDisplayNames, AssetType.sketchLayerStyle, "Sketch layer style"), _defineProperty(_typeDisplayNames, AssetType.sketchLayer, "Sketch layer"), _defineProperty(_typeDisplayNames, AssetType.sketchSymbol, "Sketch symbol"), _defineProperty(_typeDisplayNames, AssetType.sketchTextStyle, "Sketch text style"), _defineProperty(_typeDisplayNames, AssetType.svg, "SVG"), _defineProperty(_typeDisplayNames, AssetType.txt, "Text File"), _defineProperty(_typeDisplayNames, AssetType.textStyle, "Font"), _defineProperty(_typeDisplayNames, AssetType.tiff, "TIFF"), _defineProperty(_typeDisplayNames, AssetType.wav, "WAV"), _defineProperty(_typeDisplayNames, AssetType.zip, "ZIP"), _typeDisplayNames);
var ItemType;
(function (ItemType) {
  ItemType["asset"] = "asset";
  ItemType["heading"] = "heading";
  ItemType["note"] = "inline_note";
  ItemType["supportingImage"] = "supporting_image";
  ItemType["codeSnippet"] = "code_snippet";
  ItemType["guide"] = "guide";
})(ItemType || (ItemType = {}));
var PrivacyLevel;
(function (PrivacyLevel) {
  PrivacyLevel["private"] = "private";
  PrivacyLevel["password"] = "password";
  PrivacyLevel["public"] = "public";
})(PrivacyLevel || (PrivacyLevel = {}));

/**
 * Create a slug compatible id for an object with the name and shortID
 *
 * @param {String} name The name of the object
 * @param {String} shortId The short ID for the object
 */
function slugifyName(name, shortId) {
  var a = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  var b = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  var p = new RegExp(a.split("").join("|"), "g");
  var slugName = (name || "").replace(/\s+/g, "-") // Replace spaces with -
  .replace(p, function (c) {
    return b.charAt(a.indexOf(c));
  }) // Replace special characters
  .replace(/&/g, "-and-") // Replace & with 'and'
  // eslint-disable-next-line no-useless-escape
  .replace(/[^\w\-]+/g, "") // Remove all non-word characters
  // eslint-disable-next-line no-useless-escape
  .replace(/\-\-+/g, "-") // Replace multiple - with single -
  .replace(/^-+/, "") // Trim - from start of text
  .replace(/-+$/, ""); // Trim - from end of text

  return [slugName, shortId].filter(function (comp) {
    return comp && comp.length > 0;
  }).join("-");
}

/**
 * Helper for pulling a space-identifying domain from the URL.
 */

function getCustomDomainComponents() {
  return parseHostname(window.location.hostname);
}

var apiDomains = {
  "test-runner": "http://local.lingoapp.com",
  development: "http://local.lingoapp.com:9000",
  test: "https://api-test.lingoapp.com",
  staging: "https://api-staging.lingoapp.com",
  production: "https://api.lingoapp.com"
};
var wwwDomains = {
  "test-runner": {
    protocol: "http",
    subdomain: "local",
    port: "8080"
  },
  development: {
    protocol: "http",
    subdomain: "local",
    port: "8080"
  },
  test: {
    protocol: "https",
    subdomain: "www-test",
    port: ""
  },
  staging: {
    protocol: "https",
    subdomain: "www-staging",
    port: ""
  },
  production: {
    protocol: "https",
    subdomain: "www",
    port: ""
  }
};
var getWWWDomainComponents = function getWWWDomainComponents() {
  var env = _lingoConfig.environment;
  var domain = wwwDomains[env];
  if (domain) return domain;
  throw new Error("Environment not found in config.");
};
var getApiDomain = function getApiDomain() {
  var _getCustomDomainCompo = getCustomDomainComponents(),
    host = _getCustomDomainCompo.host;
  if (host) {
    // Local with custom domain
    if (_lingoConfig.environment === Environment.development) {
      return "http://local.".concat(host, ":9000");
    }
    return "https://lingo-api.".concat(host);
  }
  var env = _lingoConfig.environment;
  var domain = apiDomains[env];
  if (domain) return "".concat(domain);
  throw new Error("Environment not found in config.");
};
var getApiServiceURL = function getApiServiceURL(endpoint) {
  var path = endpoint || "";
  if (path[0] === "/") path = path.substring(1);
  return "".concat(getApiDomain(), "/v4/").concat(path);
};

function urlNeedsReload(url) {
  if (url.startsWith("/")) {
    return false;
  }
  try {
    var _URL = new URL(url),
      target = _URL.hostname;
    var current = window.location.hostname;
    return target !== current;
  } catch (e) {
    return false;
  }
}

/**
 * Builds an appropriate URL based on the path and context passed in
 *
 * @param {String} path The desired path, minus any consideration of space id or store
 * @param {Object} context An optional object to describe the space the url is for.
 *   If null, a base url is returned (i.e. a url outside the context of the store or a space)
 *
 * Example context
 * ```
 * {
 *   space: { id, subdomain }
 * }
 * ```
 */
function buildURL() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    space = _ref.space;
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var _ref2 = space || {},
    spaceId = _ref2.id,
    subdomain = _ref2.subdomain,
    domain = _ref2.domain,
    origin = getOrigin(domain, subdomain),
    fullPath = constructPath(path, spaceId, Boolean(subdomain || domain), query, hash);
  return "".concat(origin).concat(fullPath);
}

/**
 * Builds an appropriate path based on the context passed in and hopeful that
 * the current subdomain matches the required one
 *
 * @param {String} path The desired path, minus any consideration of space id
 * @param {Object} context An optional object to describe the space context the url is for.
 *   If null, a base url is returned (i.e. a url outside the context of a space)
 *
 * Example context
 * ```
 * {
 *   space: { id, subdomain }
 * }
 * ```
 */
function buildPath() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    space = _ref3.space;
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var _ref4 = space || {},
    spaceId = _ref4.id,
    subdomain = _ref4.subdomain,
    _getCustomDomainCompo = getCustomDomainComponents(),
    currentSubdomain = _getCustomDomainCompo.subdomain,
    identifier = _getCustomDomainCompo.identifier;
  if (_lingoConfig.environment !== "production" && currentSubdomain && subdomain !== undefined &&
  // Undefined subdomain will mean it was not convenient to supply it but can be assumed unimportant
  currentSubdomain !== subdomain) {
    console.error("Cannot reach this space with only a path change!");
  }
  return constructPath(path, spaceId, Boolean(identifier), query, hash);
}

/**
 * Attaches the appropriate prefix to the passed in path, based on the other context variables passed
 *
 * @param {String} path The desired path, minus any consideration of space id or store
 * @param {Number} spaceId The target space's id, if any
 * @param {Boolean} hasSubdomain Whether we are targeting a URL with a subdomain
 * @param {Object} query Search parameters in object notation
 * @param {String} hash URL hash
 *
 */
function constructPath(path, spaceId, hasSubdomain, query, hash) {
  // eslint-disable-next-line no-nested-ternary
  var spacePrefix = hasSubdomain || !spaceId ? "" : "/".concat(spaceId),
    normalizedPath = "/".concat(path || "").replace("//", "/"),
    qs = QueryString.stringify(query),
    h = hash ? "#".concat(hash) : "";
  return ["".concat(spacePrefix).concat(normalizedPath), qs].filter(Boolean).join("?").concat(h);
}

/**
 * Get the base url from the current window location and the subdomain passed in
 *
 * @param {String} [subdomain] A subdomain to use when building the host. Defaults to the standard lingo subdomain for the current environment.
 *
 */
function getOrigin(domain, subdomain) {
  var subdomainOrBase = subdomain || getBaseSubdomain(),
    host = domain || "lingoapp.com",
    _window$location = window.location,
    port = _window$location.port,
    protocol = _window$location.protocol,
    subdomainPlusPeriod = subdomainOrBase ? "".concat(subdomainOrBase, ".") : "",
    portPlusColon = port ? ":".concat(port) : "";
  return "".concat(protocol, "//").concat(subdomainPlusPeriod).concat(host).concat(portPlusColon);
}
function getBaseSubdomain() {
  return getWWWDomainComponents().subdomain;
}

var _excluded$p = ["users"],
  _excluded2$2 = ["user", "spaces"],
  _excluded3 = ["spaces"],
  _excluded4 = ["members"],
  _excluded5 = ["result"],
  _excluded6 = ["members"],
  _excluded7 = ["members"],
  _excluded8 = ["result"],
  _excluded9 = ["invitations"],
  _excluded10 = ["result"],
  _excluded11 = ["invitations"],
  _excluded12 = ["sections"],
  _excluded13 = ["result"],
  _excluded14 = ["views"],
  _excluded15 = ["result"],
  _excluded16 = ["fields"],
  _excluded17 = ["result"],
  _excluded18 = ["items"],
  _excluded19 = ["result"],
  _excluded20 = ["backgroundColor", "content"],
  _excluded21 = ["assets"],
  _excluded22 = ["result"],
  _excluded23 = ["font", "textStyle", "filecuts", "assetProcessing"];
function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function camelCaseKeys(object) {
  var snakeToCamel = function snakeToCamel(str) {
    return str.replace(/([-_][a-z0-9])/g, function (group) {
      return group.toUpperCase().replace("-", "").replace("_", "");
    });
  };
  return Object.keys(object).reduce(function (acc, key) {
    acc[snakeToCamel(key)] = object[key];
    return acc;
  }, {});
}

/**
 *
 * @param {*} dataList
 * @returns Returns  true if the provided list is in the format:
 * ```
 * [{
 *  success: true|false,
 *  result?: {}?,
 *  error?: {}
 * }]
 * ```
 * This is a common format for batch update API calls
 */
function isResultList(dataList) {
  if (!(dataList !== null && dataList !== void 0 && dataList.length)) return false;
  var first = dataList[0];
  return typeof first.success === "boolean" && (first.result || first.error);
}

// MARK : User
/*-------------------------------------------------------------------------------*/
var user = function user(json, userSchema) {
  if (json.users) {
    var users = json.users,
      _rest = _objectWithoutProperties(json, _excluded$p);
    return normalize$1(_objectSpread$e({
      users: users.map(formatUser)
    }, _rest), {
      users: [userSchema]
    });
  }
  var userData = json.user,
    spaceData = json.spaces,
    rest = _objectWithoutProperties(json, _excluded2$2);
  var u = formatUser(userData);
  var spaces = (spaceData || []).map(formatSpace);
  return normalize$1(_objectSpread$e({
    user: _objectSpread$e(_objectSpread$e({}, u), {}, {
      spaces: spaces
    })
  }, rest), {
    user: userSchema
  });
};
function formatUser(data) {
  return camelCaseKeys(data);
}

// MARK : Space
/*-------------------------------------------------------------------------------*/

var space = function space(json, spaceSchema) {
  if (json.spaces) {
    var spaces = json.spaces,
      rest = _objectWithoutProperties(json, _excluded3);
    return normalize$1(_objectSpread$e({
      spaces: spaces.map(formatSpace)
    }, rest), {
      spaces: [spaceSchema]
    });
  }
  var _space = formatSpace(json.space);
  return normalize$1(_space, spaceSchema);
};
function formatSpace(data) {
  var res = camelCaseKeys(data);
  res.avatar = data.avatars.avatar || data.avatars.default_avatar;
  res.joinSettings = data.join_settings && formatSpaceJoinSettings(data.join_settings);
  res.access = data.access && formatSpaceMember(data.access);
  res.kits = (data.kits || []).map(formatKit);
  res.kitCollections = (data.kit_collections || []).map(formatKitCollection);
  res.theme = formatTheme(data.theme);
  res.account = formatSpaceAccount(data);
  delete res.charges;
  delete res.card;
  delete res.balance;
  res.ssoOrganization = data.sso_organization && formatSsoOrganization(data.sso_organization);
  res.subscription = data.subscription && formatSubscription(data.subscription);
  return res;
}
function formatSpaceJoinSettings(data) {
  // join_with, allowed_domains, token
  return camelCaseKeys(data);
}
function spacePreview(json, previewSchema) {
  return normalize$1(formatSpacePreview(json.preview), previewSchema);
}
function formatSpacePreview(data) {
  function formatPreviewMember(m) {
    return {
      id: m.id,
      name: m.name,
      email: m.email,
      avatar: m.avatar,
      role: m.role
    };
  }
  return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(data)), {}, {
    theme: formatTheme(data.theme),
    members: data.members && data.members.map(formatPreviewMember)
  });
}
function formatSsoOrganization(data) {
  return camelCaseKeys(data);
}
function formatTheme(data) {
  if (!data) return data;
  return _objectSpread$e({
    // default
    headerBackgroundColor: "#FAFAFA"
  }, camelCaseKeys(data));
}
function formatSubscription(data) {
  var res = camelCaseKeys(data);
  res["customer"] = res.customer ? camelCaseKeys(res.customer) : {};
  return res;
}
function formatSpaceAccount(data) {
  return {
    balance: data.balance,
    card: data.card && formatCard(data.card),
    charges: data.charges && data.charges.map(formatCharge)
  };
}
function formatCard(data) {
  return camelCaseKeys(data);
}
var charge = function charge(json, chargeSchema) {
  return json.charges ? normalize$1({
    charges: json.charges.map(formatCharge)
  }, {
    charges: [chargeSchema]
  }) : normalize$1(formatCharge(json.charge), chargeSchema);
};
function formatCharge(data) {
  return camelCaseKeys(data);
}

// MARK : Space Member
/*-------------------------------------------------------------------------------*/

var spaceMember = function spaceMember(json, memberSchema) {
  if (isResultList(json.members)) {
    var members = json.members,
      rest = _objectWithoutProperties(json, _excluded4);
    var results = members.map(function (_ref) {
      var result = _ref.result,
        other = _objectWithoutProperties(_ref, _excluded5);
      return _objectSpread$e({
        member: formatSpaceMember(result === null || result === void 0 ? void 0 : result.member)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      members: results
    }, rest), {
      members: [{
        member: memberSchema
      }]
    });
  }
  if (json.members) {
    var _members = json.members,
      _rest2 = _objectWithoutProperties(json, _excluded6);
    return normalize$1(_objectSpread$e({
      members: _members.map(formatSpaceMember)
    }, _rest2), {
      members: [memberSchema]
    });
  }
  var res = formatSpaceMember(json.member);
  return normalize$1(res, memberSchema);
};
function formatSpaceMember(data) {
  if (!data) return data;
  var kits = data.kits && data.kits.map(formatKit),
    kitCount = data.joined_kits || kits && kits.reduce(function (res, k) {
      return res + (k.access.status === "active" ? 1 : 0);
    }, 0),
    kitAccess = data.kit_access && data.kit_access.map(formatKitMember);
  return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(data)), {}, {
    id: data.id,
    role: data.role,
    counts: kits,
    status: data.status,
    kitAccess: kitAccess,
    userId: data.user_id,
    spaceId: data.space_id,
    joinedKits: kitCount,
    user: data.user ? formatUser(data.user) : undefined,
    notificationPrefs: data.notification_prefs ? camelCaseKeys(data.notification_prefs) : {},
    permissions: data.permissions || [],
    ssoEnabled: data.sso_enabled,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated
  });
}

// MARK : API Token
/*-------------------------------------------------------------------------------*/

var apiToken = function apiToken(json, tokenSchema) {
  return json.tokens ? normalize$1({
    apiTokens: json.tokens.map(formatApiToken)
  }, {
    apiTokens: new schema.Array(tokenSchema)
  }) : normalize$1(formatApiToken(json.token), tokenSchema);
};
function formatApiToken(data) {
  return camelCaseKeys(data);
}

// MARK : Kit Collection
/*-------------------------------------------------------------------------------*/
var kitCollection = function kitCollection(json, kitCollectionSchema) {
  return json.kit_collections ? normalize$1({
    kitCollections: json.kit_collections.map(formatKitCollection)
  }, {
    kitCollections: new schema.Array(kitCollectionSchema)
  }) : normalize$1(formatKitCollection(json.kit_collection), kitCollectionSchema);
};
function formatKitCollection(data) {
  var _data$items;
  return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(data)), {}, {
    url: "/c/".concat(slugifyName(data.name, data.short_id)),
    items: (data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(formatKitCollectionItem)) || []
  });
}

// MARK : Kit Collection Item
/*-------------------------------------------------------------------------------*/
var kitCollectionItem = function kitCollectionItem(json, kitCollectionItemSchema) {
  return json.items ? normalize$1({
    kitCollectionItems: json.items.map(formatKitCollectionItem)
  }, {
    kitCollectionItems: new schema.Array(kitCollectionItemSchema)
  }) : normalize$1(formatKitCollectionItem(json.items), kitCollectionItemSchema);
};
function formatKitCollectionItem(data) {
  var d = data.result || data;
  return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(d)), {}, {
    kit: formatKit(d.kit)
  });
}

// MARK : Kit
/*-------------------------------------------------------------------------------*/

var kit = function kit(json, kitSchema) {
  return json.kits ? normalize$1({
    kits: json.kits.map(formatKit)
  }, {
    kits: new schema.Array(kitSchema)
  }) : normalize$1(formatKit(json.kit), kitSchema);
};
function formatKit(data) {
  var access = data.access;
  var userVersion = access && access.use_version;
  var recommendedVersion = data.use_version;
  var urlQuery = data.token ? "?kit_token=".concat(data.token) : "",
    url = buildPath("/k/".concat(slugifyName(data.name, data.short_id)).concat(urlQuery), {
      space: {
        id: data.space_id
      }
    });
  return {
    kitId: data.kit_uuid,
    shortId: data.short_id,
    // TODO this is the url the sketch plugin uses
    url: url,
    name: data.name,
    description: data.description,
    status: data.status,
    portalAccess: data.portal_access,
    images: data.images,
    counts: data.counts || {},
    privacy: data.privacy,
    indexable: data.indexable,
    shareToken: data.token,
    recommendedVersion: recommendedVersion,
    userVersion: userVersion === null ? recommendedVersion : userVersion,
    access: data.access && formatKitMember(data.access) || {},
    // Relationships
    spaceId: data.space_id,
    space: data.space ? formatSpace(data.space) : null,
    versions: data.versions && data.versions.map(formatKitVersion),
    members: (data.members || []).map(formatKitMember),
    purchase: data.purchase ? camelCaseKeys(data.purchase) : null,
    publisher: data.publisher && camelCaseKeys(data.publisher)
  };
}

// MARK : Kit Member
/*-------------------------------------------------------------------------------*/

var kitMember = function kitMember(json, _ref2) {
  var kitMemberSchema = _ref2.kitMember,
    spaceMemberSchema = _ref2.spaceMember;
  if (isResultList(json.members)) {
    var members = json.members,
      rest = _objectWithoutProperties(json, _excluded7);
    var results = members.map(function (_ref3) {
      var result = _ref3.result,
        other = _objectWithoutProperties(_ref3, _excluded8);
      return _objectSpread$e({
        member: formatKitMember(result === null || result === void 0 ? void 0 : result.member)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      members: results
    }, rest), {
      members: [{
        member: kitMemberSchema
      }]
    });
  }
  if (json.members || json.unjoined_members) {
    var kitMembers = (json.members || []).map(formatKitMember),
      unjoinedMembers = (json.unjoined_members || []).map(formatSpaceMember);
    return normalize$1({
      kitMembers: kitMembers,
      unjoinedMembers: unjoinedMembers
    }, {
      kitMembers: [kitMemberSchema],
      unjoinedMembers: [spaceMemberSchema]
    });
  }
  return normalize$1(formatKitMember(json.member), kitMemberSchema);
};
function formatKitMember(data) {
  if (!data) return data;
  if (data.result) data = data.result.member;
  return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(data)), {}, {
    user: data.user ? formatUser(data.user) : null,
    permissions: data.permissions || [],
    isFavorite: Boolean(data.is_favorite),
    isPublic: Boolean(data.user_id) === false,
    kitId: data.kit_uuid,
    kit: data.kit && formatKit(data.kit)
  });
}

// MARK : Invitation
/*-------------------------------------------------------------------------------*/

var invitation = function invitation(json, invitationSchema) {
  if (isResultList(json.invitations)) {
    var invitations = json.invitations,
      rest = _objectWithoutProperties(json, _excluded9);
    var results = invitations.map(function (_ref4) {
      var result = _ref4.result,
        other = _objectWithoutProperties(_ref4, _excluded10);
      return _objectSpread$e({
        invitation: formatInvitation(result === null || result === void 0 ? void 0 : result.invitation)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      invitations: results
    }, rest), {
      invitations: [{
        invitation: invitationSchema
      }]
    });
  }
  if (json.invitations) {
    var _invitations = json.invitations,
      _rest3 = _objectWithoutProperties(json, _excluded11);
    return normalize$1(_objectSpread$e({
      invitations: _invitations.map(formatInvitation)
    }, _rest3), {
      invitations: [invitationSchema]
    });
  }
  var res = formatInvitation(json.invitation);
  return normalize$1(res, invitationSchema);
};
function formatInvitation(data) {
  if (!data) return data;
  if (data.result) data = data.result;
  return camelCaseKeys(data);
}

// MARK : Kit Version
/*-------------------------------------------------------------------------------*/

var kitVersion = function kitVersion(json, versionSchema) {
  var version = formatKitVersion(json.kit_version);
  return normalize$1(version, versionSchema);
};
function formatKitVersion(data) {
  return {
    version: data.version,
    kitId: data.kit_uuid,
    versionIdentifier: data.version_identifier,
    notes: data.notes,
    creator: data.creator ? formatUser(data.creator) : null,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    spaceId: data.space_id,
    status: data.status,
    counts: data.counts,
    sections: data.sections && data.sections.map(function (s) {
      return _objectSpread$e(_objectSpread$e({}, formatSection(s)), {}, {
        kitId: data.kit_uuid
      });
    })
  };
}

// MARK : Section
/*-------------------------------------------------------------------------------*/

var section = function section(json, sectionSchema) {
  if (isResultList(json.sections)) {
    var sections = json.sections,
      rest = _objectWithoutProperties(json, _excluded12);
    var results = sections.map(function (_ref5) {
      var result = _ref5.result,
        other = _objectWithoutProperties(_ref5, _excluded13);
      return _objectSpread$e({
        section: formatSection(result === null || result === void 0 ? void 0 : result.section)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      sections: results
    }, rest), {
      sections: [{
        section: sectionSchema
      }]
    });
  }
  if (json.sections) {
    return normalize$1({
      sections: json.sections.map(formatSection)
    }, {
      sections: new schema.Array(sectionSchema)
    });
  }
  return normalize$1(formatSection(json.section), sectionSchema);
};
function formatSection(data) {
  return {
    id: data.uuid,
    counts: data.counts,
    version: data.version,
    shortId: data.short_id,
    name: data.name,
    status: data.status,
    displayOrder: data.display_order,
    items: data.items && data.items.map(function (i) {
      return formatItem(i);
    }),
    kitId: data.kit_uuid,
    headers: data.headers && data.headers.map(formatOutlineHeader)
  };
}
function formatOutlineHeader(data) {
  return {
    id: data.uuid,
    shortId: data.short_id,
    name: data.name,
    version: data.version,
    displayOrder: data.display_order
  };
}

// MARK : Saved Views
/*-------------------------------------------------------------------------------*/

var formatAssetView = function formatAssetView(data) {
  return {
    id: data.id,
    name: data.name,
    spaceId: data.space_id,
    filters: data.filters || [],
    status: data.status
  };
};
var assetView = function assetView(json, assetViewSchema) {
  if (isResultList(json.views)) {
    var views = json.views,
      rest = _objectWithoutProperties(json, _excluded14);
    var results = views.map(function (_ref6) {
      var result = _ref6.result,
        other = _objectWithoutProperties(_ref6, _excluded15);
      return _objectSpread$e({
        view: formatAssetView(result === null || result === void 0 ? void 0 : result.view)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      views: results
    }, rest), {
      views: [{
        view: assetViewSchema
      }]
    });
  }
  if (json.views) {
    return normalize$1({
      views: json.views.map(formatAssetView)
    }, {
      views: new schema.Array(assetViewSchema)
    });
  }
  return normalize$1(formatAssetView(json.view), assetViewSchema);
};

// MARK : Custom Fields
/*-------------------------------------------------------------------------------*/

var formatCustomField = function formatCustomField(data) {
  return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(data)), {}, {
    options: data.options ? data.options.map(camelCaseKeys) : undefined
  });
};
var customField = function customField(json, customFieldSchema) {
  if (isResultList(json.fields)) {
    var fields = json.fields,
      rest = _objectWithoutProperties(json, _excluded16);
    var results = fields.map(function (_ref7) {
      var result = _ref7.result,
        other = _objectWithoutProperties(_ref7, _excluded17);
      return _objectSpread$e({
        field: formatCustomField(result === null || result === void 0 ? void 0 : result.field)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      fields: results
    }, rest), {
      fields: [{
        field: customFieldSchema
      }]
    });
  }
  if (json.fields) {
    return normalize$1({
      fields: json.fields.map(formatCustomField)
    }, {
      fields: new schema.Array(customFieldSchema)
    });
  }
  return normalize$1(formatCustomField(json.field), customFieldSchema);
};

// MARK : Item
/*-------------------------------------------------------------------------------*/

var item = function item(json, itemSchema) {
  if (isResultList(json.items)) {
    var items = json.items,
      rest = _objectWithoutProperties(json, _excluded18);
    var results = items.map(function (_ref8) {
      var result = _ref8.result,
        other = _objectWithoutProperties(_ref8, _excluded19);
      return _objectSpread$e({
        item: formatItem(result === null || result === void 0 ? void 0 : result.item)
      }, other);
    });
    return normalize$1(_objectSpread$e({
      items: results
    }, rest), {
      items: [{
        item: itemSchema
      }]
    });
  }
  if (json.items) {
    return normalize$1({
      items: json.items.map(formatItem)
    }, {
      items: new schema.Array(itemSchema)
    });
  }
  return normalize$1(formatItem(json.item), itemSchema);
};
var search = function search(json) {
  var formattedJson = _objectSpread$e(_objectSpread$e({}, json), {}, {
    queries: Object.keys(json.queries).reduce(function (acc, q) {
      var jsonQuery = camelCaseKeys(json.queries[q]);
      if (jsonQuery.type === "content") {
        acc[q] = _objectSpread$e(_objectSpread$e({}, jsonQuery), {}, {
          results: jsonQuery.results.map(function (o) {
            return _objectSpread$e(_objectSpread$e({}, formatItem(o.object)), {}, {
              section: formatSection(o.object.section),
              kit: formatKit(o.object.kit)
            });
          })
        });
      } else if (jsonQuery.type === "jump_to") {
        acc[q] = _objectSpread$e(_objectSpread$e({}, jsonQuery), {}, {
          results: jsonQuery.results.map(function (o) {
            switch (o.type) {
              case "item":
                return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(o)), {}, {
                  object: _objectSpread$e(_objectSpread$e({}, formatItem(o.object)), {}, {
                    section: formatSection(o.object.section),
                    kit: formatKit(o.object.kit)
                  })
                });
              case "section":
                return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(o)), {}, {
                  object: _objectSpread$e(_objectSpread$e({}, formatSection(o.object)), {}, {
                    kit: formatKit(o.object.kit)
                  })
                });
              case "kit":
                return _objectSpread$e(_objectSpread$e({}, camelCaseKeys(o)), {}, {
                  object: formatKit(o.object)
                });
              default:
                return o;
            }
          })
        });
      } else acc[q] = jsonQuery;
      return acc;
    }, {})
  });
  return normalize$1(formattedJson, {});
};
function formatItem(data) {
  if (!data) return data;
  return {
    id: data.uuid,
    version: data.version,
    shortId: data.short_id,
    kitId: data.kit_uuid,
    sectionId: data.section_uuid,
    spaceId: data.space_id,
    assetId: data.asset_uuid,
    displayOrder: data.display_order,
    status: data.status,
    type: data.type,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    data: formatItemData(data.data),
    // Relationships
    space: data.space && formatSpace(data.space),
    kit: data.kit && formatKit(data.kit),
    section: data.section && formatSection(data.section),
    kitVersion: data.kitVersion && formatKitVersion(data.kit_version),
    asset: data.asset && formatAsset(data.asset)
  };
}
function formatItemData(data) {
  var _camelCaseKeys = camelCaseKeys(data),
    backgroundColor = _camelCaseKeys.backgroundColor,
    textContent = _camelCaseKeys.content,
    rest = _objectWithoutProperties(_camelCaseKeys, _excluded20);
  return _objectSpread$e({
    textContent: textContent,
    backgroundColor: backgroundColor || "default"
  }, rest);
}

// MARK : Item.Asset
// asset is always contained in an item
/*-------------------------------------------------------------------------------*/

var asset = function asset(json, assetSchema) {
  if (isResultList(json.assets)) {
    var assets = json.assets,
      rest = _objectWithoutProperties(json, _excluded21);
    var results = assets.map(function (_ref9) {
      var result = _ref9.result,
        other = _objectWithoutProperties(_ref9, _excluded22);
      return _objectSpread$e({
        asset: formatAsset(result === null || result === void 0 ? void 0 : result.asset)
      }, other);
    });
    // Mutating an asset may affect kit items
    var items = assets.filter(function (f) {
      var _f$result;
      return Boolean(f === null || f === void 0 ? void 0 : (_f$result = f.result) === null || _f$result === void 0 ? void 0 : _f$result.item);
    }).map(function (d) {
      return "".concat(d.result.item.uuid, "-").concat(d.result.item.version);
    });
    return normalize$1(_objectSpread$e({
      assets: results,
      items: items
    }, rest), {
      assets: [{
        asset: assetSchema
      }]
    });
  }
  if (json.assets) {
    return normalize$1({
      assets: json.assets.map(formatAsset)
    }, {
      assets: new schema.Array(assetSchema)
    });
  }
  return normalize$1(formatAsset(json.asset), assetSchema);
};
var assetSearch = function assetSearch(json, assetSchema) {
  var results = json.queries.assets.results.map(function (r) {
    return {
      asset: formatAsset(r.object)
    };
  });
  return normalize$1({
    assets: results,
    total: json.queries.assets.total
  }, {
    assets: [{
      asset: assetSchema
    }]
  });
};
function formatAsset(data) {
  var _data$versioned_field, _data$items2;
  if (!data) return data;
  if (!data.meta) data.meta = {};
  function decacheUrl(url) {
    if (typeof url !== "string") return url;
    return url.includes("?") ? "".concat(url, "&hash=").concat(data.file_hash) : "".concat(url, "?hash=").concat(data.file_hash);
  }
  return _objectSpread$e(_objectSpread$e({
    id: data.uuid,
    sourceId: data.source_uuid,
    spaceId: data.space_id,
    name: data.name,
    notes: data.notes,
    keywords: data.keywords,
    autoKeywords: data.auto_keywords,
    type: data.type,
    category: data.category,
    size: data.size,
    shareToken: data.token
  }, getAssetDimensions(data)), {}, {
    colors: (data.colors || []).map(formatAssetColor),
    isFont: assetIsFont(data),
    permalink: decacheUrl(data.permalink),
    thumbnails: data.thumbnails && Object.keys(data.thumbnails).reduce(function (res, k) {
      res[k] = decacheUrl(data.thumbnails[k]);
      return res;
    }, {}),
    thumbnailPlaceholders: data.thumbnail_placeholders,
    meta: formatAssetMeta(data.meta),
    createdBy: data.uploader_id,
    fields: data.fields,
    versionedFields: (_data$versioned_field = data.versioned_fields) === null || _data$versioned_field === void 0 ? void 0 : _data$versioned_field.map(formatCustomField),
    fileId: data.file_id,
    fileHash: data.file_hash,
    fileUpdated: data.file_updated,
    dateAdded: data.date_added,
    dateUpdated: data.date_updated,
    items: (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.map(function (r) {
      return formatItem(r);
    })
  });
}
function formatAssetColor(color) {
  var c = tinycolor("hsva(".concat(color.hue, ", ").concat(color.saturation, "%, ").concat(color.brightness, "%, ").concat(color.alpha / 100, ")"));
  return _objectSpread$e(_objectSpread$e({}, color), {}, {
    hex: c.toHexString(),
    hex8: c.toHex8String(),
    rgb: c.toRgbString(),
    hsb: c.toHsvString().replace("hsv", "hsb"),
    name: color.name,
    pms: color.pms || null,
    cmyk: color.cmyk || null
  });
}
function formatAssetMeta(meta) {
  var _camelCaseKeys2 = camelCaseKeys(meta),
    font = _camelCaseKeys2.font,
    textStyle = _camelCaseKeys2.textStyle,
    filecuts = _camelCaseKeys2.filecuts,
    assetProcessing = _camelCaseKeys2.assetProcessing,
    rest = _objectWithoutProperties(_camelCaseKeys2, _excluded23);
  return _objectSpread$e({
    assetProcessing: assetProcessing,
    font: font && formatFontData(font),
    textStyle: textStyle && formatAssetTextStyle(textStyle),
    filecuts: filecuts && formatFilecuts(filecuts)
  }, rest);
}
function formatFilecuts(data) {
  return {
    availableTypes: data.available_types || [],
    presets: data.presets || []
  };
}
function formatFontData(data) {
  return {
    displayName: data.display_name,
    name: data.font_name,
    family: data.family,
    variant: data.variant,
    googleVariant: data.g_variant,
    extension: data.extension,
    source: data.source,
    stylesheetUrl: data.stylesheet_url
  };
}
function formatAssetTextStyle(data) {
  return {
    color: data.color || null,
    decoration: data.decoration || null,
    lineHeight: data.line_height || null,
    size: data.size || null,
    transform: data.transform || null
  };
}
function assetIsFont(a) {
  if (a.type !== AssetType.textStyle) return false;
  return Boolean(a.meta.text_style && Object.keys(a.meta.text_style).length);
}
function getAssetDimensions(a) {
  // Convert dimensions to ints (96.0x96.0 -> 96x96)
  var comps = a.dimensions.split("x").map(function (px) {
    return Math.round(parseFloat(px));
  });
  return {
    dimensions: comps.join("x"),
    width: comps[0],
    height: comps[1]
  };
}

// MARK : Kit Search
/*-------------------------------------------------------------------------------*/

var kitSearch = function kitSearch(json, kitSearchSchema) {
  var sections = json.sections.map(function (res) {
    return {
      total: res.total,
      section: formatSection(res.section),
      items: res.items.map(formatItem)
    };
  });
  return normalize$1(_objectSpread$e(_objectSpread$e({}, json), {}, {
    sections: sections
  }), kitSearchSchema);
};

// MARK : Space Search
/*-------------------------------------------------------------------------------*/

var spaceSearch = function spaceSearch(json, spaceSearchSchema) {
  var kits = json.kits.map(function (k) {
    return {
      total: k.total,
      kit: formatKit(k.kit),
      items: k.items.map(formatItem),
      version: formatKitVersion(k.version)
    };
  });
  return normalize$1(_objectSpread$e(_objectSpread$e({}, json), {}, {
    kits: kits
  }), spaceSearchSchema);
};

// MARK : Exports
/*-------------------------------------------------------------------------------*/

var normalizers = {
  user: user,
  space: space,
  spacePreview: spacePreview,
  spaceMember: spaceMember,
  apiToken: apiToken,
  charge: charge,
  kitCollection: kitCollection,
  kitCollectionItem: kitCollectionItem,
  kit: kit,
  kitVersion: kitVersion,
  kitMember: kitMember,
  invitation: invitation,
  section: section,
  item: item,
  asset: asset,
  assetSearch: assetSearch,
  kitSearch: kitSearch,
  spaceSearch: spaceSearch,
  search: search,
  customField: customField,
  assetView: assetView
};

var User = new schema.Entity("users", {}, {
  idAttribute: "id"
});
var Invitation = new schema.Entity("invitations", {}, {
  idAttribute: "id"
});
var Space = new schema.Entity("spaces", {}, {
  idAttribute: "id"
});
var ApiToken = new schema.Entity("apiTokens", {}, {
  idAttribute: "token"
});
var SpaceMember = new schema.Entity("spaceMembers", {}, {
  idAttribute: function idAttribute(val) {
    return "".concat(val.spaceId, "-").concat(val.userId);
  }
});
var KitCollection = new schema.Entity("kitCollections", {}, {
  idAttribute: "uuid"
});
var KitCollectionItem = new schema.Entity("kitCollectionItems", {}, {
  idAttribute: function idAttribute(val) {
    return "".concat(val.collectionUuid, "-").concat(val.kit.kitId);
  }
});
var Kit = new schema.Entity("kits", {}, {
  idAttribute: "kitId"
});
var KitMember = new schema.Entity("kitMembers", {}, {
  idAttribute: function idAttribute(val) {
    return "".concat(val.spaceId, "-").concat(val.userId, "-").concat(val.kitId);
  }
});
var KitVersion = new schema.Entity("kitVersions", {}, {
  idAttribute: function idAttribute(val) {
    return "".concat(val.kitId, "-").concat(val.version);
  }
});
var Section$2 = new schema.Entity("sections", {}, {
  idAttribute: function idAttribute(val) {
    return "".concat(val.id, "-").concat(val.version);
  }
});
var Item$5 = new schema.Entity("items", {}, {
  idAttribute: function idAttribute(val) {
    return "".concat(val.id, "-").concat(val.version);
  }
});
var Asset = new schema.Entity("assets", {}, {
  idAttribute: "id"
});
var CustomField = new schema.Entity("fields", {}, {
  idAttribute: "id"
});
var AssetView = new schema.Entity("views", {}, {
  idAttribute: "id"
});
User.define({
  spaces: new schema.Array(Space)
});
KitCollectionItem.define({
  kit: Kit
});
KitCollection.define({
  kits: new schema.Array(Kit),
  items: new schema.Array(KitCollectionItem)
});
Space.define({
  kits: new schema.Array(Kit),
  kitCollections: new schema.Array(KitCollection)
});
SpaceMember.define({
  user: User,
  kitAccess: new schema.Array(KitMember)
});
Kit.define({
  space: Space,
  versions: new schema.Array(KitVersion)
});
KitVersion.define({
  sections: new schema.Array(Section$2),
  creator: User
});
KitMember.define({
  kit: Kit,
  user: User,
  spaceMember: SpaceMember
});
Section$2.define({
  items: new schema.Array(Item$5)
});
Item$5.define({
  section: Section$2,
  kit: KitVersion,
  space: Space,
  asset: Asset
});
CustomField.define({
  space: Space
});
var KitSearch = new schema.Object({
  sections: new schema.Array({
    section: Section$2,
    items: new schema.Array(Item$5)
  })
});
var SpaceSearch = new schema.Object({
  kits: new schema.Array({
    kit: Kit,
    version: KitVersion,
    items: new schema.Array(Item$5)
  })
});
var Schemas = {
  USER: {
    schema: User,
    normalizer: normalizers.user
  },
  SPACE: {
    schema: Space,
    normalizer: normalizers.space
  },
  SPACE_PREVIEW: {
    schema: {},
    normalizer: normalizers.spacePreview
  },
  SPACE_MEMBER: {
    schema: SpaceMember,
    normalizer: normalizers.spaceMember
  },
  API_TOKEN: {
    schema: ApiToken,
    normalizer: normalizers.apiToken
  },
  CHARGE: {
    schema: {},
    normalizer: normalizers.charge
  },
  SPACE_SEARCH: {
    schema: SpaceSearch,
    normalizer: normalizers.spaceSearch
  },
  KIT_COLLECTION_ITEM: {
    schema: KitCollectionItem,
    normalizer: normalizers.kitCollectionItem
  },
  KIT_COLLECTION: {
    schema: KitCollection,
    normalizer: normalizers.kitCollection
  },
  KIT: {
    schema: Kit,
    normalizer: normalizers.kit
  },
  KIT_VERSION: {
    schema: KitVersion,
    normalizer: normalizers.kitVersion
  },
  KIT_SEARCH: {
    schema: KitSearch,
    normalizer: normalizers.kitSearch
  },
  KIT_MEMBER: {
    schema: {
      kitMember: KitMember,
      spaceMember: SpaceMember
    },
    normalizer: normalizers.kitMember
  },
  INVITATION: {
    schema: Invitation,
    normalizer: normalizers.invitation
  },
  SECTION: {
    schema: Section$2,
    normalizer: normalizers.section
  },
  ITEM: {
    schema: Item$5,
    normalizer: normalizers.item
  },
  SEARCH: {
    schema: {},
    normalizer: normalizers.search
  },
  ASSET: {
    schema: Asset,
    normalizer: normalizers.asset
  },
  ASSET_SEARCH: {
    schema: Asset,
    normalizer: normalizers.assetSearch
  },
  CUSTOM_FIELD: {
    schema: CustomField,
    normalizer: normalizers.customField
  },
  ASSET_VIEW: {
    schema: AssetView,
    normalizer: normalizers.assetView
  }
};

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function genUUID() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return v4();
}
function genShortId() {
  return "xxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      // eslint-disable-line no-bitwise
      v = c === "x" ? r : r & 0x3 | 0x8; // eslint-disable-line no-bitwise
    return v.toString(16);
  });
}
function genID() {
  return Math.round(Math.random() * 10000) + 1;
}
function genEmail() {
  var name = genName().replace(" ", "_");
  return "".concat(name, "@lingoapp.com");
}

/**
 * Generates a alpha string
 * @param {*} length
 */
function genString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
    charactersLength = characters.length;
  return Array(length).fill(null).map(function () {
    return characters.charAt(Math.floor(Math.random() * charactersLength));
  }).join("");
}
function genName() {
  var words = ["ants", "excited", "press", "spotty", "coat", "gato", "bathe", "heat", "deeply", "embarrass", "mist", "craven", "neighborly", "funny", "man", "van", "tranquil", "grandiose", "march", "road"];
  var wordCount = words.length;
  var numWords = 2 + Math.floor(Math.random() * 2);
  var res = [];
  for (var i = 0; i < numWords; i += 1) {
    var w = words[Math.floor(Math.random() * wordCount)];
    res.push(w);
  }
  return res.join(" ");
}

// MARK : Default IDs
/*-------------------------------------------------------------------------------*/

var kitUUID = genUUID();
var sectionUUID = genUUID();
var spaceID = genID();
var userID = genID();

// MARK : Generators
/*-------------------------------------------------------------------------------*/

function mergeRules(objValue, srcValue) {
  if (_isArray(objValue)) {
    return srcValue || objValue;
  }
}
function createUser() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    id: userID,
    name: "Jordan Smith",
    email: "jsmith@thenounproject.com",
    app_progress: "onboard_v1,app_login,download,example_kit,created_in_app",
    avatar: "https://static-test.lingoapp.com/avatar/3efacf39-cc23-41e4-afc2-9fb2631c5563.png",
    features: [],
    installed_app: "2016-01-05 22:06:22.942431+0000",
    is_active: true,
    is_admin: true,
    last_login: "2018-12-13 22:44:15.454399+0000",
    created_at: "2016-01-12 19:46:59.683120+0000",
    updated_at: "2018-12-13 20:43:47.785993+0000"
  }, overrides);
}
function createNestedUser() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    avatar: "https://www.gravatar.com/avatar/64fe995229067daf8862575df759b43a?s=240&d=https%3A%2F%2Fstatic.lingoapp.com%2Fassets%2Fimages%2Fuser-avatars%2Fv2-12.png",
    email: "jSmith@thenounproject.com",
    id: userID,
    name: "Jordan Smith"
  }, overrides);
}
function createSpace() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _mergeWith({
    access: {
      date_added: "2016-01-19 20:29:34.669786+0000",
      date_updated: "2016-01-19 20:29:34.669786+0000",
      id: genID(),
      permissions: ["delete", "create_kit", "edit", "invite_user", "change_user_role", "revoke_invitation", "remove_user", "manage_billing", "manage_resources", "view_members", "create_asset"],
      upgrade_permissions: {},
      role: "owner",
      space_id: overrides.id || spaceID,
      status: "active",
      user_id: userID
    },
    avatar: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF.png",
    avatars: createSpaceAvatars(),
    counts: createSpaceCounts(),
    date_added: "2016-01-19 20:29:34.669786+0000",
    date_updated: "2018-11-16 20:54:13.815200+0000",
    features: ["space_theme", "web_edit_content", "kit_versioning"],
    id: spaceID,
    max_assets: null,
    max_users: null,
    name: "Guest Mania",
    slug: "guest-mania",
    status: "active",
    privacy: "private",
    join_settings: {
      token: null,
      join_with: {},
      allowed_domains: null
    },
    subscription: {
      cancel_at_period_end: false,
      current_period_end: "2016-11-26 00:04:05+00:00",
      customer: {
        coupon: null,
        stripe_id: "cus_8KzfYdDX0a6WGE"
      },
      interval: "month",
      plan: "tier-enterprise-month",
      price: 4900,
      price_per_user: null,
      quantity: 1,
      status: "active",
      stripe_id: "sub_8KzffcSRwSnAm6",
      total_price: null
    },
    theme: createSpaceTheme(),
    uuid: "team_18"
  }, overrides, mergeRules);
}
function createSpaceAvatars() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    avatar: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF.png",
    avatar_16: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_16.png",
    avatar_180: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_180.png",
    avatar_32: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_32.png",
    card: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF_card.png",
    default_avatar: "https://static-test.lingoapp.com/assets/images/user-avatars/space.png"
  }, overrides);
}
function createSpaceCounts() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    assets: 20,
    invitations: 16,
    storage: 958991,
    users: 376
  }, overrides);
}
function createSpaceTheme() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    primary_color: "#AAAAAA",
    primary_color_dark: "#555555",
    primary_color_light: "#BBBBBB",
    primary_color_tint: "#FFFFFF"
  }, overrides);
}
function createSpacePreview() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    id: spaceID,
    name: genName(),
    subdomain: null,
    avatar: "https://static-test.lingoapp.com/avatar/s/72/8C3F847C-DFCE-4B61-9D8C-50FF1A5B9DFF.png",
    avatars: createSpaceAvatars(),
    theme: createSpaceTheme()
  }, overrides);
}
function createSpacePreviewMember() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    id: genID(),
    name: genName(),
    email: genEmail(),
    avatar: "https://www.gravatar.com/avatar/64fe995229067daf8862575df759b43a?s=240&d=https%3A%2F%2Fstatic.lingoapp.com%2Fassets%2Fimages%2Fuser-avatars%2Fv2-12.png",
    role: "admin"
  }, overrides);
}
function createSpaceCard() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var stripeId = "ch_".concat(genShortId());
  return _objectSpread$d({
    brand: "Visa",
    country: "US",
    exp_month: 2,
    exp_year: 2024,
    last4: "4242",
    receipt_extra: null,
    stripe_id: stripeId
  }, overrides);
}
function createSpaceCharge() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var stripeId = overrides.stripe_id || "ch_".concat(genShortId());
  return _objectSpread$d({
    id: genID(),
    amount: 165.31,
    card: "Visa 4242",
    date: "2016-11-03 23:47:26.421327+0000",
    invoice_url: "/v4/invoices/".concat(stripeId),
    receipt_extra: null,
    refunded: false,
    status: "succeeded",
    stripe_id: stripeId
  }, overrides);
}
function createApiToken() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    token: genUUID(),
    name: "My Api Token",
    writeAccess: false,
    status: "active",
    space_id: spaceID,
    created_at: "2016-11-03 23:47:26.421327+0000"
  }, overrides);
}
function createSpaceMember() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userId = overrides.user_id || genID();
  return _mergeWith({
    id: genID(),
    role: "member",
    space_id: spaceID,
    status: "active",
    joined_kits: 0,
    permissions: ["search_assets", "view_members", "remove_self"],
    user_id: userId,
    user: createNestedUser({
      id: userId
    }),
    date_added: "2016-11-03 23:47:26.421327+0000",
    date_updated: "2017-06-15 16:19:48.204267+0000"
  }, overrides, mergeRules);
}
function createInvitation() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _mergeWith({
    id: genID(),
    email: "".concat(genName().split(" ").join("_"), "@lingoapp.com"),
    space_id: spaceID,
    join_with: {
      role: "admin",
      kits: []
    },
    note: "",
    token: genUUID(),
    invited_at: "2017-06-15 16:19:48.204267+0000",
    accepted_at: null,
    status: "pending",
    from_user_id: genID()
  }, overrides, mergeRules);
}
function createKit() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _spaceID = overrides.space_id || spaceID,
    _kitID = overrides.kit_uuid || kitUUID;
  return _mergeWith({
    access: {
      date_added: "2018-03-12 04:59:16.472477+0000",
      date_updated: "2018-03-12 04:59:16.472477+0000",
      id: 7929,
      is_favorite: false,
      kit_uuid: _kitID,
      permissions: ["manage", "view", "edit", "delete", "change_member_role", "manage_sharelinks", "change_own_status", "edit_content", "search_assets", "view_all_content", "favorite"],
      upgrade_permissions: {},
      role: "admin",
      space_id: _spaceID,
      status: "active",
      use_version: null,
      user_id: 2
    },
    counts: {
      invitations: 0,
      members: 6
    },
    date_added: "2018-03-12 04:59:16.472477+0000",
    date_updated: "2018-04-20 16:37:00.807095+0000",
    id: 2474,
    images: {
      cover: "https://lingo-test.s3.amazonaws.com/kits/factory.spaceID/216F2D9A-68C0-4F4E-B728-DB0042A97791/cover_1524242220.png"
    },
    privacy: "private",
    portal_access: false,
    kit_uuid: _kitID,
    short_id: genShortId(),
    name: genName(),
    notes: "",
    space_id: _spaceID,
    status: "active",
    token: null,
    use_version: 0
  }, overrides, mergeRules);
}
function createKitMember() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userId = overrides.user_id || genID();
  return _mergeWith({
    id: genID(),
    role: "admin",
    space_id: spaceID,
    kit_uuid: kitUUID,
    user_id: userId,
    status: "active",
    is_favorite: false,
    use_version: 0,
    permissions: ["manage", "view", "edit", "delete", "change_member_role", "manage_sharelinks", "change_own_status", "edit_content", "search_assets", "view_all_content"],
    user: createNestedUser({
      id: userId
    }),
    date_added: "2016-11-03 23:47:26.421327+0000",
    date_updated: "2017-06-15 16:19:48.204267+0000"
  }, overrides, mergeRules);
}
function createVersion() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    counts: {
      assets: 0,
      items: 0,
      sections: 0
    },
    date_added: "2018-03-12 04:59:16.472477+0000",
    date_updated: "2018-03-12 04:59:16.472477+0000",
    kit_uuid: kitUUID,
    notes: "",
    space_id: spaceID,
    status: "active",
    store_status: "inactive",
    version: 0,
    version_identifier: "0.0",
    sections: []
  }, overrides);
}
function createOutlineSection() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    uuid: genUUID(),
    short_id: genShortId(),
    name: genName(),
    display_order: 0,
    headers: [],
    counts: {
      assets: 0,
      items: 0
    },
    version: 0
  }, overrides);
}
function createOutlineHeader() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    uuid: genUUID(),
    short_id: genShortId(),
    name: genName(),
    version: 0,
    display_order: 0
  }, overrides);
}
function createSection() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    uuid: genUUID(),
    short_id: genShortId(),
    kit_uuid: kitUUID,
    name: genName(),
    counts: {
      assets: 1,
      items: 1
    },
    display_order: 0,
    status: "active",
    version: 0,
    creator_id: 2,
    date_added: "2018-03-12 04:59:22.760599+0000",
    date_updated: "2018-03-12 04:59:22.760599+0000"
  }, overrides);
}
function createItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge({
    asset_uuid: null,
    data: {},
    date_added: "2018-04-05 20:13:53.528112+0000",
    date_updated: "2018-04-05 20:13:53.528121+0000",
    display_order: -20,
    status: "active",
    type: ItemType.heading,
    uuid: genUUID(),
    version: 0,
    short_id: genShortId(),
    space_id: spaceID,
    kit_uuid: kitUUID,
    section_uuid: sectionUUID
  }, overrides);
}
function createHeadingItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createItem(_objectSpread$d(_objectSpread$d({}, _merge({
    data: {
      content: "Stars & Nebulas",
      display_size: "0"
    }
  }, overrides)), {}, {
    asset_uuid: null,
    type: ItemType.heading
  }));
}
function createNoteItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createItem(_objectSpread$d(_objectSpread$d({}, _merge({
    data: {
      content: "These photos provided by NASA.",
      display_size: "0"
    }
  }, overrides)), {}, {
    asset_uuid: null,
    type: ItemType.note
  }));
}
function createGuideItem() {
  var asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createItem(_objectSpread$d(_objectSpread$d({}, _merge({
    data: {
      content: "Make sure you do this",
      color: "green",
      title: "DO",
      display_style: "image",
      display_size: 1
    }
  }, overrides)), {}, {
    type: ItemType.guide,
    asset_uuid: asset ? asset.uuid : null,
    space_id: asset ? asset.space_id : spaceID,
    asset: asset
  }));
}
function createCodeSnippetItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createItem(_objectSpread$d(_objectSpread$d({}, _merge({
    data: {
      content: 'const name = "Bob"',
      display_size: "0",
      code_language: "Javascript"
    }
  }, overrides)), {}, {
    asset_uuid: null,
    type: ItemType.codeSnippet
  }));
}
function createAssetItem(asset) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createItem(_objectSpread$d(_objectSpread$d({}, overrides), {}, {
    type: ItemType.asset,
    asset_uuid: asset.uuid,
    space_id: asset.space_id,
    asset: asset
  }));
}
function createImageItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createImageAsset(), overrides);
}
function createVideoItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createVideoAsset(), overrides);
}
function createLottieItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createLottieAsset(), overrides);
}
function createAudioItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createAudioAsset(), overrides);
}
function createColorItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createColorAsset(), overrides);
}
function createFontItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createAssetItem(createFontAsset(), overrides);
}
function createSupportingImageItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var item = createAssetItem(createImageAsset(), overrides);
  item.type = ItemType.supportingImage;
  return item;
}
function createSupportingVideoItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var item = createAssetItem(createVideoAsset(), overrides);
  item.type = ItemType.supportingImage;
  return item;
}
function createSupportingLottieItem() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var item = createAssetItem(createLottieAsset(), overrides);
  item.type = ItemType.supportingImage;
  return item;
}
var thumbnails = {
  thumbnail_placeholders: {
    292: "https://lingo-test.s3.amazonaws.com/thumbnails/placeholder/svg/292x292.png",
    480: "https://lingo-test.s3.amazonaws.com/thumbnails/placeholder/svg/480x480.png",
    1232: "https://lingo-test.s3.amazonaws.com/thumbnails/placeholder/svg/1232x1232.png"
  },
  thumbnails: {
    292: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/preview?size=292&asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    480: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/preview?size=480&asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    1232: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/preview?size=1232&asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY"
  }
};
function createImageAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d(_objectSpread$d({
    category: "raster",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "100.0x100.0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    meta: {
      assetProcessing: "complete",
      filecuts: {
        available_types: [{
          enabled: true,
          resizable: true,
          type: "PNG"
        }, {
          enabled: true,
          resizable: true,
          type: "JPG"
        }],
        presets: [{
          description: "",
          size: "1x",
          type: "PNG"
        }, {
          description: "",
          size: "1x",
          type: "JPG"
        }]
      }
    },
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.png,
    uploader_id: 2,
    uuid: genUUID()
  }, thumbnails), overrides);
}
function createLottieAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d(_objectSpread$d({
    category: "video",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "100.0x100.0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.lottie,
    uploader_id: 2,
    uuid: genUUID(),
    meta: {
      assetProcessing: "complete"
    }
  }, thumbnails), overrides);
}
function createVideoAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _merge(_objectSpread$d({
    category: "video",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "100.0x100.0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.mp4,
    uploader_id: 2,
    uuid: genUUID(),
    meta: {
      assetProcessing: "complete",
      duration: 30
    }
  }, thumbnails), overrides);
}
function createAudioAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d(_objectSpread$d({
    category: "audio",
    colors: [],
    date_added: "2018-03-12 04:59:44.891239+0000",
    date_updated: "2018-12-14 15:49:21.701801+0000",
    dimensions: "0x0",
    file_hash: "9622e706196bf2dd6db976c10cdb2c4c97a4673c",
    file_id: "4D421CC8-353C-49F6-9538-124A924A76B2",
    file_updated: "2018-03-12 04:59:44.891239+0000",
    keywords: "Kaiser,antimodernization,pretraveling,tubercularise",
    name: genName(),
    notes: "",
    permalink: "https://api-test.lingoapp.com/v4/assets/AFCD9898-BB8B-455C-8429-5D4717496A33/download?asset_token=G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    size: 16326,
    space_id: spaceID,
    token: "G3Ss23q1ARG8z3zrsHDCssEhM-B9lkZZsYIyEUMgukY",
    type: AssetType.mp3,
    uploader_id: 2,
    uuid: genUUID(),
    meta: {
      assetProcessing: "complete",
      duration: 1.175
    }
  }, thumbnails), overrides);
}
function createColorAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d({
    category: "color",
    colors: [{
      alpha: 100,
      brightness: 81.96078,
      coverage: 100,
      hue: 360,
      name: "Candy",
      saturation: 100
    }],
    date_added: "2018-07-16 19:26:22.771418+0000",
    date_updated: "2018-08-31 15:51:52.472919+0000",
    dimensions: "0x0",
    file_hash: "8e7e4c3c4c16c5422116153ae300160901186e9d",
    file_id: null,
    file_updated: "2018-07-16 19:26:22.771418+0000",
    keywords: "red",
    meta: {
      external_id: genUUID()
    },
    name: genName(),
    notes: "red",
    size: 0,
    space_id: spaceID,
    token: "zo8YcVI-Ih0-Wbk4bQrgjNczhZMyNpIQH7kfvzDMskw",
    type: AssetType.color,
    uploader_id: 2,
    uuid: genUUID()
  }, overrides);
}
function createFontAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d(_objectSpread$d({
    category: "text_style",
    colors: [],
    date_added: "2018-10-02 18:52:29.586325+0000",
    date_updated: "2018-10-24 19:18:01.357386+0000",
    dimensions: "0.0x0.0",
    file_hash: "5cab77a2faac5b6bdbdb22808f8e9296100b1529",
    file_id: "e86cc57a-2dfb-47e8-befb-afcc4243b065",
    file_updated: "2018-10-02 18:52:29.586325+0000",
    keywords: "font,heading,big,bold,sans-serif",
    meta: {
      font: {
        display_name: "Input Bold",
        extension: "ttf",
        family: "Input",
        font_name: "Input-Bold",
        source: "file",
        stylesheet_url: "https://api-test.lingoapp.com/v4/assets/8424E3C7-4AF5-46D4-8BD1-C4363BF78CF6/css?asset_token=_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
        variant: "Bold"
      }
    },
    name: "Heading",
    notes: "Use this for all the headings",
    permalink: "https://api-test.lingoapp.com/v4/assets/8424E3C7-4AF5-46D4-8BD1-C4363BF78CF6/download?asset_token=_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    size: 122340,
    space_id: spaceID,
    token: "_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    type: AssetType.textStyle,
    uploader_id: 2,
    uuid: genUUID()
  }, thumbnails), overrides);
}
function createDocumentAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$d(_objectSpread$d({
    category: "document",
    colors: [],
    date_added: "2018-10-02 18:52:29.586325+0000",
    date_updated: "2018-10-24 19:18:01.357386+0000",
    dimensions: "0.0x0.0",
    file_hash: "5cab77a2faac5b6bdbdb22808f8e9296100b1529",
    file_id: "e86cc57a-2dfb-47e8-befb-afcc4243b065",
    file_updated: "2018-10-02 18:52:29.586325+0000",
    keywords: "file,presentation,keynote",
    meta: {},
    name: "Presentation",
    notes: "Use this for all the presentations",
    permalink: "https://api-test.lingoapp.com/v4/assets/8424E3C7-4AF5-46D4-8BD1-C4363BF78CF6/download?asset_token=_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    size: 122340,
    space_id: spaceID,
    token: "_Zhe87o4B2NFIoNaX5sagApadSxcLlzHD9-BLiHcVNY",
    type: AssetType.pptx,
    uploader_id: 2,
    uuid: genUUID()
  }, thumbnails), overrides);
}
function createSketchAsset() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _mergeWith(_objectSpread$d({
    category: "sketch",
    colors: [],
    date_added: "2018-03-12 05:01:26.570207+0000",
    date_updated: "2018-03-12 05:01:26.570713+0000",
    dimensions: "320.0x200.0",
    file_hash: "9a427051418fbfaa14c30cbd9b95ecd58cc0f86c",
    file_id: "EDCB69C7-6BB4-4677-8A73-4BDB72C2BD2D",
    file_updated: "2018-03-12 05:01:26.570207+0000",
    keywords: "Image",
    meta: {
      embedded_cuts: "SVG,PDF",
      external_hash: "3dc6e4a666b4b1a2d7762d074457ef0528e6464a",
      sketch_object_id: genUUID(),
      sketch_format_version: "101_2",
      sketch_pathname: "Image / 16 : 1",
      filecuts: {
        available_types: [{
          enabled: true,
          resizable: true,
          type: "PNG"
        }, {
          enabled: true,
          resizable: true,
          type: "JPG"
        }, {
          enabled: true,
          resizable: false,
          type: "SVG"
        }],
        presets: [{
          description: "",
          size: "1x",
          type: "SVG"
        }, {
          description: "",
          size: "1x",
          type: "PNG"
        }, {
          description: "",
          size: "1x",
          type: "JPG"
        }]
      }
    },
    name: genName(),
    notes: "",
    permalink: "http://local.lingoapp.com:9000/v4/assets/A4508D1F-51E4-477D-A747-F2FC3CB903B5/download?asset_token=C4kl9Nba7X44Ha54wAn1B40hf1B0B93iOZxo9_KGOY8",
    size: 15681,
    space_id: spaceID,
    token: "C4kl9Nba7X44Ha54wAn1B40hf1B0B93iOZxo9_KGOY8",
    uploader_id: 2,
    type: AssetType.sketchSymbol,
    uuid: genUUID()
  }, thumbnails), overrides, mergeRules);
}

// MARK : Normalized/State data
/*-------------------------------------------------------------------------------*/

/**
 * Easily normalize factory objects as they would be in state.
 *
 * ex. `factory.normalize.space(factory.createSpace())`
 *
 * Note that the overrides use with the factory object creators may be different
 * than the keys you are expecting from the normalized version. Overrides should
 * be supplied as they would come from the API.
 */

var createState = function createState(entities) {
  var _entities$spaces = entities.spaces,
    spaces = _entities$spaces === void 0 ? [] : _entities$spaces,
    _entities$kits = entities.kits,
    kits = _entities$kits === void 0 ? [] : _entities$kits,
    _entities$sections = entities.sections,
    sections = _entities$sections === void 0 ? [] : _entities$sections,
    _entities$items = entities.items,
    items = _entities$items === void 0 ? [] : _entities$items;
  return normalize$1({
    spaces: spaces.map(formatSpace),
    kits: kits.map(formatKit),
    sections: sections.map(formatSection),
    items: items.map(formatItem)
  }, {
    spaces: [Schemas.SPACE.schema],
    kits: [Schemas.KIT.schema],
    sections: [Schemas.SECTION.schema],
    items: [Schemas.ITEM.schema]
  });
};
var normalize = {
  user: function user(data) {
    return formatUser(data);
  },
  space: function space(data) {
    return formatSpace(data);
  },
  spacePreview: function spacePreview(data) {
    return formatSpacePreview(data);
  },
  charge: function charge(data) {
    return formatCharge(data);
  },
  apiToken: function apiToken(data) {
    return formatApiToken(data);
  },
  spaceMember: function spaceMember(data) {
    return formatSpaceMember(data);
  },
  invitation: function invitation(data) {
    return formatInvitation(data);
  },
  kit: function kit(data) {
    return formatKit(data);
  },
  kitMember: function kitMember(data) {
    return formatKitMember(data);
  },
  kitVersion: function kitVersion(data) {
    return formatKitVersion(data);
  },
  section: function section(data) {
    return formatSection(data);
  },
  item: function item(data) {
    return formatItem(data);
  },
  asset: function asset(data) {
    return formatAsset(data);
  },
  outlineHeader: function outlineHeader(data) {
    return formatOutlineHeader(data);
  }
};
var factory = {
  normalize: normalize,
  genUUID: genUUID,
  genString: genString,
  createUser: createUser,
  createNestedUser: createNestedUser,
  createSpace: createSpace,
  createSpacePreview: createSpacePreview,
  createSpacePreviewMember: createSpacePreviewMember,
  createSpaceTheme: createSpaceTheme,
  createSpaceCounts: createSpaceCounts,
  createSpaceCard: createSpaceCard,
  createSpaceCharge: createSpaceCharge,
  createInvitation: createInvitation,
  createApiToken: createApiToken,
  createSpaceMember: createSpaceMember,
  createKit: createKit,
  createKitMember: createKitMember,
  createVersion: createVersion,
  createOutlineHeader: createOutlineHeader,
  createOutlineSection: createOutlineSection,
  createSection: createSection,
  createHeadingItem: createHeadingItem,
  createNoteItem: createNoteItem,
  createGuideItem: createGuideItem,
  createCodeSnippetItem: createCodeSnippetItem,
  createAssetItem: createAssetItem,
  createImageItem: createImageItem,
  createVideoItem: createVideoItem,
  createLottieItem: createLottieItem,
  createAudioItem: createAudioItem,
  createColorItem: createColorItem,
  createFontItem: createFontItem,
  createSupportingImageItem: createSupportingImageItem,
  createSupportingVideoItem: createSupportingVideoItem,
  createSupportingLottieItem: createSupportingLottieItem,
  createImageAsset: createImageAsset,
  createVideoAsset: createVideoAsset,
  createLottieAsset: createLottieAsset,
  createAudioAsset: createAudioAsset,
  createColorAsset: createColorAsset,
  createFontAsset: createFontAsset,
  createDocumentAsset: createDocumentAsset,
  createSketchAsset: createSketchAsset,
  createState: createState
};

/**
 *
 * @param {Boolean} val The default value
 *
 * Wraps a boolean in state, providing callbacks for setting the value to true and false.
 *
 * const [isModalShown, showModal, hideModal] = useBoolean(false)
 *
 * <Button onClick={showModal} text="Open Modal" />
 * <Modal open={isModalShown} close={hideModal} />
 */

function useBoolean(val) {
  var _useState = useState(val),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var setTrue = useCallback(function () {
      return setValue(true);
    }, [setValue]),
    setFalse = useCallback(function () {
      return setValue(false);
    }, [setValue]);
  return [value, setTrue, setFalse];
}

// This const/type approach is an alternative to enums that
// is supposed to be more efficient and reliable. babel also doesn't support
// const enums which is problematic.
var TooltipDirection = {
  Top: "top",
  Left: "left",
  Right: "right",
  Bottom: "bottom"
};

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TooltipTail = styled(Box$1).attrs(function (props) {
  var style = function style() {
    var translateValue = props.offset ? "calc(-50% + ".concat(props.offset, "px)") : "-50%";
    var horizontalPosition = function horizontalPosition() {
      return {
        left: "50%",
        transform: "translateX(".concat(translateValue, ")")
      };
    };
    var verticalPosition = function verticalPosition() {
      return {
        top: "50%",
        transform: "translateY(".concat(translateValue, ")")
      };
    };
    switch (props.direction) {
      case TooltipDirection.Top:
        return _objectSpread$c({
          borderBottomColor: color.modalOverlay,
          top: "-16px"
        }, horizontalPosition());
      case TooltipDirection.Bottom:
        return _objectSpread$c({
          borderTopColor: color.modalOverlay,
          bottom: "-16px"
        }, horizontalPosition());
      case TooltipDirection.Right:
        return _objectSpread$c({
          borderLeftColor: color.modalOverlay,
          right: "-16px"
        }, verticalPosition());
      case TooltipDirection.Left:
        return _objectSpread$c({
          borderRightColor: color.modalOverlay,
          left: "-16px"
        }, verticalPosition());
      default:
        return null;
    }
  };
  return {
    border: "solid 8px transparent",
    position: "absolute",
    style: style()
  };
}).withConfig({
  displayName: "TooltipTail"
})(["pointer-events:none;"]);
var TooltipTail$1 = TooltipTail;

var _excluded$o = ["source", "direction", "children", "interactive"],
  _excluded2$1 = ["tail"];
function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Wrapper$4 = styled(Flex$1).attrs(function (props) {
  return {
    background: "modalOverlay",
    boxShadow: "panel",
    maxWidth: props.maxWidth || 360,
    minWidth: props.minWidth || 50,
    flexDirection: "column",
    position: "fixed",
    display: "block",
    borderRadius: "default",
    zIndex: 51000,
    style: _objectSpread$b({
      lineHeight: "30px",
      transition: "opacity 0.2s",
      opacity: props.isOpen ? 1 : 0,
      pointerEvents: props.isOpen ? null : "none"
    }, props.tooltipPositioning)
  };
}).withConfig({
  displayName: "Tooltip__Wrapper"
})([""]);

// Helper function for getting DOM elements
function getElement$1(name, value) {
  var el;
  if (typeof value === "string") {
    try {
      el = document.querySelector(value);
    } catch (_unused) {
      // Retry another selector below
    }
    if (!el) el = document.querySelector("[".concat(name, "='").concat(value, "']"));
  }
  return el;
}

/**
 * A Tooltip component
 *
 * ### Example usage
 * ```
 * const tooltipID = "my-tooltip"
 * <>
 *  <Text data-tooltip-source={tooltipId}>I have a tooltip</Text>
 *  <Tooltip source={tooltipId} direction={}>
 *    You found the tooltip!
 *  </Tooltip>
 * </>
 * ```
 */

var Tooltip = function Tooltip(_ref) {
  var source = _ref.source,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "right" : _ref$direction,
    children = _ref.children,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive,
    props = _objectWithoutProperties(_ref, _excluded$o);
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 3),
    isOpen = _useBoolean2[0],
    setOpen = _useBoolean2[1],
    setClosed = _useBoolean2[2];
  var _useBoolean3 = useBoolean(false),
    _useBoolean4 = _slicedToArray(_useBoolean3, 3),
    wantsOpen = _useBoolean4[0],
    setWantsOpen = _useBoolean4[1],
    setWantsClosed = _useBoolean4[2];
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var contentIdentifier = useMemo(function () {
    return factory.genString();
  }, []);

  // MARK : Elemenets
  // -------------------------------------------------------------------------------
  var getContentElement = useCallback(function () {
    return document.body.querySelector("#".concat(contentIdentifier));
  }, [contentIdentifier]);
  var getSource = useCallback(function () {
    return getElement$1("data-tooltip-source", source);
  }, [source]);
  var getTrigger = useCallback(function () {
    return getElement$1("data-tooltip-trigger", source) || getSource();
  }, [getSource, source]);

  // Set accessability attributes on the source
  // This obviously isn't very JSX-like but it allows for a more flexibility
  // when composing tooltips with components since we don't have to pass around
  // refs or props. This way it is all handled implicitly.
  useEffect(function () {
    var _getSource;
    (_getSource = getSource()) === null || _getSource === void 0 ? void 0 : _getSource.setAttribute("aria-describedby", contentIdentifier);
  }, [contentIdentifier, getSource]);

  // MARK : Positioning
  // -------------------------------------------------------------------------------
  var calculatePosition = useCallback(function () {
    var sourceEl = getSource();
    var contentEl = getContentElement();
    if (!sourceEl || !contentEl) return;
    var rect = sourceEl.getBoundingClientRect(),
      windowRect = document.body.getBoundingClientRect(),
      contentRect = contentEl.getBoundingClientRect();
    var pos = {
      tail: {
        direction: TooltipDirection.Left
      }
    };
    var defaultPad = 8;
    var tailSize = 8;
    function positionCenterY() {
      var sourceCenter = rect.top + rect.height / 2;
      pos.top = sourceCenter - contentRect.height / 2;
      pos.top = Math.max(defaultPad, pos.top);
      var contentCenter = pos.top + contentRect.height / 2;
      var estimatedTop = pos.top + contentRect.height;
      if (estimatedTop > windowRect.height) {
        pos.bottom = 8;
        pos.top = null;
        contentCenter = windowRect.height - 8 - contentRect.height / 2;
      }
      if (contentCenter !== sourceCenter) {
        pos.tail.offset = sourceCenter - contentCenter;
      }
    }
    function positionCenterX() {
      var sourceCenter = rect.left + rect.width / 2;
      pos.left = sourceCenter - contentRect.width / 2;
      pos.left = Math.max(defaultPad, pos.left);
      var contentCenter = pos.left + contentRect.width / 2;
      var estimatedRight = pos.left + contentRect.width;
      if (estimatedRight > windowRect.width) {
        pos.right = 8;
        pos.left = null;
        contentCenter = windowRect.width - 8 - contentRect.width / 2;
      }
      if (contentCenter !== sourceCenter) {
        pos.tail.offset = sourceCenter - contentCenter;
      }
    }
    switch (direction) {
      case TooltipDirection.Left:
        positionCenterY();
        if (rect.left - contentRect.width < 8) {
          pos.left = rect.left + tailSize;
          pos.tail.direction = TooltipDirection.Left;
        } else {
          pos.right = windowRect.width - rect.left + tailSize;
          pos.tail.direction = TooltipDirection.Right;
        }
        break;
      case TooltipDirection.Right:
        {
          var maxX = rect.left + rect.width;
          positionCenterY();
          if (maxX > windowRect.width - tailSize) {
            // If the source is past the endge
            pos.right = defaultPad + tailSize;
            pos.tail.direction = TooltipDirection.Right;
          } else if (maxX + contentRect.width > windowRect.width) {
            // If the source is inset but too close
            pos.right = windowRect.width - rect.right + tailSize;
            pos.tail.direction = TooltipDirection.Right;
          } else {
            pos.left = maxX + tailSize;
            pos.tail.direction = TooltipDirection.Left;
          }
          break;
        }
      case TooltipDirection.Top:
        {
          var desiredBottom = windowRect.height - rect.top;
          positionCenterX();
          if (rect.top < 0) {
            pos.top = rect.bottom + tailSize;
            pos.tail.direction = TooltipDirection.Top;
          } else if (desiredBottom + contentRect.height > windowRect.height) {
            pos.top = rect.top + tailSize;
            pos.tail.direction = TooltipDirection.Top;
          } else {
            pos.bottom = desiredBottom + tailSize;
            pos.tail.direction = TooltipDirection.Bottom;
          }
          break;
        }
      case TooltipDirection.Bottom:
        {
          var desiredTop = rect.bottom;
          positionCenterX();
          if (rect.bottom > windowRect.height) {
            pos.bottom = windowRect.height - rect.top;
            pos.tail.direction = TooltipDirection.Bottom;
          } else if (desiredTop + contentRect.height > windowRect.height) {
            pos.bottom = windowRect.height - rect.bottom;
            pos.tail.direction = TooltipDirection.Bottom;
          } else {
            pos.top = desiredTop;
            pos.tail.direction = TooltipDirection.Top;
          }
        }
        break;
    }
    setPosition(pos);
  }, [direction, getContentElement, getSource]);
  useLayoutEffect(function () {
    calculatePosition();
  }, [isOpen, direction, children, calculatePosition]);
  useEffect(function () {
    if (wantsOpen && !isOpen) setOpen();else if (!wantsOpen && isOpen) {
      var timeout = setTimeout(setClosed, 150);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [isOpen, setClosed, setOpen, wantsOpen]);

  // MARK : Managing Open State
  // -------------------------------------------------------------------------------

  useEffect(function () {
    var triggerEl = getTrigger();
    if (!triggerEl) return;
    var openEvents = ["focus", "mouseenter"];
    var closeEvents = ["blur", "mouseleave"];
    var elements = [triggerEl];
    var contentEl = getContentElement();
    if (contentEl && interactive) elements.push(contentEl);
    openEvents.forEach(function (e) {
      return elements.forEach(function (el) {
        return el.addEventListener(e, setWantsOpen);
      });
    });
    closeEvents.forEach(function (e) {
      return elements.forEach(function (el) {
        return el.addEventListener(e, setWantsClosed);
      });
    });
    return function () {
      openEvents.forEach(function (e) {
        return elements.forEach(function (el) {
          return el.removeEventListener(e, setWantsOpen);
        });
      });
      closeEvents.forEach(function (e) {
        return elements.forEach(function (el) {
          return el.removeEventListener(e, setWantsClosed);
        });
      });
    };
  }, [getContentElement, getTrigger, wantsOpen, setWantsClosed, setWantsOpen]);
  useEffect(function () {
    if (isOpen) window.addEventListener("scroll", calculatePosition, true);
    return function () {
      window.removeEventListener("scroll", calculatePosition, true);
    };
  }, [calculatePosition, isOpen]);

  // MARK : Rendering
  // -------------------------------------------------------------------------------
  function renderContent() {
    return /*#__PURE__*/React.createElement(Text, {
      as: "span",
      font: "ui.small",
      color: "white"
    }, children);
  }
  function renderTooltip() {
    var tail = position.tail,
      style = _objectWithoutProperties(position, _excluded2$1);
    return (
      /*#__PURE__*/
      // Use style instead of passing the position props via Box/Flex
      // to avoid styled components generating too many classes
      React.createElement(Wrapper$4, _extends({
        id: contentIdentifier,
        "data-testid": "tooltip-wrapper",
        tooltipPositioning: style,
        onClick: close
      }, props, {
        isOpen: isOpen,
        role: "tooltip"
      }), /*#__PURE__*/React.createElement(TooltipTail$1, tail), /*#__PURE__*/React.createElement(Flex$1, {
        flexDirection: "column",
        alignItems: "center",
        maxHeight: "368",
        overflow: "auto",
        "data-testid": "tooltip-content",
        p: "s"
      }, renderContent()))
    );
  }
  return /*#__PURE__*/createPortal(renderTooltip(), document.body);
};
Tooltip.Direction = TooltipDirection;
var Tooltip$1 = Tooltip;

var Badge = function Badge(_ref) {
  var id = _ref.id,
    text = _ref.text,
    _ref$font = _ref.font,
    font = _ref$font === void 0 ? "ui.smallBold" : _ref$font,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? "white" : _ref$textColor,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? "info" : _ref$background,
    tooltip = _ref.tooltip;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box$1, {
    background: background,
    p: "2px 4px",
    borderRadius: "default",
    "data-tooltip-source": id
  }, /*#__PURE__*/React.createElement(Text, {
    font: font,
    color: textColor
  }, text)), tooltip && /*#__PURE__*/React.createElement(Tooltip$1, {
    border: "none",
    direction: Tooltip$1.Direction.Bottom,
    source: id,
    minWidth: "40",
    maxWidth: "250"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    font: "ui.small"
  }, tooltip, " ", /*#__PURE__*/React.createElement(Button$1, {
    fontStyle: "ui.smallBold",
    size: "small",
    buttonStyle: "tertiary",
    link: "/pricing",
    text: "View plans",
    themeOverrides: {
      primaryColor: "white",
      primaryColorDark: "white"
    },
    newWindow: true
  }))));
};

var CheckboxWrapper = styled(Flex$1).attrs({}).withConfig({
  displayName: "Checkbox__CheckboxWrapper"
})(["input[type=\"checkbox\"]{display:none;}"]);
var Checkbox$1 = function Checkbox(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "checkbox" : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "regular" : _ref$size,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? false : _ref$truncate,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    styleOverrides = _ref.styleOverrides;
  var iconState = isSelected ? "checked" : "unchecked";
  var iconId = type === "indeterminate" ? "action.checkbox-indeterminate" : "".concat(type, "-").concat(iconState);
  var theme = useContext(ThemeContext);
  var fill = disabled ? getColor("grayDark") : getColor(theme && theme.primaryColor || "primary");
  var text = label;
  // Wrap string label in a Text element
  // Non string labels are typically used to include a text link in the label
  if (typeof label === "string") {
    text = /*#__PURE__*/React.createElement(Text, {
      font: size === "small" ? "ui.small" : "ui.regular",
      truncate: truncate,
      color: disabled ? "grayDarker" : "black"
    }, label);
  }
  return /*#__PURE__*/React.createElement(CheckboxWrapper, _extends({
    as: "label",
    style: {
      cursor: disabled ? "not-allowed" : "pointer"
    },
    alignItems: "center",
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, styleOverrides), /*#__PURE__*/React.createElement("input", {
    "data-testid": id,
    type: "checkbox",
    "aria-checked": isSelected,
    checked: isSelected,
    onChange: disabled ? null : onClick,
    disabled: disabled,
    role: type === "radio" ? "radio" : "checkbox"
  }), /*#__PURE__*/React.createElement(Icon$1, {
    disabled: disabled,
    flexShrink: "0",
    fill: fill,
    iconId: iconId,
    size: size === "small" ? "16" : undefined,
    mr: text ? "xs" : null,
    "aria-hidden": true
  }), text);
};
var Checkbox$2 = Checkbox$1;

function variableStyle(props) {
  var gridTemplateColumns = props.templateColumns;
  if (Number.isInteger(Number(gridTemplateColumns))) {
    gridTemplateColumns = "repeat(".concat(gridTemplateColumns, ", 1fr)");
  }
  return css(["grid-template-columns:", ";gap:", ";", ""], gridTemplateColumns, props.gap, getVariations(props, variableStyle));
}
var Grid = styled(Box$1).withConfig({
  displayName: "Grid"
})(["display:grid;", ""], variableStyle);
var Grid$1 = Grid;

var _excluded$n = ["id", "alt", "src", "srcFallback", "onDragStart", "onLoad", "icon", "iconSize", "iconFill", "cover"];
var imageAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var ContainImage = styled.img.withConfig({
  displayName: "ImageView__ContainImage"
})(["", " max-height:100%;max-width:100%;animation:", " 0.3s ease;"], centered, imageAnimation);
var CoverImage = styled(Box$1).withConfig({
  displayName: "ImageView__CoverImage"
})(["", " width:100%;height:100%;background:", ";background-position:center;background-size:cover;animation:", " 0.3s ease;"], centered, function (props) {
  return "url(".concat(props.src, ")");
}, imageAnimation);
// Wrap in styled to support built in props
var ImageView = function ImageView(_ref) {
  var id = _ref.id,
    alt = _ref.alt,
    src = _ref.src,
    srcFallback = _ref.srcFallback,
    onDragStart = _ref.onDragStart,
    onLoad = _ref.onLoad,
    icon = _ref.icon,
    iconSize = _ref.iconSize,
    iconFill = _ref.iconFill,
    cover = _ref.cover,
    otherProps = _objectWithoutProperties(_ref, _excluded$n);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    loadedSrc = _useState2[0],
    setLoadedSrc = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var onImageLoad = useCallback(function () {
    setLoadedSrc(src);
    setLoaded(true);
    if (onLoad) onLoad(true);
  }, [src, onLoad]);
  var onImageError = useCallback(function () {
    setLoadedSrc(srcFallback);
    setLoaded(true);
    if (onLoad) onLoad(false);
  }, [srcFallback, onLoad]);
  var onImageFallbackLoad = useCallback(function () {
    setLoadedSrc(srcFallback);
    setLoaded(true);
  }, [srcFallback]);
  useLayoutEffect(function () {
    if (src !== loadedSrc) {
      setLoaded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);
  useEffect(function () {
    if (!src) {
      if (loadedSrc) {
        onImageFallbackLoad();
      }
      return;
    }
    var img = new Image();
    img.src = src;
    img.addEventListener("load", onImageLoad);
    img.addEventListener("error", onImageError);
    return function () {
      img.removeEventListener("load", onImageLoad);
      img.removeEventListener("error", onImageError);
    };
  }, [onImageFallbackLoad, onImageError, onImageLoad, src, loadedSrc, srcFallback]);
  function renderIcon() {
    return icon ? /*#__PURE__*/React.createElement(Icon$1, {
      "data-testid": "image-view-icon",
      coverParent: true,
      fill: getColor(iconFill, "grayDark"),
      iconId: icon,
      size: iconSize
    }) : null;
  }
  function renderThumb() {
    var Comp = cover ? CoverImage : ContainImage;
    return /*#__PURE__*/React.createElement(Comp, {
      alt: alt,
      "data-testid": "image-view-image",
      src: loadedSrc,
      onDragStart: onDragStart
    });
  }
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    "data-testid": id,
    flexShrink: "0",
    overflow: "hidden"
  }, otherProps), loaded && loadedSrc ? renderThumb() : renderIcon());
};
var ImageView$1 = ImageView;

var _excluded$m = ["id", "label", "message", "inputStyle", "size", "children", "font", "disabled", "readOnly", "autoFocus", "autoSelect", "onSubmit", "styleOverrides"];
var Element = styled.input.withConfig({
  displayName: "Input__Element"
})(["width:100%;border:", ";border-radius:", ";background:white;box-sizing:border-box;", ";", " ", " &::placeholder{", ";color:", ";}&.active,&:focus{border:", ";outline:none;}&.error{border:", ";}&.disabled,&:read-only{border:", ";background:", ";color:", ";}&[type=\"search\"]{-webkit-appearance:textfield;}&[type=\"text\"]::-ms-clear{display:none;width:0;height:0;}&[type=\"text\"]::-ms-reveal{display:none;width:0;height:0;}&[type=\"search\"]::-webkit-search-decoration,&[type=\"search\"]::-webkit-search-cancel-button,&[type=\"search\"]::-webkit-search-results-button,&[type=\"search\"]::-webkit-search-results-decoration{-webkit-appearance:none;display:none;}"], getBorder("1px solid border"), function (props) {
  var _props$theme;
  return getBorderRadius(props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default");
}, function (props) {
  return getFont(props.font, props.defaultFontSize, props);
}, function (props) {
  return positioningCSS({
    px: "8px",
    py: "5px",
    height: props.height
  });
}, positioningCSS, function (props) {
  return getFont(props.font, props.defaultFontSize, props);
}, color.grayDark, getBorder("1px solid focus"), getBorder("1px solid error"), getBorder("1px solid border"), color.grayLighter, color.grayDarker);
var Input$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    message = _ref.message,
    inputStyle = _ref.inputStyle,
    size = _ref.size,
    children = _ref.children,
    font = _ref.font,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    autoFocus = _ref.autoFocus,
    autoSelect = _ref.autoSelect,
    _onSubmit = _ref.onSubmit,
    styleOverrides = _ref.styleOverrides,
    inputAttributes = _objectWithoutProperties(_ref, _excluded$m);
  var inputRef = useRef();
  var innerRef = ref || inputRef;
  useEffect(function () {
    if (autoFocus) {
      var _innerRef$current;
      innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.focus();
    }
    if (autoSelect) {
      var _innerRef$current2;
      innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current2 = innerRef.current) === null || _innerRef$current2 === void 0 ? void 0 : _innerRef$current2.select();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getIcon() {
    switch (inputStyle) {
      case "error":
        return /*#__PURE__*/React.createElement(Icon$1, {
          size: "16",
          fill: "error",
          iconId: "error",
          pr: "xs"
        });
      case "success":
        return /*#__PURE__*/React.createElement(Icon$1, {
          size: "16",
          fill: "success",
          iconId: "checkmark",
          pr: "xs"
        });
      case "warning":
        return /*#__PURE__*/React.createElement(Icon$1, {
          size: "16",
          fill: "warning",
          iconId: "warning",
          pr: "xs"
        });
      default:
        return null;
    }
  }
  function renderContent() {
    var height = size === "small" ? "28px" : "36px",
      defaultFontSize = size === "small" ? "ui.small" : "ui.regular";
    return /*#__PURE__*/React.createElement(Flex$1, {
      alignItems: "center",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Element, _extends({
      id: id,
      role: "textbox",
      ref: innerRef,
      disabled: disabled,
      readOnly: readOnly,
      className: disabled || readOnly ? "disabled" : inputStyle,
      defaultFontSize: defaultFontSize,
      height: height,
      font: font
    }, inputAttributes)), children);
  }
  function renderForm() {
    if (!_onSubmit) {
      return renderContent();
    }
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        if (_onSubmit) _onSubmit(e);
      }
    }, renderContent());
  }
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    "data-testid": id,
    width: "100%"
  }, styleOverrides), label ? /*#__PURE__*/React.createElement(Text, {
    as: "label",
    "data-testid": "input-label",
    display: "block",
    color: "black",
    mb: "4px",
    htmlFor: id,
    textAlign: "left"
  }, label) : null, renderForm(), message ? /*#__PURE__*/React.createElement(Flex$1, {
    "data-testid": "input-message",
    ml: "s",
    flexDirection: "row",
    alignItems: "center"
  }, getIcon(), /*#__PURE__*/React.createElement(Text, {
    my: "xs",
    font: "ui.small",
    color: inputStyle === "error" ? "error" : "black"
  }, message)) : null);
});
Input$1.displayName = "Input";
var Input$2 = Input$1;

function useWindowSize() {
  function getSize() {
    if (!isBrowser()) {
      return {
        width: 0,
        height: 0,
        belowInspectorThreshold: false
      };
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      // Custom screen size metric bools
      belowInspectorThreshold: window.innerWidth <= 1200,
      isMobile: window.innerWidth <= 768
    };
  }
  var _useState = useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return useMemo(function () {
    return windowSize;
  }, [windowSize]);
}

var _excluded$l = ["source", "open", "vPos", "hPos", "width", "maxHeight", "close", "stayOpenOnClick", "clickAwayClose", "id", "children"];
var MenuContainer = styled(Flex$1).attrs(function (props) {
  return {
    maxWidth: "100%",
    border: "default",
    background: "white",
    boxShadow: "panel",
    width: props.width || 236,
    flexDirection: "column",
    position: props.position || "absolute",
    display: "block",
    borderRadius: "default",
    overflow: "hidden",
    zIndex: 51000
  };
}).withConfig({
  displayName: "PopupMenu__MenuContainer"
})(["line-height:30px;"]);
var PopupMenu$1 = function PopupMenu(_ref) {
  var source = _ref.source,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? true : _ref$open,
    _ref$vPos = _ref.vPos,
    vPos = _ref$vPos === void 0 ? "floatBelow" : _ref$vPos,
    _ref$hPos = _ref.hPos,
    hPos = _ref$hPos === void 0 ? "alignLeft" : _ref$hPos,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 236 : _ref$width,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? 368 : _ref$maxHeight,
    close = _ref.close,
    _ref$stayOpenOnClick = _ref.stayOpenOnClick,
    stayOpenOnClick = _ref$stayOpenOnClick === void 0 ? false : _ref$stayOpenOnClick,
    _ref$clickAwayClose = _ref.clickAwayClose,
    clickAwayClose = _ref$clickAwayClose === void 0 ? true : _ref$clickAwayClose,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$l);
  // const [bodyStyle, setBodyStyle] = useState<Record<string, string>>();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var contentIdentifier = useRef(factory.genString());
  var windowSize = useWindowSize();
  useEffect(function () {
    function preventScroll() {
      // Allows all scrolling to happen within the overlay, and saves previous scroll position.
      var body = document.querySelector("body");
      body.style.overflow = "hidden";
    }
    function restoreScroll() {
      // Restores scroll position to state before overlay was opened.
      var body = document.querySelector("body");
      body.style.overflow = null;
    }
    if (open) preventScroll();else restoreScroll();
    return function () {
      return restoreScroll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  var calculatePosition = useCallback(function () {
    var sourceEl;
    if (typeof source === "string") {
      try {
        sourceEl = document.querySelector(source);
      } catch (_unused) {
        // Retry another selector below
      }
      if (!sourceEl) sourceEl = document.querySelector("[data-popup-source='".concat(source, "']"));
    } else {
      sourceEl = source;
    }
    if (!sourceEl || !sourceEl.getBoundingClientRect) {
      // Something about the test environment causes this querySelector to fail
      // and this log pollutes the test output.
      if (_lingoConfig.environment !== "test-runner") {
        var _sourceEl;
        console.error("Unable to find source element ".concat(source), sourceEl, (_sourceEl = sourceEl) === null || _sourceEl === void 0 ? void 0 : _sourceEl.getBoundingClientRect);
      }
      return;
    }
    var rect = sourceEl.getBoundingClientRect(),
      windowRect = document.body.getBoundingClientRect(),
      contentEl = document.body.querySelector("#".concat(contentIdentifier.current)),
      contentRect = contentEl.getBoundingClientRect();
    var transform = {
      x: 0,
      y: 0
    };
    var pos = {
      width: Number(width)
    };
    switch (hPos) {
      case "alignLeft":
        if (rect.left + contentRect.width > windowRect.width) {
          pos.right = "s";
        } else {
          pos.left = rect.left;
        }
        break;
      case "alignRight":
        if (rect.left + rect.width < contentRect.width) pos.left = "s";else {
          pos.left = rect.left + rect.width;
          transform.x = "-100%";
        }
        break;
      case "center":
        {
          var center = rect.left + rect.width / 2;
          if (center + contentRect.width / 2 > windowRect.width) {
            pos.right = "s";
          } else if (center < contentRect.width / 2) {
            pos.left = "s";
          } else {
            pos.left = center - contentRect.width / 2;
          }
          break;
        }
      case "floatLeft":
        if (rect.left < contentRect.width) {
          pos.left = "s";
        } else {
          pos.left = rect.left;
          transform.x = "-100%";
        }
        break;
      case "floatRight":
        if (rect.left + rect.width + contentRect.width > windowRect.width) {
          pos.right = "s";
        } else {
          pos.left = rect.left + rect.width;
        }
        break;
    }
    switch (vPos) {
      case "alignTop":
        if (rect.top + contentRect.height > windowRect.height) {
          pos.bottom = "s";
        } else {
          pos.top = rect.top;
        }
        break;
      case "alignBottom":
        if (rect.top + rect.height < contentRect.height) {
          pos.top = "s";
        } else {
          pos.top = rect.top + rect.height;
          transform.y = "-100%";
        }
        break;
      case "center":
        {
          var _center = rect.top + rect.height / 2;
          if (_center + contentRect.height / 2 > windowRect.height) {
            pos.bottom = "s";
          } else if (_center < contentRect.height / 2) {
            pos.top = "s";
          } else {
            pos.top = rect.top;
            transform.y = "-50%";
          }
          break;
        }
      case "floatAbove":
        if (rect.top < contentRect.height) {
          pos.top = "s";
        } else {
          pos.top = rect.top;
          transform.y = "-100%";
        }
        break;
      case "floatBelow":
        if (rect.top + rect.height + contentRect.height > windowRect.height) {
          pos.bottom = "s";
        } else {
          pos.top = rect.top + rect.height;
        }
        break;
    }
    pos.transform = "translate(".concat(transform.x, ", ").concat(transform.y, ")");
    setPosition(pos);
  }, [hPos, source, vPos, width]);
  useLayoutEffect(function () {
    if (!open) return;
    calculatePosition();
  }, [hPos, open, vPos, width, windowSize, children, calculatePosition]);
  var noBubble = useCallback(function (e) {
    return e.stopPropagation();
  }, []);
  if (!open) return null;
  function renderMenu() {
    return /*#__PURE__*/React.createElement(MenuContainer, _extends({}, position, {
      "data-testid": id,
      onClick: !stayOpenOnClick ? close : undefined,
      position: clickAwayClose ? "absolute" : "fixed"
    }, props), /*#__PURE__*/React.createElement(Flex$1, {
      id: contentIdentifier.current,
      flexDirection: "column",
      maxHeight: maxHeight,
      overflow: "auto",
      "data-testid": "popup-menu-content"
    }, children));
  }
  function renderWrappedMenu() {
    return /*#__PURE__*/React.createElement(Box$1, {
      zIndex: "50000",
      position: "fixed",
      top: "0",
      bottom: "0",
      right: "0",
      left: "0",
      onClick: noBubble,
      onDoubleClick: noBubble
    }, /*#__PURE__*/React.createElement(Box$1, {
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "0",
      left: "0",
      onClick: close
    }), renderMenu());
  }
  return /*#__PURE__*/createPortal(clickAwayClose ? renderWrappedMenu() : renderMenu(), document.body);
};
var PopupMenu$2 = PopupMenu$1;

var _excluded$k = ["id", "title", "onClick", "link", "image", "font", "children", "checked", "disabled", "truncate", "bordered", "badge", "tooltip", "accessory", "hPos", "isActive", "innerRef"],
  _excluded2 = ["src", "iconId", "imageStyle"];
// Wes: I believe this consumes clicks on disabled/non-clickable PopupMenu items
// Without it the click is passed through the menu which closes the menu
function noOp(e) {
  e.preventDefault();
  e.stopPropagation();
}
var ItemWrapper$1 = styled(Flex$1).attrs(function (props) {
  return {
    p: "8px",
    alignItems: props.alignItems || "center",
    background: props.isActive ? "grayLighter" : "white",
    textAlign: "left",
    variations: {
      "&:hover": {
        background: "grayLighter"
      },
      "&:last-of-type": {
        borderBottom: "none"
      }
    },
    style: {
      cursor: props.disabled ? "not-allowed" : "pointer",
      opacity: props.disabled ? 0.5 : 1
    }
  };
}).withConfig({
  displayName: "Item__ItemWrapper"
})(["", ""], positioningCSS);
var Pill$2 = styled.span.withConfig({
  displayName: "Item__Pill"
})(["background:", ";color:white;padding:4px 8px;border-radius:4px;", ""], color.info, font.ui.smallBold);
var Item$3 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    title = _ref.title,
    onClick = _ref.onClick,
    link = _ref.link,
    image = _ref.image,
    _ref$font = _ref.font,
    font = _ref$font === void 0 ? "ui.regular" : _ref$font,
    children = _ref.children,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? false : _ref$truncate,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? false : _ref$bordered,
    badge = _ref.badge,
    tooltip = _ref.tooltip,
    accessory = _ref.accessory,
    hPos = _ref.hPos,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    innerRef = _ref.innerRef,
    other = _objectWithoutProperties(_ref, _excluded$k);
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 3),
    nestedOpen = _useBoolean2[0],
    openNested = _useBoolean2[1],
    closeNested = _useBoolean2[2];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  var nestedPopupKey = useMemo(function () {
    return v4();
  }, []);
  function renderImage() {
    if (!image) return null;
    var src = image.src,
      iconId = image.iconId,
      imageStyle = image.imageStyle,
      imageProps = _objectWithoutProperties(image, _excluded2);
    if (src) {
      var rounded = imageStyle === "circle" ? "50%" : "default";
      return /*#__PURE__*/React.createElement(ImageView$1, _extends({
        mr: "s",
        iconSize: 16 ,
        icon: iconId,
        width: 24 ,
        height: 24 ,
        src: src,
        cover: true,
        background: "grayLighter",
        iconFill: imageProps.fill || "grayDark",
        borderRadius: rounded
      }, imageProps));
    }
    if (iconId) return /*#__PURE__*/React.createElement(Icon$1, _extends({
      mr: "xs",
      iconId: iconId,
      fill: "black"
    }, imageProps));
    return null;
  }
  function renderContent() {
    var popupSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return /*#__PURE__*/React.createElement(LinkWrapper$1, {
      disabled: disabled,
      title: typeof title === "string" ? title : "",
      link: link
    }, /*#__PURE__*/React.createElement(ItemWrapper$1, _extends({
      "data-tooltip-source": id,
      "data-testid": id,
      onClick: disabled ? noOp : onClick,
      "data-popup-source": popupSource,
      disabled: disabled,
      borderBottom: bordered ? "default" : null,
      isActive: isActive,
      ref: ref || innerRef
    }, other), checked ? /*#__PURE__*/React.createElement(Icon$1, {
      flexShrink: "0",
      flexGrow: "0",
      iconId: "checkmark",
      fill: "black",
      mr: "xs",
      size: "16"
    }) : /*#__PURE__*/React.createElement(Box$1, {
      flexShrink: "0",
      mr: "xs",
      width: "16",
      height: "16"
    }), renderImage(), typeof title === "string" ? /*#__PURE__*/React.createElement(Text, {
      truncate: truncate,
      flex: "1",
      title: title,
      font: font
    }, title) : title, accessory, badge && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill$2, null, badge)), tooltip && /*#__PURE__*/React.createElement(Tooltip$1, {
      width: 230,
      direction: "bottom",
      source: id
    }, tooltip)));
  }
  function renderAsNested() {
    accessory = accessory || /*#__PURE__*/React.createElement(Icon$1, {
      iconId: "triangle-collapsed",
      justifySelf: "center",
      size: "16"
    });
    onClick = onClick || noOp;
    return /*#__PURE__*/React.createElement(Box$1, {
      onMouseEnter: openNested,
      onMouseLeave: closeNested
    }, renderContent(nestedPopupKey), nestedOpen && /*#__PURE__*/React.createElement(PopupMenu$2, {
      hPos: hPos ? hPos : "floatRight",
      vPos: "alignTop",
      source: nestedPopupKey,
      close: closeNested,
      clickAwayClose: false
    }, children));
  }
  return children ? renderAsNested() : renderContent();
});
Item$3.displayName = "Item";
var Item$4 = Item$3;

var _excluded$j = ["id", "title", "children", "button"];
function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SectionHeading = styled(Flex$1).attrs({
  background: "grayLightest",
  borderBottom: "default",
  flexDirection: "row",
  px: "m",
  py: "xs",
  justifyContent: "space-between",
  textAlign: "left",
  position: "sticky",
  top: 0,
  zIndex: 5
}).withConfig({
  displayName: "Section__SectionHeading"
})([""]);

// Wrapper is used to avoid adding a border to the first section header
// but still contain the contents of each section
var SectionContainer = styled(Box$1).attrs(function (props) {
  return _objectSpread$a({
    borderTop: "default",
    variations: {
      "&:first-child": {
        borderTop: "none"
      }
    }
  }, props);
}).withConfig({
  displayName: "Section__SectionContainer"
})([""]);
var Section = function Section(_ref) {
  var id = _ref.id,
    title = _ref.title,
    children = _ref.children,
    button = _ref.button,
    rest = _objectWithoutProperties(_ref, _excluded$j);
  function renderHeader() {
    var headerButton = function () {
      if (!button || !button.text) return null;
      return /*#__PURE__*/React.createElement(Button$1, _extends({}, button, {
        buttonStyle: "tertiary",
        size: "small",
        m: 0
      }));
    }();
    if (!title && !headerButton) return null;
    return /*#__PURE__*/React.createElement(SectionHeading, {
      "data-testid": "menu-section-heading"
    }, /*#__PURE__*/React.createElement(Text, {
      truncate: true,
      font: "ui.smallBold",
      color: "grayDarkest"
    }, title), headerButton);
  }
  var header = renderHeader();
  if (!header && !children) return null;
  return /*#__PURE__*/React.createElement(SectionContainer, _extends({
    "data-testid": id
  }, rest), header, children);
};
var Section$1 = Section;

var Dialog = function Dialog(_ref) {
  var text = _ref.text,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "grayDarkest" : _ref$color,
    _ref$borderBottom = _ref.borderBottom,
    borderBottom = _ref$borderBottom === void 0 ? "default" : _ref$borderBottom,
    _ref$borderTop = _ref.borderTop,
    borderTop = _ref$borderTop === void 0 ? "none" : _ref$borderTop,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? "white" : _ref$background;
  return /*#__PURE__*/React.createElement(Box$1, {
    p: "s",
    borderBottom: borderBottom,
    borderTop: borderTop,
    background: background
  }, /*#__PURE__*/React.createElement(Text, {
    ml: "20px",
    font: "ui.smallBold",
    color: color
  }, text));
};
var Dialog$1 = Dialog;

var ContextMenuAnchor = styled.div.withConfig({
  displayName: "ContextMenuAnchor"
})(["position:fixed;top:", ";left:", ";height:1px;width:1px;background:transparent;pointer-events:none;"], function (props) {
  return props.yPos;
}, function (props) {
  return props.xPos;
});
var ContextMenuAnchor$1 = ContextMenuAnchor;

var MenuItemRenderer = function MenuItemRenderer(_ref) {
  var menuItems = _ref.menuItems;
  return /*#__PURE__*/React.createElement(React.Fragment, null, menuItems.map(function (menuItem, index) {
    switch (menuItem.type) {
      case "Item":
        return /*#__PURE__*/React.createElement(Item$4, _extends({}, menuItem.itemProps, {
          key: index
        }));
      case "Dialog":
        return /*#__PURE__*/React.createElement(Dialog$1, _extends({}, menuItem.dialogProps, {
          key: index
        }));
      default:
        return null;
    }
  }));
};
var MenuItemRenderer$1 = MenuItemRenderer;

var Component$7 = PopupMenu$2;
Component$7.Item = Item$4;
Component$7.Dialog = Dialog$1;
Component$7.Section = Section$1;
Component$7.ContextMenuAnchor = ContextMenuAnchor$1;
Component$7.MenuContainer = MenuContainer;
Component$7.MenuItemRenderer = MenuItemRenderer$1;
var PopupMenu = Component$7;

/**
 * Pluralize helper function
 * @param {string} word
 * @param {number} length
 * @returns Singular or plural string
 */
function pluralize(word, length) {
  if (length !== 1) word += "s";
  return word;
}

function getVerticalDragDirection(e, dragRef) {
  var dragEventY = e.pageY;
  var sideY = "top";
  /**
   * Null check the ref for tests
   */
  if (dragRef.current) {
    var _dragRef$current$getB = dragRef.current.getBoundingClientRect(),
      bottom = _dragRef$current$getB.bottom,
      top = _dragRef$current$getB.top;
    sideY = Math.abs(top - dragEventY) < Math.abs(bottom - dragEventY) ? "top" : "bottom";
  }
  return sideY;
}
function getHorizontalDragDirection(e, dragRef) {
  var dragEventX = e.pageX;
  var sideX = "left";

  /**
   * Null check the ref for tests
   */
  if (dragRef.current) {
    var _dragRef$current$getB2 = dragRef.current.getBoundingClientRect(),
      left = _dragRef$current$getB2.left,
      right = _dragRef$current$getB2.right;
    sideX = Math.abs(left - dragEventX) < Math.abs(right - dragEventX) ? "left" : "right";
  }
  return sideX;
}

function useDrag(_ref) {
  var dragRef = _ref.dragRef,
    doOnDragStart = _ref.doOnDragStart,
    doOnDragOver = _ref.doOnDragOver,
    doOnDragEnd = _ref.doOnDragEnd,
    doOnDragLeave = _ref.doOnDragLeave,
    doOnDrop = _ref.doOnDrop;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dragDirection = _React$useState2[0],
    setDragDirection = _React$useState2[1];
  var onDragStart = function onDragStart(e) {
    if (doOnDragStart) doOnDragStart(e);
  };
  var onDragOver = function onDragOver(e) {
    if (e) e.preventDefault();
    if (doOnDragOver) doOnDragOver(e);
    var h = getHorizontalDragDirection(e, dragRef);
    var v = getVerticalDragDirection(e, dragRef);
    if (h !== (dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.horizontal) || v !== (dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.vertical)) setDragDirection({
      horizontal: h,
      vertical: v
    });
  };
  var onDragEnd = function onDragEnd(e) {
    if (e) e.preventDefault();
    if (doOnDragEnd) doOnDragEnd(e);
    setDragDirection(null);
  };
  var onDragLeave = function onDragLeave(e) {
    if (e) e.preventDefault();
    if (doOnDragLeave) doOnDragLeave(e);
    setDragDirection(null);
  };
  var onDrop = function onDrop(e) {
    if (e) e.preventDefault();
    if (doOnDrop) doOnDrop(e);
    setDragDirection(null);
  };
  return {
    dragDirection: dragDirection,
    dragProps: {
      draggable: true,
      onDragStart: onDragStart,
      onDragOver: onDragOver,
      onDragEnd: onDragEnd,
      onDragLeave: onDragLeave,
      onDrop: onDrop
    }
  };
}

var retiredThemeNameMap = {
  pismo: SpaceThemeNames.wyman,
  dockweiler: SpaceThemeNames.scher
};
function useSpaceThemeName() {
  var theme = useTheme();
  var themeName = React.useMemo(function () {
    if (retiredThemeNameMap[theme === null || theme === void 0 ? void 0 : theme.themeName]) return retiredThemeNameMap[theme === null || theme === void 0 ? void 0 : theme.themeName];
    return (theme === null || theme === void 0 ? void 0 : theme.themeName) || SpaceThemeNames.classic;
  }, [theme]);
  return themeName;
}

var _iconMap;
function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var KitCardWrapper = styled(Box$1).withConfig({
  displayName: "KitCard__KitCardWrapper"
})(["cursor:pointer;background-color:", ";transition:background-color 0.3s ease;&:before,&:after{top:0;content:\"\";height:100%;width:4px;background:", ";position:absolute;border-radius:4px;}&:after{right:-12px;", "}&:before{left:-12px;", "}", " .hover{opacity:", ";background:linear-gradient( 180deg,rgba(42,42,42,0) 0%,rgba(42,42,42,0.45) 36.98%,rgba(42,42,42,0.9) 88.02% );transition:opacity 0.3s ease;}&:hover{.hover{opacity:1;}}"], color.white, function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.dragStyle !== "right" && "\n      opacity: 0;\n      display: none;\n    ";
}, function (props) {
  return props.dragStyle !== "left" && "\n      opacity: 0;\n      display: none;\n    ";
}, function (_ref) {
  var theme = _ref.theme;
  return theme.themeName === SpaceThemeNames.wyman && ":hover {\n    background-color: ".concat(color.grayLightest, "\n    }");
}, function (props) {
  return props.showOverlay ? "1" : "0";
});
var KitDescription = styled(Text).attrs({}).withConfig({
  displayName: "KitCard__KitDescription"
})(["overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical;"]);
var iconMap = (_iconMap = {}, _defineProperty(_iconMap, PrivacyLevel.public, "globe"), _defineProperty(_iconMap, PrivacyLevel.private, "users"), _defineProperty(_iconMap, PrivacyLevel.password, "globe-lock"), _iconMap);

/**
 *
 * Renders a kit card including an image, name, and description.
 *
 * The buttons on the card are shown based on the provided props:
 * Favorite button: setFavorited && kit.access.permissions.includes("favorite")
 * Overflow button: menuItems
 * @param {Object} props
 */
var KitCard = function KitCard(_ref2) {
  var _buttonThemeVals, _memberCountTextTheme, _normalKitCardThemeVa;
  var id = _ref2.id,
    kit = _ref2.kit,
    space = _ref2.space,
    onClick = _ref2.onClick,
    setFavorited = _ref2.setFavorited,
    menuItems = _ref2.menuItems,
    kitCollectionId = _ref2.kitCollectionId,
    reorderKitCollectionItems = _ref2.reorderKitCollectionItems,
    identifier = _ref2.identifier;
  var themeName = useSpaceThemeName();
  var dragRef = useRef(null);
  var permissions = kit.access.permissions || [],
    spacePermissions = ((space || {}).access || {}).permissions || [],
    canFavorite = setFavorited && permissions.includes("favorite"),
    canViewMembers = spacePermissions.includes("view_members"),
    isFavorited = kit.access.isFavorite;
  var _useDrag = useDrag({
      dragRef: dragRef,
      doOnDragStart: function doOnDragStart(e) {
        return e.dataTransfer.setData("kitId", kit.kitId);
      },
      doOnDrop: function doOnDrop(e) {
        var droppingId = e.dataTransfer.getData("kitId");
        if (kit.kitId === droppingId) return;
        var displayDirection = (dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.horizontal) === "left" ? "before" : "after";
        reorderKitCollectionItems({
          kitId: droppingId,
          kitCollectionId: kitCollectionId,
          displayOrder: "".concat(displayDirection, ":").concat(kit.kitId)
        });
      }
    }),
    dragDirection = _useDrag.dragDirection,
    dragProps = _useDrag.dragProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuVisible = _useState2[0],
    setMenuVisible = _useState2[1];
  var menuId = identifier ? "".concat(kit.kitId, "-").concat(identifier, "-overflow-menu") : "".concat(kit.kitId, "-overflow-menu");
  var menu = menuVisible && menuItems ? /*#__PURE__*/React.createElement(PopupMenu, {
    source: menuId,
    id: "kit-card-menu",
    verticalPosition: "below",
    close: function close() {
      return setMenuVisible(!menuVisible);
    }
  }, menuItems) : null;
  var handleClick = function handleClick() {
    onClick(kit);
  };
  var buttonThemeVals = (_buttonThemeVals = {}, _defineProperty(_buttonThemeVals, SpaceThemeNames.classic, {
    themeOverrides: {
      primaryColor: "black"
    }
  }), _defineProperty(_buttonThemeVals, SpaceThemeNames.scher, {
    themeOverrides: {
      primaryColor: "white"
    }
  }), _defineProperty(_buttonThemeVals, SpaceThemeNames.wyman, {
    themeOverrides: {
      primaryColor: "black"
    }
  }), _buttonThemeVals);
  var buttonOverrides = buttonThemeVals[themeName];
  function renderFavoriteButton() {
    return /*#__PURE__*/React.createElement(Button$1, _extends({
      id: "favorite-button",
      buttonStyle: "tertiary",
      icon: isFavorited ? "star-filled" : "star",
      m: "none",
      ml: "xs",
      p: "none",
      width: "24",
      height: "24",
      background: "none",
      onClick: function onClick(e) {
        e.stopPropagation();
        setFavorited(kit, !isFavorited);
      }
    }, buttonOverrides));
  }
  function renderOverflowButton() {
    return /*#__PURE__*/React.createElement(Button$1, _extends({
      id: "overflow-button",
      "data-popup-source": menuId,
      buttonStyle: "tertiary",
      icon: "overflow",
      width: "24",
      height: "24",
      onClick: function onClick(e) {
        e.stopPropagation();
        setMenuVisible(!menuVisible);
      }
    }, buttonOverrides));
  }
  var memberCountTextThemeVals = (_memberCountTextTheme = {}, _defineProperty(_memberCountTextTheme, SpaceThemeNames.classic, {
    color: "grayDarker"
  }), _defineProperty(_memberCountTextTheme, SpaceThemeNames.scher, {
    color: "white"
  }), _memberCountTextTheme);
  function renderMemberCount() {
    var overrides = memberCountTextThemeVals[themeName];
    return /*#__PURE__*/React.createElement(Text, _extends({
      id: "member-count",
      my: "none",
      p: "none",
      font: "ui.small"
    }, overrides), kit.counts.members, pluralize(" user", kit.counts.members));
  }
  var descriptionThemeVals = _defineProperty({}, SpaceThemeNames.scher, {
    color: "white"
  });
  function renderDescription() {
    var overrides = descriptionThemeVals[themeName];
    return /*#__PURE__*/React.createElement(KitDescription, _extends({
      id: "kit-description",
      mt: "xs"
    }, overrides), kit.description);
  }
  var normalKitCardThemeVals = (_normalKitCardThemeVa = {}, _defineProperty(_normalKitCardThemeVa, SpaceThemeNames.classic, {
    contentContainerOverrides: {
      mt: "s"
    },
    imageViewOverrides: {
      borderRadius: "small"
    }
  }), _defineProperty(_normalKitCardThemeVa, SpaceThemeNames.wyman, {
    kitCardWrapperOverrides: {
      border: "default",
      borderRadius: "large"
    },
    imageViewOverrides: {
      mt: "s",
      mx: "s",
      borderRadius: "medium"
    },
    contentContainerOverrides: {
      m: "m"
    }
  }), _normalKitCardThemeVa);
  function renderNormalKitCard() {
    var _normalKitCardThemeVa2 = normalKitCardThemeVals[themeName],
      kitCardWrapperOverrides = _normalKitCardThemeVa2.kitCardWrapperOverrides,
      imageViewOverrides = _normalKitCardThemeVa2.imageViewOverrides,
      contentContainerOverrides = _normalKitCardThemeVa2.contentContainerOverrides;
    return /*#__PURE__*/React.createElement(KitCardWrapper, _extends({
      ref: dragRef,
      "data-testid": id,
      "data-kitid": id,
      width: "100%",
      onClick: handleClick
    }, kitCardWrapperOverrides, _dragProps), /*#__PURE__*/React.createElement(Box$1, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(_StyledImageView, _extends({
      src: kit.images.cover,
      icon: "content.kit",
      alt: kit.name,
      aspectRatio: 63,
      cover: true,
      background: "grayLight",
      border: "default"
    }, imageViewOverrides, {
      $_css: onClick ? "pointer" : null
    }))), /*#__PURE__*/React.createElement(Box$1, contentContainerOverrides, /*#__PURE__*/React.createElement(Flex$1, {
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h1",
      id: "kit-title",
      font: "ui.regularSemiBold",
      truncate: true,
      onClick: handleClick
    }, kit.name), /*#__PURE__*/React.createElement(Flex$1, null, /*#__PURE__*/React.createElement(Icon$1, {
      id: "privacy-".concat(kit.privacy),
      iconId: iconMap[kit.privacy],
      size: "24"
    }), canFavorite && renderFavoriteButton(), menuItems && renderOverflowButton(), menu)), canViewMembers && renderMemberCount(), kit.description && renderDescription()));
  }
  function renderOverlayTypeKitCard() {
    return /*#__PURE__*/React.createElement(KitCardWrapper, _extends({
      ref: dragRef,
      "data-testid": id,
      "data-kitid": id,
      width: "100%",
      showOverlay: menuVisible,
      onClick: handleClick
    }, _dragProps), /*#__PURE__*/React.createElement(_StyledImageView2, {
      src: kit.images.cover,
      icon: "content.kit",
      alt: kit.name,
      aspectRatio: 63,
      cover: true,
      background: "grayLight",
      border: "default",
      $_css2: onClick ? "pointer" : null
    }), /*#__PURE__*/React.createElement(Flex$1, {
      className: "hover",
      width: "100%",
      pt: "l",
      px: "m",
      pb: "s",
      flexDirection: "column",
      position: "absolute",
      bottom: "0",
      textAlign: "left"
    }, /*#__PURE__*/React.createElement(Flex$1, {
      width: "100%",
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "h1",
      id: "kit-title",
      font: "ui.regularSemiBold",
      color: "white",
      truncate: true,
      onClick: handleClick
    }, kit.name), /*#__PURE__*/React.createElement(Flex$1, null, /*#__PURE__*/React.createElement(Icon$1, {
      id: "privacy-".concat(kit.privacy),
      iconId: iconMap[kit.privacy],
      size: "24",
      fill: "white"
    }), canFavorite && renderFavoriteButton(), menuItems && renderOverflowButton(), menu)), canViewMembers && renderMemberCount(), kit.description && renderDescription()));
  }
  var _dragProps = kitCollectionId && reorderKitCollectionItems ? _objectSpread$9(_objectSpread$9({}, dragProps), {}, {
    dragStyle: dragDirection === null || dragDirection === void 0 ? void 0 : dragDirection.horizontal
  }) : {};
  switch (themeName) {
    case SpaceThemeNames.classic:
    case SpaceThemeNames.wyman:
      {
        return renderNormalKitCard();
      }
    case SpaceThemeNames.scher:
      {
        return renderOverlayTypeKitCard();
      }
  }
};
var KitCard$1 = KitCard;
var _StyledImageView = styled(ImageView$1).withConfig({
  displayName: "KitCard___StyledImageView"
})(function (p) {
  return {
    cursor: p.$_css
  };
});
var _StyledImageView2 = styled(ImageView$1).withConfig({
  displayName: "KitCard___StyledImageView2"
})(function (p) {
  return {
    cursor: p.$_css2
  };
});

var _excluded$i = ["size", "center", "color"];
var spinning$1 = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(960deg);}"]);
var Spinner = styled(Box$1).attrs({
  position: "relative",
  display: "block"
}).withConfig({
  displayName: "ActivityIndicator__Spinner"
})(["pointer-events:none;transform:", ";& svg{animation:", " 1s ease-in-out infinite alternate;transform-origin:50% 50%;}& svg::selection{background:transparent;}"], function (props) {
  return props.center ? "translateY(-50%)" : null;
}, spinning$1);
var sizes$1 = {
  small: 24,
  default: 40,
  large: 100
};
var ActivityIndicator = function ActivityIndicator(_ref) {
  var size = _ref.size,
    center = _ref.center,
    color = _ref.color,
    styling = _objectWithoutProperties(_ref, _excluded$i);
  var theme = useContext(ThemeContext);
  var _size = sizes$1[size] || sizes$1.default;
  var iconProps = {
    width: _size,
    height: _size,
    fill: getColor(color || theme && theme.primaryColor, "primary")
  };
  var spinnerProps = center ? {
    m: "auto",
    width: "100%",
    top: "50%",
    textAlign: "center",
    height: null
  } : {
    height: _size,
    width: _size
  };
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    height: center ? "100%" : _size,
    width: center ? "100%" : _size
  }, styling, {
    "data-testid": "loading"
  }), /*#__PURE__*/React.createElement(Spinner, _extends({
    role: "progressbar",
    center: center
  }, spinnerProps), /*#__PURE__*/React.createElement(Icon$1, _extends({}, iconProps, {
    iconId: "spinner"
  }))));
};
var ActivityIndicator$1 = ActivityIndicator;

var ModalWrapper = styled(ReactModal).withConfig({
  displayName: "Modal__ModalWrapper"
})(["max-height:calc(100% - 100px);width:750px;margin:auto;top:40px;border:", ";background-color:rgb(255,255,255);border-radius:", ";outline:none;padding:0;display:flex;flex-direction:column;transition:height 0.3s ease;position:fixed;left:50%;transform:translateX(-50%);box-shadow:", ";overflow:hidden;max-width:100%;", ""], border.default, borderRadius.default, boxShadow.panel, mq.s({
  maxHeight: "100%",
  top: 0,
  bottom: 0
}));
var Modal = function Modal(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    onRequestClose = _ref.onRequestClose,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton;
  var modalProps = {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true
  };
  return /*#__PURE__*/React.createElement(ModalWrapper, _extends({
    ariaHideApp: _lingoConfig.environment !== "test-runner"
  }, modalProps), !hideCloseButton && /*#__PURE__*/React.createElement(Button$1, {
    buttonStyle: "tertiary",
    "aria-label": "Close",
    icon: "close",
    onClick: onRequestClose,
    width: "36px",
    height: "36px",
    position: "absolute",
    top: "0",
    right: "0",
    zIndex: "50"
  }), children);
};
var Modal$1 = Modal;

var _excluded$h = ["title", "message", "children"];
var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
    message = _ref.message,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$h);
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    zIndex: 20,
    background: "white",
    borderBottom: "default",
    as: "header",
    pt: "l",
    width: "100%",
    display: "block"
  }, rest), /*#__PURE__*/React.createElement(Box$1, {
    mx: "xxl",
    textAlign: "center",
    mb: "m"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h1",
    font: "ui.title"
  }, title), message ? /*#__PURE__*/React.createElement(Text, {
    mt: "s"
  }, message) : null), children);
};
var Header = ModalHeader;

var ModalBody = styled(Flex$1).attrs(function (props) {
  return {
    flexDirection: "column",
    px: props.px || "xxl",
    py: props.py || "xl",
    textAlign: "left",
    overflow: "auto"
  };
}).withConfig({
  displayName: "Body__ModalBody"
})([""]);
var Body = ModalBody;

var _excluded$g = ["primary", "secondary"];
var ModalFooter = function ModalFooter(_ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    styles = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement(Flex$1, _extends({
    px: "xxl",
    py: "m",
    borderTop: "default",
    background: "grayLightest",
    alignItems: "center",
    justifyContent: "flex-end",
    flexShrink: "0"
  }, styles), secondary ? /*#__PURE__*/React.createElement(Button$1, _extends({
    id: "modal-footer-secondary-button",
    buttonStyle: "secondary",
    mr: "s"
  }, secondary)) : null, /*#__PURE__*/React.createElement(Button$1, _extends({
    fullWidth: !secondary,
    id: "modal-footer-primary-button"
  }, primary)));
};
var Footer = ModalFooter;

var Component$5 = Modal$1;
Component$5.Header = Header;
Component$5.Body = Body;
Component$5.Footer = Footer;
Component$5.setAppElement = ReactModal.setAppElement;
var Component$6 = Component$5;

var markdownStyle = css(["", " color:", ";> :first-child{margin-top:0;}> :last-child{margin-bottom:0;}p{margin-top:0;margin-bottom:16px;code{background:", ";", ";border:1px solid ", ";border-radius:", ";", ";", ";}}hr{border:none;border-top:1px solid ", ";margin-top:16px;margin-bottom:16px;}ol,ul{", " margin-bottom:16px;padding-left:28px;li{list-style:inherit;}ol,ul{", ";}}ol{list-style:decimal outside;li{padding-left:7px;}}ul{list-style:disc outside;}h1{", " ", ";}h2,h3,h4,h5,h6{", " ", ";}blockquote{", ";border-left:3px solid ", ";color:", ";font-size:16px;line-height:1.7;margin-bottom:16px;p{", ";}}a{color:", ";&:hover{color:", ";text-decoration:underline;}}"], function (props) {
  return getFont(props.font, "gallery.regular", props);
}, function (props) {
  return getColor(props.color, "black");
}, color.grayLightest, font.gallery.code, color.border, borderRadius.small, padding.x.xs, padding.y.none, color.gray, function (props) {
  return getFont(props.font, "gallery.regular", props);
}, margin.b.none, function (props) {
  return getFont(props.font, "gallery.h1", props);
}, margin.y.xs, function (props) {
  return getFont(props.font, "gallery.h2", props);
}, margin.y.xs, padding.l.l, function (props) {
  return props.theme.primaryColor;
}, color.grayDarkest, margin.b.s, function (props) {
  return props.theme.primaryColor || color.primary;
}, function (props) {
  return props.theme.primaryColorDark || color.primaryDark;
});

var sets = {
  basic: ["blockQuote", "characterReference", "codeFenced", "codeIndented", "codeText", "definition", "del", "footnoteDefinition", "headingAtx", "html", "htmlFlow", "htmlText", "input", "labelStartImage", "list", "setextUnderline", "table", "thematicBreak"
  // Leaving these here for reference
  // "lineEnding",
  // "attention",
  // "autolink",
  // "characterEscape",
  // "hardBreakEscape",
  // "labelEnd",
  // "labelStartLink",
  ],

  gallery: ["codeFenced", "codeIndented", "definition", "del", "footnote", "footnoteDefinition", "html", "htmlFlow", "input", "labelStartImage", "setextHeading", "table"]
};
function remarkDisableElements() {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var disable = sets[elements] || [];
  if (!elements) {
    return function () {
      /* noop */
    };
  }
  function disableElements() {
    var data = this.data();
    var list = data.micromarkExtensions || (data.micromarkExtensions = []);
    list.push({
      disable: {
        null: disable
      }
    });
  }
  return disableElements;
}

function remarkStrikethrough() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  var data = this.data();
  add("micromarkExtensions", gfmStrikethrough());
  add("fromMarkdownExtensions", gfmFromMarkdown());
  add("toMarkdownExtensions", gfmToMarkdown());
  function add(field, value) {
    var list /** @type {unknown[]} */ =
    // Other extensions
    /* c8 ignore next 2 */
    data[field] ? data[field] : data[field] = [];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    list.push(value);
  }
}

var _excluded$f = ["children", "buttonComponent", "elements"];
var StyledReactMarkdown$1 = styled(ReactMarkdown).withConfig({
  displayName: "MarkdownText__StyledReactMarkdown"
})(["word-break:break-word;flex:1 1 100%;", " ", ""], positioningCSS, markdownStyle);

// eslint-disable-next-line @typescript-eslint/no-explicit-any

var MarkdownText = function MarkdownText(_ref) {
  var children = _ref.children,
    buttonComponent = _ref.buttonComponent,
    elements = _ref.elements,
    rest = _objectWithoutProperties(_ref, _excluded$f);
  var LinkRenderer = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (_ref2) {
    var href = _ref2.href,
      node = _ref2.node;
    var props = {
      fontStyle: rest.font,
      link: href,
      text: node.children[0].value,
      icon: null
    };
    var ButtonComp = buttonComponent;
    if (buttonComponent) {
      return /*#__PURE__*/React.createElement(ButtonComp, props);
    } else {
      return /*#__PURE__*/React.createElement(Button$1, _extends({
        buttonStyle: "tertiary"
      }, props));
    }
  }, [rest.font, buttonComponent]);
  if (typeof children !== "string") return null;
  return /*#__PURE__*/React.createElement(StyledReactMarkdown$1
  // Set defaults
  , _extends({
    font: "gallery.regular",
    color: "black"
  }, rest, {
    components: {
      a: LinkRenderer
    },
    remarkPlugins: [remarkDisableElements(elements), remarkStrikethrough, remarkBreaks]
  }), children);
};
var MarkdownText$1 = MarkdownText;

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Pill = styled(Flex$1).attrs(function (props) {
  var _themeStyleObj;
  var theme = props.theme.themeName;
  var themeStyleObj = (_themeStyleObj = {}, _defineProperty(_themeStyleObj, SpaceThemeNames.classic, {
    background: props.selected ? "grayLighter" : null,
    variations: {
      "&:hover": {
        background: "grayLighter"
      }
    }
  }), _defineProperty(_themeStyleObj, SpaceThemeNames.scher, {}), _defineProperty(_themeStyleObj, SpaceThemeNames.wyman, {}), _themeStyleObj);
  return _objectSpread$8({
    px: "s",
    py: "xs",
    width: "100%",
    textAlign: "left",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "default"
  }, themeStyleObj[theme]);
}).withConfig({
  displayName: "Pill"
})(["&.disabled{pointer-events:none !important;}"]);
var Pill$1 = Pill;

var _excluded$e = ["placeholder", "defaultText", "onSubmit", "iconId", "submitOnBlur", "autoFocus"];
var NavInputField = styled(Input$2).attrs({
  styleOverrides: {
    mb: "none",
    mt: "none"
  },
  type: "text"
}).withConfig({
  displayName: "Input__NavInputField"
})(["padding:4px;border:none;border-radius:none;box-shadow:none;background:transparent;margin-top:0;margin-bottom:0;height:30px;&::placeholder{color:", ";}&::-webkit-input-placeholder{color:", ";}&:focus{outline:0;border:none;background:", ";}"], color.grayDarkest, color.grayDarkest, color.grayLighter);
var NavInput = function NavInput(_ref) {
  var placeholder = _ref.placeholder,
    defaultText = _ref.defaultText,
    _onSubmit = _ref.onSubmit,
    iconId = _ref.iconId,
    submitOnBlur = _ref.submitOnBlur,
    autoFocus = _ref.autoFocus,
    rest = _objectWithoutProperties(_ref, _excluded$e);
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    inputText = _useState2[0],
    setInputText = _useState2[1],
    _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  useEffect(function () {
    if (focused) {
      document.querySelector("#input-nav-pill").select();
    }
  }, [focused]);
  return /*#__PURE__*/React.createElement(Flex$1, _extends({
    pl: "xs",
    alignItems: "center",
    borderRadius: "default",
    background: focused ? "grayLighter" : "none",
    variations: {
      ":hover": {
        background: focused ? "none" : "grayLighter"
      }
    }
  }, rest), iconId && /*#__PURE__*/React.createElement(Icon$1, {
    iconId: iconId,
    size: "16",
    fill: "grayDarkest"
  }), /*#__PURE__*/React.createElement(NavInputField, {
    "data-testid": "navpill-input",
    id: "input-nav-pill",
    placeholder: placeholder,
    autoFocus: autoFocus,
    value: inputText,
    onSubmit: function onSubmit() {
      if (inputText && inputText.length > 0) {
        _onSubmit(inputText);
        setInputText("");
      }
    },
    onChange: function onChange(e) {
      return setInputText(e.target.value);
    },
    onFocus: function onFocus() {
      setInputText(defaultText || "");
      setFocused(true);
    },
    onBlur: function onBlur() {
      if (submitOnBlur) {
        _onSubmit(inputText);
      } else {
        setInputText("");
        setFocused(false);
      }
    }
  }));
};
NavInput.defaultProps = {
  iconId: "plus"
};
var Input = NavInput;

function useContextMenu(_ref) {
  var itemRef = _ref.itemRef,
    onOpenMenu = _ref.onOpenMenu,
    _ref$autoOpen = _ref.autoOpen,
    autoOpen = _ref$autoOpen === void 0 ? true : _ref$autoOpen;
  var _useState = useState("0px"),
    _useState2 = _slicedToArray(_useState, 2),
    contextMenuXPos = _useState2[0],
    setXPos = _useState2[1];
  var _useState3 = useState("0px"),
    _useState4 = _slicedToArray(_useState3, 2),
    contextMenuYPos = _useState4[0],
    setYPos = _useState4[1];
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 3),
    menuOpen = _useBoolean2[0],
    setMenuOpen = _useBoolean2[1],
    setMenuClosed = _useBoolean2[2];
  var handleContextMenu = useCallback(function (e) {
    if (e.shiftKey && process.env.NODE_ENV === "development") return;
    e.preventDefault();
    setXPos("".concat(e.pageX, "px"));
    setYPos("".concat(e.pageY, "px"));
    if (onOpenMenu) onOpenMenu(e);
    if (autoOpen) setMenuOpen(true);
  }, [autoOpen, onOpenMenu, setMenuOpen]);
  var handleContextMenuClose = useCallback(function () {
    if (menuOpen) setMenuClosed(false);
  }, [menuOpen, setMenuClosed]);
  useEffect(function () {
    var element = itemRef.current;
    element === null || element === void 0 ? void 0 : element.addEventListener("contextmenu", handleContextMenu);
    return function () {
      element === null || element === void 0 ? void 0 : element.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [itemRef, handleContextMenu]);
  return {
    contextMenuXPos: contextMenuXPos,
    contextMenuYPos: contextMenuYPos,
    contextMenuOpen: menuOpen,
    handleContextMenuClose: handleContextMenuClose,
    setMenuOpen: setMenuOpen,
    setMenuClosed: setMenuClosed
  };
}

// Usage:
var ContextMenu = function ContextMenu(_ref) {
  var id = _ref.id,
    parentRef = _ref.parentRef,
    onOpenMenu = _ref.onOpenMenu,
    children = _ref.children;
  var _useContextMenu = useContextMenu({
      itemRef: parentRef,
      onOpenMenu: onOpenMenu
    }),
    contextMenuXPos = _useContextMenu.contextMenuXPos,
    contextMenuYPos = _useContextMenu.contextMenuYPos,
    contextMenuOpen = _useContextMenu.contextMenuOpen,
    handleContextMenuClose = _useContextMenu.handleContextMenuClose;
  var contextMenuSource = "".concat(id, "-context-menu");
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(PopupMenu.ContextMenuAnchor, {
    xPos: contextMenuXPos,
    yPos: contextMenuYPos,
    "data-popup-source": contextMenuSource
  }), contextMenuOpen && /*#__PURE__*/React.createElement(PopupMenu, {
    "data-testid": "context-menu-popup",
    source: contextMenuSource,
    close: handleContextMenuClose,
    vPos: "floatBelow",
    hPos: "alignLeft"
  }, children));
};
var ContextMenu$1 = ContextMenu;

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ParentWrapper = styled(Box$1).attrs(function (props) {
  var _themeStyleObj;
  var theme = props.theme.themeName;
  var themeStyleObj = (_themeStyleObj = {}, _defineProperty(_themeStyleObj, SpaceThemeNames.classic, {}), _defineProperty(_themeStyleObj, SpaceThemeNames.scher, {
    mb: "m"
  }), _defineProperty(_themeStyleObj, SpaceThemeNames.wyman, {}), _themeStyleObj);
  return _objectSpread$7({
    width: "100%",
    my: "3",
    position: "relative"
  }, themeStyleObj[theme]);
}).withConfig({
  displayName: "NavPill__ParentWrapper"
})(["position:relative;&:after{content:\"\";height:2px;width:calc(100% - 4px);top:-2.5px;left:4px;background:", ";z-index:10;position:absolute;opacity:0;}&:before{content:\"\";height:2px;width:calc(100% - 4px);bottom:-2.5px;left:4px;background:", ";z-index:10;position:absolute;opacity:0;}", ";", ";"], function (props) {
  return getPrimaryColor(props);
}, function (props) {
  return getPrimaryColor(props);
}, function (props) {
  return props.dragDirection === "top" && "\n    &:after {\n      opacity: 1;\n    }\n  ";
}, function (props) {
  return props.dragDirection === "bottom" && "\n    &:before {\n      opacity: 1;\n    }\n  ";
});
var ChildWrapper = styled(Box$1).attrs(function (props) {
  var _themeStyleObj2;
  var theme = props.theme.themeName;
  var themeStyleObj = (_themeStyleObj2 = {}, _defineProperty(_themeStyleObj2, SpaceThemeNames.classic, {}), _defineProperty(_themeStyleObj2, SpaceThemeNames.scher, {}), _defineProperty(_themeStyleObj2, SpaceThemeNames.wyman, {}), _themeStyleObj2);
  return _objectSpread$7({
    maxHeight: props.selected ? React.Children.count(props.children) * 60 : 0,
    overflow: "hidden",
    as: "ul",
    pl: "s"
  }, themeStyleObj[theme]);
}).withConfig({
  displayName: "NavPill__ChildWrapper"
})(["transition:max-height 0.4s cubic-bezier(0.51,0.01,0.29,1.2);"]);

// MARK : Base
// -------------------------------------------------------------------------------

var NavPill = function NavPill(_ref) {
  var _SpaceThemeNames$clas;
  var id = _ref.id,
    text = _ref.text,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    link = _ref.link,
    icon = _ref.icon,
    canEdit = _ref.canEdit,
    onFinishEditing = _ref.onFinishEditing,
    onDelete = _ref.onDelete,
    shareLink = _ref.shareLink,
    entity = _ref.entity,
    children = _ref.children,
    _ref$draggable = _ref.draggable,
    draggable = _ref$draggable === void 0 ? false : _ref$draggable,
    onDropHandler = _ref.onDropHandler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    dragDirection = _useState4[0],
    setDragDirection = _useState4[1];
  var contextMenuRef = useRef(null);
  var dragRef = useRef(null);
  var theme = useTheme();
  /**
   * Drag context data is only available in the onDrop event,
   * so we need this isDragging state to let each instance know
   * if it's the one being dragged.
   */
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDragging = _useState6[0],
    setIsDragging = _useState6[1];
  var finishEditing = useCallback(function (inputText) {
    setEditing(false);
    if (inputText.trim() === text.trim()) return;
    onFinishEditing(id, inputText.trim() || "Untitled ".concat(entity));
  }, [setEditing, onFinishEditing, text, entity, id]);
  var toggleEditing = useCallback(function () {
    setEditing(!editing);
  }, [editing]);
  var pillProps = {
    selected: selected,
    onClick: onClick,
    onDoubleClick: canEdit ? toggleEditing : undefined,
    disabled: disabled,
    children: children,
    canEdit: canEdit
  };
  var pillTextThemeProps = (_SpaceThemeNames$clas = {}, _defineProperty(_SpaceThemeNames$clas, SpaceThemeNames.classic, {
    font: "ui.regularSemiBold"
  }), _defineProperty(_SpaceThemeNames$clas, SpaceThemeNames.scher, {
    font: selected ? "ui.regularSemiBold" : "ui.regular",
    color: selected ? "black" : "grayDarkest",
    variations: {
      "&:hover": {
        font: "ui.regularSemiBold"
      }
    }
  }), _defineProperty(_SpaceThemeNames$clas, SpaceThemeNames.wyman, {}), _SpaceThemeNames$clas)[theme.themeName];
  var pillTextProps = _objectSpread$7({
    truncate: true
  }, pillTextThemeProps);
  var contextMenuItems = [];
  if (!editing) {
    if (shareLink) {
      contextMenuItems.push( /*#__PURE__*/React.createElement(PopupMenu.Section, {
        key: "share-link"
      }, /*#__PURE__*/React.createElement(PopupMenu.Item, {
        onClick: function onClick() {
          return copy(shareLink);
        },
        title: "Copy share link"
      })));
    }
    if (canEdit) {
      contextMenuItems.push( /*#__PURE__*/React.createElement(PopupMenu.Section, {
        key: "update-items"
      }, /*#__PURE__*/React.createElement(PopupMenu.Item, {
        key: "edit-item",
        onClick: toggleEditing,
        title: "Rename ".concat(entity)
      })));
      if (onDelete) {
        contextMenuItems.push( /*#__PURE__*/React.createElement(PopupMenu.Section, {
          key: "edit-items"
        }, /*#__PURE__*/React.createElement(PopupMenu.Item, {
          key: "delete-item",
          onClick: function onClick() {
            return onDelete(id);
          },
          title: "Delete ".concat(entity)
        })));
      }
    }
  }
  var onDragStart = useCallback(function (e) {
    if (draggable && !id) {
      console.warn("NavPill components need ID values in order to drag & drop");
    }
    /** Normalize browser UI during drag */
    e.dataTransfer.effectAllowed = "all";
    /** Let this component know its the one being dragged */
    setIsDragging(true);
    /** Create or reuse the previous drag image clone */
    var elem = document.createElement("div");
    elem.setAttribute("style", "position: absolute; top: -1000px; font-size: 14px; padding: 4px 8px; background: white; border-radius: 4px;");
    elem.innerHTML = text;
    document.body.appendChild(elem);

    /** Set the drag element style */
    e.dataTransfer.setDragImage(elem, 0, 0);

    /** Set the ID of the item being dragged */
    e.dataTransfer.setData("navItemId", id);
    setTimeout(function () {
      document.body.removeChild(elem);
    }, 0);
  }, [draggable, id, text]);
  var onDragOver = useCallback(function (e) {
    if (e) e.preventDefault();
    var activeDragDirection = getVerticalDragDirection(e, dragRef);
    if (dragDirection !== activeDragDirection) setDragDirection(activeDragDirection);
  }, [dragRef, dragDirection, setDragDirection]);
  var onDragLeave = useCallback(function (e) {
    if (e) e.preventDefault();
    setDragDirection(null);
  }, []);
  var onDragEnd = useCallback(function (e) {
    if (e) e.preventDefault();
    setIsDragging(false);
  }, []);
  var onDrop = useCallback(function (e) {
    if (e) e.preventDefault();
    var dragId = e.dataTransfer.getData("navItemId"),
      dropId = id;

    /** If it's a valid drop, fire the handler passed down through props */
    if (dragId && dragId !== dropId) {
      onDropHandler({
        dragId: dragId,
        dropId: dropId,
        dragDirection: dragDirection
      });
    }
    setDragDirection(null);
  }, [dragDirection, id, onDropHandler]);
  var dragProps = draggable ? {
    draggable: true,
    ref: dragRef,
    dragDirection: isDragging ? null : dragDirection,
    onDragStart: onDragStart,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave,
    onDragEnd: onDragEnd,
    onDrop: onDrop
  } : {};
  return /*#__PURE__*/React.createElement(ParentWrapper, _extends({
    "data-testid": id
  }, dragProps), contextMenuItems.length ? /*#__PURE__*/React.createElement(ContextMenu$1, {
    "data-testid": "navpill-context-menu",
    id: id,
    parentRef: contextMenuRef
  }, contextMenuItems) : null, !editing ? /*#__PURE__*/React.createElement(LinkWrapper$1, {
    link: link,
    disabled: disabled,
    title: text
  }, /*#__PURE__*/React.createElement(Pill$1, _extends({
    ref: contextMenuRef,
    "data-testid": "nav-pill-title",
    className: disabled ? "disabled" : ""
  }, pillProps), /*#__PURE__*/React.createElement(Text, _extends({}, pillTextProps, {
    as: "span"
  }), text), icon ? /*#__PURE__*/React.createElement(Icon$1, {
    size: "12",
    iconId: icon
  }) : null)) : /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    submitOnBlur: true,
    iconId: null,
    placeholder: "Untitled ".concat(entity),
    defaultText: text,
    onSubmit: finishEditing
  }), children && /*#__PURE__*/React.createElement(ChildWrapper, {
    selected: selected
  }, children));
};
NavPill.defaultProps = {
  entity: "Item"
};
var NavPill$1 = NavPill;

function elementInViewport(el) {
  if (!el) return;
  var rect = el.getBoundingClientRect(),
    vWidth = window.innerWidth || document.documentElement.clientWidth,
    vHeight = window.innerHeight || document.documentElement.clientHeight,
    efp = function efp(x, y) {
      return document.elementFromPoint(x, y);
    };

  // Return false if it's not in the viewport
  if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;

  // Return true if any of its four corners are visible
  return el.contains(efp(rect.left, rect.top)) || el.contains(efp(rect.right, rect.top)) || el.contains(efp(rect.right, rect.bottom)) || el.contains(efp(rect.left, rect.bottom));
}

var elementIds = {
  SCROLL_CONTAINER: "scrollContainer"
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ChildPill = styled(Flex$1).attrs(function (props) {
  var _themeVals;
  var primary = getPrimaryColor(props);
  var themeName = getThemeName(props);
  var themeVals = (_themeVals = {}, _defineProperty(_themeVals, SpaceThemeNames.classic, {
    ml: "s",
    pl: props.relativeInView ? "s" : "xs",
    borderLeft: props.relativeInView ? "2px solid ".concat(primary) : "2px solid transparent",
    variations: {
      "&:hover": {
        borderLeft: "2px solid ".concat(primary)
      }
    }
  }), _defineProperty(_themeVals, SpaceThemeNames.scher, {
    ml: "s",
    mt: "m",
    variations: {
      "&:last-child": {
        mb: "s"
      }
    }
  }), _themeVals);
  return _merge({
    as: "li",
    mt: "s"
  }, themeVals[themeName]);
}).withConfig({
  displayName: "Child__ChildPill"
})(["transition:all 0.3s ease;width:100%;a{width:100%;}"]);
var ChildPillText = styled(Text).withConfig({
  displayName: "Child__ChildPillText"
})(["transition:all 0.3s ease;"]);
var Child = function Child(_ref) {
  var _themedPillTextProps;
  var id = _ref.id,
    text = _ref.text,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    relativeIdentifier = _ref.relativeIdentifier,
    link = _ref.link;
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 3),
    relativeInView = _useBoolean2[0],
    setRelativeInViewTrue = _useBoolean2[1],
    setRelativeInViewFalse = _useBoolean2[2];
  var theme = useTheme();
  var pillProps = {
    onClick: onClick,
    disabled: disabled,
    relativeInView: relativeInView
  };
  var themedPillTextProps = (_themedPillTextProps = {}, _defineProperty(_themedPillTextProps, SpaceThemeNames.classic, {
    color: relativeInView ? "black" : "grayDarkest"
  }), _defineProperty(_themedPillTextProps, SpaceThemeNames.scher, {
    color: relativeInView ? theme.primaryColor : "black"
  }), _defineProperty(_themedPillTextProps, SpaceThemeNames.wyman, {
    color: relativeInView ? theme.primaryColor : "grayDarkest"
  }), _themedPillTextProps);
  var pillTextProps = _objectSpread$6({
    truncate: true
  }, themedPillTextProps[theme.themeName]);
  var classes = ["secondary", disabled ? " disabled" : ""].join(" ");
  var relativeEffect = React.useCallback(function () {
    var relativeElementInView = elementInViewport(document.querySelector(relativeIdentifier));
    if (relativeElementInView) setRelativeInViewTrue();else setRelativeInViewFalse();
  }, [relativeIdentifier, setRelativeInViewFalse, setRelativeInViewTrue]);
  React.useEffect(function () {
    if (!relativeIdentifier) return;
    relativeEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if (!relativeIdentifier) return;
    var element = document.getElementById(elementIds.SCROLL_CONTAINER);
    element.addEventListener("scroll", relativeEffect);
    return function () {
      element.removeEventListener("scroll", relativeEffect);
    };
  }, [relativeEffect, relativeIdentifier, relativeInView, setRelativeInViewFalse, setRelativeInViewTrue]);
  return /*#__PURE__*/React.createElement(ChildPill, _extends({
    "data-testid": id,
    className: classes
  }, pillProps), /*#__PURE__*/React.createElement(LinkWrapper$1, {
    link: link,
    disabled: disabled,
    title: text
  }, /*#__PURE__*/React.createElement(ChildPillText, pillTextProps, text)));
};
var Child$1 = Child;

var Component$3 = NavPill$1;
Component$3.Child = Child$1;
Component$3.Input = Input;
var Component$4 = Component$3;

var _excluded$d = ["id", "text", "size", "onClick", "styleOverrides"];
var buttonHeights = {
  regular: "36px",
  small: "28px"
};
var Wrapper$3 = styled(Flex$1).attrs(function (props) {
  var _props$theme;
  return {
    as: "button",
    role: "",
    pl: "s",
    justifyContent: "space-between",
    alignItems: "center",
    height: buttonHeights[props.size] || buttonHeights.regular,
    overflow: "hidden",
    border: "default",
    borderRadius: getBorderRadius(props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.themeName, "default"),
    flexShrink: 0,
    background: "white"
  };
}).withConfig({
  displayName: "DropdownButton__Wrapper"
})(["cursor:pointer;transition:background 0.2s ease-in;opacity:", ";&:hover{background:", ";}"], function (props) {
  return props.disabled ? "50%" : null;
}, getColor("grayLighter"));
var IconWrapper = styled(Flex$1).attrs(function (props) {
  return {
    height: buttonHeights[props.size] || buttonHeights.regular,
    width: buttonHeights[props.size] || buttonHeights.regular,
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    padding: "4px 0"
  };
}).withConfig({
  displayName: "DropdownButton__IconWrapper"
})([""]);
var DropdownButton = function DropdownButton(props) {
  // ...rest is used for data-attrs here - try to avoid using this pattern
  var id = props.id,
    text = props.text,
    size = props.size,
    onClick = props.onClick,
    styleOverrides = props.styleOverrides,
    rest = _objectWithoutProperties(props, _excluded$d);
  return /*#__PURE__*/React.createElement(Wrapper$3, _extends({
    "data-testid": id,
    size: size,
    onClick: onClick
  }, styleOverrides, rest), /*#__PURE__*/React.createElement(Text, {
    color: "black",
    font: "ui.".concat(size),
    truncate: true
  }, text || ""), /*#__PURE__*/React.createElement(IconWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(Icon$1, {
    iconId: "navigation.chevron-down",
    size: size === "small" ? "16" : "24",
    fill: "grayDarker"
  })));
};
DropdownButton.defaultProps = {
  size: "small"
};
var DropdownButton$1 = DropdownButton;

var _excluded$c = ["label", "value", "buttonStyle", "size", "options", "onChange", "width", "disabled", "menuId"];
/**
 * A custom select component that wraps a Button and PopupMenu
 * Just provide options and an onChange handle similar to a native select
 */
var Select = function Select(_ref) {
  var _options$find;
  var label = _ref.label,
    value = _ref.value,
    _ref$buttonStyle = _ref.buttonStyle,
    buttonStyle = _ref$buttonStyle === void 0 ? "dropdown" : _ref$buttonStyle,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "regular" : _ref$size,
    options = _ref.options,
    onChange = _ref.onChange,
    width = _ref.width,
    disabled = _ref.disabled,
    _menuId = _ref.menuId,
    rest = _objectWithoutProperties(_ref, _excluded$c);
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 3),
    isMenuActive = _useBoolean2[0],
    showMenu = _useBoolean2[1],
    hideMenu = _useBoolean2[2],
    menuId = useMemo(function () {
      return _menuId !== null && _menuId !== void 0 ? _menuId : factory.genUUID();
    }, [_menuId]);
  var displayValue = (_options$find = options.find(function (f) {
    return f.value === value;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label;
  function renderButton() {
    return buttonStyle === "dropdown" ? /*#__PURE__*/React.createElement(DropdownButton$1, {
      "data-popup-source": menuId,
      onClick: showMenu,
      text: displayValue,
      size: size,
      styleOverrides: {
        width: width
      },
      disabled: disabled
    }) : /*#__PURE__*/React.createElement(Button$1, {
      buttonStyle: "tertiary",
      "data-popup-source": menuId,
      onClick: showMenu,
      text: displayValue,
      size: size,
      icon: "action.expand",
      disabled: disabled
    });
  }
  var menuItems = useMemo(function () {
    return options.map(function (opt) {
      return /*#__PURE__*/React.createElement(PopupMenu.Item, {
        key: opt.value,
        title: opt.labelNode || opt.label,
        checked: value === opt.value,
        onClick: function onClick() {
          return onChange(opt.value);
        }
      });
    });
  }, [onChange, options, value]);
  return /*#__PURE__*/React.createElement(Box$1, rest, label && /*#__PURE__*/React.createElement(Box$1, {
    mb: "xs"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "label",
    lineHeight: 1
  }, label)), renderButton(), /*#__PURE__*/React.createElement(PopupMenu, {
    vPos: "alignTop",
    source: menuId,
    open: isMenuActive,
    value: value,
    close: hideMenu
  }, menuItems));
};
var Select$1 = Select;

var _excluded$b = ["id", "isOn", "size", "onToggle", "label", "disabled"];
var sizes = {
  small: {
    w: 30,
    h: 18,
    m: 3
  },
  regular: {
    w: 40,
    h: 24,
    m: 3
  }
};
function handleSize(size) {
  var m = sizes[size].m;
  return sizes[size].h - m * 2;
}
var ControlWrapper = styled.button.withConfig({
  displayName: "Switch__ControlWrapper"
})(["position:relative;display:inline-block;width:", "px;height:", "px;opacity:", ";"], function (props) {
  return sizes[props.size].w;
}, function (props) {
  return sizes[props.size].h;
}, function (props) {
  return props.disabled ? 0.5 : 1;
});
var Checkbox = styled.input.withConfig({
  displayName: "Switch__Checkbox"
})(["opacity:0;width:0;height:0;&:focus + span{box-shadow:0 0 1px ", ";}"], function (props) {
  return props.color;
});
var Handle = styled.span.withConfig({
  displayName: "Switch__Handle"
})(["position:absolute;cursor:", ";top:0;left:0;right:0;bottom:0;background-color:", ";-webkit-transition:0.4s;transition:0.4s;border-radius:34px;flex-shrink:0;&:before{position:absolute;content:\"\";cursor:", ";width:", "px;height:", "px;left:", "px;bottom:", "px;background-color:white;-webkit-transition:0.4s;transition:0.4s;border-radius:50%;}"], function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  var _props$theme;
  return props.isOn ? getColor((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.primaryColor, "primary") : getColor("grayDark");
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return handleSize(props.size);
}, function (props) {
  return handleSize(props.size);
}, function (props) {
  return props.isOn ? sizes[props.size].w - handleSize(props.size) - sizes[props.size].m : sizes[props.size].m;
}, function (props) {
  return sizes[props.size].m;
});
var Label = styled.label.withConfig({
  displayName: "Switch__Label"
})(["margin-right:", "px;margin-left:", "px;", ";color:", ";"], function (props) {
  return props.position === "left" ? 6 : 0;
}, function (props) {
  return props.position === "right" ? 6 : 0;
}, function (props) {
  return getFont(props.font, "ui.regular");
}, getColor("black"));
var Switch = function Switch(_ref) {
  var id = _ref.id,
    isOn = _ref.isOn,
    size = _ref.size,
    onToggle = _ref.onToggle,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded$b);
  var handler = useCallback(function () {
    onToggle(!isOn);
  }, [isOn, onToggle]);
  function renderLabel(render) {
    if (render && label && label.text) return /*#__PURE__*/React.createElement(Label, {
      "data-testid": "switch-label",
      htmlFor: id,
      font: label.font,
      position: label.position || "left"
    }, label.text);
    return null;
  }
  return /*#__PURE__*/React.createElement(Flex$1, _extends({
    alignItems: "center",
    "data-testid": id
  }, rest), renderLabel(label && (!label.position || label.position === "left")), /*#__PURE__*/React.createElement(ControlWrapper, {
    size: size,
    className: "".concat(disabled ? "disabled" : ""),
    "data-testid": "switch-content",
    onClick: disabled ? null : handler,
    role: "switch",
    "aria-checked": isOn,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Handle, {
    "data-testid": "switch-handle",
    disabled: disabled,
    isOn: isOn,
    size: size
  }), /*#__PURE__*/React.createElement(Checkbox, {
    id: id
  })), renderLabel((label === null || label === void 0 ? void 0 : label.position) === "right"));
};
Switch.defaultProps = {
  isOn: false,
  size: "regular",
  disabled: false
};
var Switch$1 = Switch;

function useEventListener(eventName, handler) {
  React.useEffect(function () {
    window.addEventListener(eventName, handler);
    return function () {
      return window.removeEventListener(eventName, handler);
    };
  }, [eventName, handler]);
}

var BarWrapper = styled(Flex$1).attrs(function (props) {
  return {
    width: "100%",
    height: props.size === "small" ? "28px" : "36px",
    px: props.innerOverflows ? "40px" : "0"
  };
}).withConfig({
  displayName: "TabBar__BarWrapper"
})(["position:relative;overflow:hidden;scroll-behavior:smooth;button{", ";}a{button{height:100%;}}"], function (props) {
  return getFont(props.size === "small" ? "ui.small" : "ui.regular", null, props);
});
var OverflowOverlay = styled(Flex$1).attrs(function (props) {
  return {
    width: "49px",
    height: props.size === "small" ? "28px" : "36px"
  };
}).withConfig({
  displayName: "TabBar__OverflowOverlay"
})(["z-index:100;background:", ";flex-flow:", ";"], function (props) {
  return props.side === "right" ? "linear-gradient(270deg, #FFFFFF 45.48%, rgba(255, 255, 255, 0) 100%)" : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 40.1%)";
}, function (props) {
  return props.side === "right" ? "row-reverse" : "row";
});
var ScrollButton = styled.button.withConfig({
  displayName: "TabBar__ScrollButton"
})(["display:flex;align-items:center;"]);
var TabBar = function TabBar(_ref) {
  var _ref$center = _ref.center,
    center = _ref$center === void 0 ? true : _ref$center,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "regular" : _ref$size,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? false : _ref$separator,
    children = _ref.children,
    styleOverrides = _ref.styleOverrides;
  var outerRef = useRef();
  var innerRef = useRef();
  var _useBoolean = useBoolean(false),
    _useBoolean2 = _slicedToArray(_useBoolean, 3),
    innerOverflows = _useBoolean2[0],
    setTrue = _useBoolean2[1],
    setFalse = _useBoolean2[2];
  var handleResize = useCallback(function () {
    if (outerRef.current.clientWidth < innerRef.current.clientWidth && !innerOverflows) {
      setTrue();
    } else if (outerRef.current.clientWidth > innerRef.current.clientWidth && innerOverflows) {
      setFalse();
    }
  }, [innerOverflows, setTrue, setFalse]);
  useEffect(function () {
    handleResize();
  }, [handleResize]);
  useEventListener("resize", handleResize);
  var scroll = function scroll(direction) {
    var numberOfItems = Children.count(children);
    if (direction === "left") {
      outerRef.current.scrollLeft -= innerRef.current.clientWidth / numberOfItems;
    } else if (direction === "right") {
      outerRef.current.scrollLeft += innerRef.current.clientWidth / numberOfItems;
    }
  };
  function renderOverlay(direction) {
    return /*#__PURE__*/React.createElement(OverflowOverlay, {
      size: size,
      side: direction
    }, /*#__PURE__*/React.createElement(ScrollButton, {
      onClick: function onClick() {
        return scroll(direction);
      }
    }, /*#__PURE__*/React.createElement(Icon$1, {
      iconId: "navigation.chevron-".concat(direction),
      size: "24"
    })));
  }
  return /*#__PURE__*/React.createElement(Box$1, null, innerOverflows && /*#__PURE__*/React.createElement(Flex$1, {
    width: "100%",
    justifyContent: "space-between",
    position: "absolute"
  }, renderOverlay("left"), renderOverlay("right")), separator && /*#__PURE__*/React.createElement(Box$1, {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    height: "1",
    background: "border"
  }), /*#__PURE__*/React.createElement(BarWrapper, _extends({
    ref: outerRef,
    size: size,
    innerOverflows: innerOverflows
  }, styleOverrides), /*#__PURE__*/React.createElement(Box$1, {
    ref: innerRef,
    mx: center ? "auto" : null
  }, children)));
};
var TabBar$1 = TabBar;

var _excluded$a = ["text", "subtext", "disabled", "link"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ItemWrapper = styled.button.withConfig({
  displayName: "Item__ItemWrapper"
})(["background:none;padding:0;opacity:", ";transition:background ", ",opacity ", ",color ", ",text-decoration ", ",box-shadow ", ";user-select:none;box-shadow:none;flex-shrink:0;border:none;height:100%;flex:1;pointer-events:", ";", ";", " ", " color:", ";span.subtext{color:", ";", ";}&:hover{color:", ";text-decoration:underline;}border-bottom:2px solid ", ";transition:color ", ",border-bottom ", ";&:hover,&:focus{border-bottom:2px solid ", ";text-decoration:none;outline:none;}", ""], function (props) {
  return props.disabled ? ".5" : "1";
}, transition, transition, transition, transition, transition, function (props) {
  return props.disabled ? "none" : null;
}, ellipsis, positioningCSS, flexCSS, function (props) {
  return props.selected ? getColor(props.theme.primaryColor, "primary") : getColor("black");
}, getColor("grayDarker"), positioningCSS({
  ml: "xs"
}), function (props) {
  return props.selected ? getColor(props.theme.primaryColor, "primary") : "black";
}, function (props) {
  return props.selected ? color.grayLight : "transparent";
}, transition, transition, function (props) {
  return props.selected ? getColor(props.theme.primaryColor, "primary") : color.grayDark;
}, function (props) {
  return props.selected && "\n  border-bottom: 2px solid ".concat(getColor(props.theme.primaryColor, "primary"), ";\n");
});
var Item$1 = function Item(_ref) {
  var text = _ref.text,
    _ref$subtext = _ref.subtext,
    subtext = _ref$subtext === void 0 ? null : _ref$subtext,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? null : _ref$link,
    rest = _objectWithoutProperties(_ref, _excluded$a);
  var linkProps = {
    disabled: disabled,
    link: link,
    height: "100%",
    style: null
  };
  var buttonProps = _objectSpread$5(_objectSpread$5({
    disabled: disabled
  }, rest), {}, {
    px: "m"
  });
  function renderContent() {
    return /*#__PURE__*/React.createElement(Flex$1, {
      justifyContent: "center",
      alignItems: "center"
    }, text && /*#__PURE__*/React.createElement("span", null, text), subtext && /*#__PURE__*/React.createElement("span", {
      className: "subtext"
    }, subtext));
  }
  return /*#__PURE__*/React.createElement(LinkWrapper$1, linkProps, /*#__PURE__*/React.createElement(ItemWrapper, buttonProps, renderContent()));
};
var Item$2 = Item$1;

var Component$1 = TabBar$1;
Component$1.Item = Item$2;
var Component$2 = Component$1;

var _excluded$9 = ["value", "onChange", "placeholder", "id", "label", "message", "textareaStyle", "maxLength", "rows", "resize", "disabled", "readOnly", "autoFocus", "onFocus", "onBlur"];
var StyledTextArea = styled.textarea.withConfig({
  displayName: "Textarea__StyledTextArea"
})(["width:100%;border:", ";border-radius:", ";background:white;box-sizing:border-box;", ";", " resize:", ";&::placeholder{color:", ";}&.active,&:focus{border:", ";outline:none;}&.error{border:", ";}&.disabled{border:", ";background:", ";}"], getBorder("1px solid border"), borderRadius.default, function (props) {
  return getFont("ui.regular", null, props);
}, positioningCSS({
  px: "s",
  py: "s"
}), function (props) {
  return props.resize || "vertical";
}, color.grayDark, getBorder("1px solid focus"), getBorder("1px solid error"), getBorder("1px solid border"), color.grayLighter);
var Textarea$4 = function Textarea(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    id = _ref.id,
    label = _ref.label,
    message = _ref.message,
    textareaStyle = _ref.textareaStyle,
    maxLength = _ref.maxLength,
    rows = _ref.rows,
    _ref$resize = _ref.resize,
    resize = _ref$resize === void 0 ? "vertical" : _ref$resize,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    autoFocus = _ref.autoFocus,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    rest = _objectWithoutProperties(_ref, _excluded$9);
  var elementProps = {
    id: id,
    value: value,
    placeholder: placeholder,
    maxLength: maxLength,
    rows: rows,
    resize: resize,
    autoFocus: autoFocus,
    disabled: disabled,
    readOnly: readOnly,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  };
  var ref = useRef();
  useEffect(function () {
    if (autoFocus) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getIcon() {
    switch (textareaStyle) {
      case "error":
        return /*#__PURE__*/React.createElement(Icon$1, {
          size: "16",
          fill: "error",
          iconId: "error",
          pr: "xs"
        });
      case "success":
        return /*#__PURE__*/React.createElement(Icon$1, {
          size: "16",
          fill: "success",
          iconId: "checkmark",
          pr: "xs"
        });
      case "warning":
        return /*#__PURE__*/React.createElement(Icon$1, {
          size: "16",
          fill: "warning",
          iconId: "warning",
          pr: "xs"
        });
      default:
        return null;
    }
  }
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    "data-testid": id,
    width: "100%"
  }, rest), label ? /*#__PURE__*/React.createElement(Text, {
    as: "label",
    "data-testid": "textarea-label",
    display: "block",
    color: "black",
    mb: "xs",
    htmlFor: id
  }, label) : null, /*#__PURE__*/React.createElement(Flex$1, {
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(StyledTextArea, _extends({
    ref: ref,
    role: "textbox",
    className: disabled || readOnly ? "disabled" : textareaStyle
  }, elementProps))), message ? /*#__PURE__*/React.createElement(Flex$1, {
    "data-testid": "textarea-message",
    ml: "s",
    flexDirection: "row",
    alignItems: "center"
  }, getIcon(), /*#__PURE__*/React.createElement(Text, {
    my: "xs",
    font: "ui.small",
    color: textareaStyle === "error" ? "error" : "black"
  }, message)) : null);
};
var Textarea$5 = Textarea$4;

var ContentBox = styled(Box$1).withConfig({
  displayName: "ToggleBox__ContentBox"
})(["transition:opacity 500ms,padding-top 500ms,padding-bottom 500ms,max-height 500ms;opacity:", ";max-height:", ";"], function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.isOpen ? cssVal(props.estimatedHeight || "200px") : 0;
});
var ToggleBox = function ToggleBox(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    isOpen = _ref.isOpen,
    disabled = _ref.disabled,
    _onToggle = _ref.onToggle,
    children = _ref.children,
    estimatedHeight = _ref.estimatedHeight,
    _ref$control = _ref.control,
    control = _ref$control === void 0 ? "switch" : _ref$control,
    styleOverrides = _ref.styleOverrides,
    descriptionButton = _ref.descriptionButton,
    buttonProps = _ref.buttonProps,
    titleBadge = _ref.titleBadge;
  return /*#__PURE__*/React.createElement(Box$1, _extends({
    "data-testid": id,
    borderRadius: "default",
    border: "default",
    background: "grayLightest"
  }, styleOverrides), /*#__PURE__*/React.createElement(Flex$1, {
    p: "m",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex$1, {
    flex: 5,
    flexDirection: "column",
    pr: "8px"
  }, /*#__PURE__*/React.createElement(Flex$1, {
    alignItems: "center"
  }, icon && /*#__PURE__*/React.createElement(Icon$1, {
    pr: "s",
    iconId: icon
  }), /*#__PURE__*/React.createElement(Text, {
    id: "toggle-box-title",
    font: "ui.regularBold",
    mr: "s"
  }, title), titleBadge && /*#__PURE__*/React.createElement(Badge, {
    id: "".concat(title, "-upgrade"),
    text: titleBadge
  })), description && /*#__PURE__*/React.createElement(Text, {
    id: "toggle-box-description",
    mt: "xs",
    m: 0
  }, description, descriptionButton && /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(Button$1, {
    onClick: descriptionButton.onClick,
    text: descriptionButton.text,
    buttonStyle: "tertiary"
  })))), control === "switch" && /*#__PURE__*/React.createElement("div", {
    className: "toggle"
  }, /*#__PURE__*/React.createElement(Switch$1, {
    id: "toggle-box-switch",
    isOn: isOpen,
    disabled: disabled,
    size: "small",
    onToggle: function onToggle(toggledOn) {
      _onToggle(toggledOn);
    }
  })), control === "button" && /*#__PURE__*/React.createElement(Button$1, _extends({
    disabled: disabled
  }, buttonProps))), children && /*#__PURE__*/React.createElement(ContentBox, {
    "data-testid": "toggle-box-content",
    isOpen: isOpen,
    estimatedHeight: estimatedHeight,
    py: isOpen ? "m" : "0",
    px: "m",
    borderTop: "default",
    overflow: "hidden"
  }, children));
};
var ToggleBox$1 = ToggleBox;

var _excluded$8 = ["id", "noticeStyle", "message", "button", "secondaryButton"];
var Notice = function Notice(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    _ref$noticeStyle = _ref.noticeStyle,
    noticeStyle = _ref$noticeStyle === void 0 ? "info" : _ref$noticeStyle,
    message = _ref.message,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? null : _ref$button,
    _ref$secondaryButton = _ref.secondaryButton,
    secondaryButton = _ref$secondaryButton === void 0 ? null : _ref$secondaryButton,
    rest = _objectWithoutProperties(_ref, _excluded$8);
  var style = {
    border: "1px solid ".concat(noticeStyle),
    background: "".concat(noticeStyle, "Light")
  };
  function renderIcon() {
    var iconName = function iconName() {
      switch (noticeStyle) {
        case "warning":
          return "info.warning";
        case "error":
          return "info.error";
        case "info":
        case "neutral":
        default:
          return "info.info";
      }
    };
    return /*#__PURE__*/React.createElement(Icon$1, {
      "data-testid": "notice-icon",
      size: 16,
      fill: "black",
      iconId: iconName(),
      flexShrink: 0,
      mr: "s"
    });
  }
  function renderButton() {
    if (!button) return null;
    var theme = {
      primaryColor: noticeStyle,
      primaryColorDark: "".concat(noticeStyle, "Dark"),
      primaryColorLight: "".concat(noticeStyle, "Light"),
      primaryColorTint: ["warning"].includes(noticeStyle) ? "black" : "white"
    };
    return /*#__PURE__*/React.createElement(Button$1, _extends({
      buttonStyle: "primary",
      themeOverrides: theme
    }, button, {
      justifySelf: "flex-end",
      size: "small"
    }));
  }
  function renderSecondaryButton() {
    if (!secondaryButton) return null;
    var theme = {
      primaryColor: noticeStyle,
      primaryColorDark: "".concat(noticeStyle, "Dark"),
      primaryColorLight: "".concat(noticeStyle, "Light"),
      primaryColorTint: ["warning", "neutral"].includes(noticeStyle) ? "black" : "white"
    };
    return /*#__PURE__*/React.createElement(Button$1, _extends({
      mr: button ? "m" : "none",
      buttonStyle: "tertiary",
      themeOverrides: theme
    }, secondaryButton, {
      justifySelf: "flex-end",
      size: "small"
    }));
  }
  return /*#__PURE__*/React.createElement(Flex$1, _extends({
    "data-testid": id,
    alignItems: "center",
    p: "s",
    mt: "xs",
    borderRadius: "default",
    textAlign: "left"
  }, style, rest), renderIcon(), /*#__PURE__*/React.createElement(Text, {
    flex: "1",
    "data-testid": "notice-message",
    font: "ui.small"
  }, message), renderSecondaryButton(), renderButton());
};
Notice.defaultProps = {
  noticeStyle: "info"
};
var Notice$1 = Notice;

var _excluded$7 = ["id", "title", "detail", "image", "cardStyle", "disabled", "selected", "onClick", "size"];
var Container = styled(Flex$1).attrs({
  borderRadius: "default"
}).withConfig({
  displayName: "OptionCard__Container"
})(["cursor:", ";transition:background-color 0.4s;opacity:", ";&:hover{background:", ";}"], function (props) {
  return props.disabled && "not-allowed" || props.selectable && "pointer";
}, function (props) {
  return props.disabled && "50%";
}, function (props) {
  return props.selectable && color.grayLightest;
});
var OptionCard = function OptionCard(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    title = _ref.title,
    _ref$detail = _ref.detail,
    detail = _ref$detail === void 0 ? null : _ref$detail,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$cardStyle = _ref.cardStyle,
    cardStyle = _ref$cardStyle === void 0 ? "default" : _ref$cardStyle,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "regular" : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded$7);
  function renderImage() {
    if (!image) return null;
    if (image.style === "iconOnly") {
      return /*#__PURE__*/React.createElement(Box$1, {
        mr: "m"
      }, /*#__PURE__*/React.createElement(Icon$1, {
        id: "optioncard-icon",
        size: "40",
        fill: "grayDarkest",
        iconId: image.icon
      }));
    }
    var radius;
    if (image.style === "rounded") radius = "default";
    if (image.style === "circle") radius = "50%";
    return /*#__PURE__*/React.createElement(Box$1, {
      borderRadius: radius,
      mr: "m",
      background: "grayLightest",
      overflow: "hidden"
    }, /*#__PURE__*/React.createElement(ImageView$1, {
      id: "optioncard-image",
      width: "40px",
      height: "40px",
      icon: image.icon,
      iconFill: "grayDarkest",
      src: image.src
    }));
  }
  var theme = useContext(ThemeContext);
  var accentColor = theme && theme.primaryColor || "primary";
  function renderAccessory() {
    switch (cardStyle) {
      case "radio":
        return /*#__PURE__*/React.createElement(Icon$1, {
          ml: "s",
          id: "optioncard-accessory",
          fill: accentColor,
          iconId: selected ? "radio-checked" : "radio-unchecked"
        });
      case "checkbox":
        return /*#__PURE__*/React.createElement(Icon$1, {
          ml: "s",
          id: "optioncard-accessory",
          fill: accentColor,
          iconId: selected ? "checkbox-checked" : "checkbox-unchecked"
        });
      case "disclosure":
        return /*#__PURE__*/React.createElement(Icon$1, {
          ml: "s",
          id: "optioncard-accessory",
          fill: "grayDarker",
          iconId: "arrow-right"
        });
      default:
        return null;
    }
  }
  var ariaAttributes = useMemo(function () {
    switch (cardStyle) {
      case "radio":
        return {
          role: "radio",
          "aria-checked": selected,
          "aria-disabled": disabled
        };
      case "checkbox":
        return {
          role: "checkbox",
          "aria-checked": selected,
          "aria-disabled": disabled
        };
      case "disclosure":
        return {
          role: "button"
        };
    }
  }, [cardStyle, disabled, selected]);
  var role = useMemo(function () {
    switch (cardStyle) {
      case "radio":
        return "radio";
      case "checkbox":
        return "checkbox";
      case "disclosure":
        return "button";
    }
  }, [cardStyle]);
  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": id !== null && id !== void 0 ? id : "option-card",
    mb: "8px",
    px: "16px",
    role: role,
    minHeight: size === "small" ? null : "80px",
    borderRadius: "default",
    py: size === "small" ? "12px" : "16px",
    alignItems: "center",
    border: selected && cardStyle !== "checkbox" ? "1px solid ".concat(accentColor) : "default",
    disabled: disabled,
    selectable: !disabled && cardStyle !== "default",
    onClick: disabled ? null : onClick
  }, ariaAttributes, rest), renderImage(), /*#__PURE__*/React.createElement(Flex$1, {
    flex: "10",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    id: "optioncard-title",
    font: "ui.regularBold"
  }, title), detail && /*#__PURE__*/React.createElement(Text, {
    id: "optioncard-detail",
    font: size === "small" ? "ui.small" : "ui.regular"
  }, detail)), renderAccessory());
};
OptionCard.defaultProps = {
  cardStyle: "default",
  size: "regular"
};
var OptionCard$1 = OptionCard;

var _excluded$6 = ["children"];
var StyledReactMarkdown = styled(ReactMarkdown).withConfig({
  displayName: "GalleryMarkdown__StyledReactMarkdown"
})(["word-break:break-word;flex:1 1 100%;", " ", ""], margin.x.s, markdownStyle);
var LinkRenderer = function LinkRenderer(_ref) {
  var children = _ref.children,
    href = _ref.href;
  return /*#__PURE__*/React.createElement(LinkWrapper$1, {
    link: href,
    style: {
      textDecoration: "underline"
    }
  }, children);
};
var GalleryMarkdown = function GalleryMarkdown(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded$6);
  if (typeof children !== "string") return null;
  return /*#__PURE__*/React.createElement(StyledReactMarkdown, _extends({}, rest, {
    components: {
      a: LinkRenderer
    },
    remarkPlugins: [remarkDisableElements("gallery"), remarkStrikethrough, remarkBreaks]
  }), children);
};
var GalleryMarkdown$1 = GalleryMarkdown;

var useRect = (function (ref) {
  var _useState = useState(getRect(ref ? ref.current : null)),
    _useState2 = _slicedToArray(_useState, 2),
    rect = _useState2[0],
    setRect = _useState2[1];
  var handleResize = useCallback(function () {
    if (!ref.current) {
      return;
    }
    setRect(getRect(ref.current));
  }, [ref]);
  useLayoutEffect(function () {
    var element = ref.current;
    if (!element) {
      return;
    }
    handleResize();
    if (typeof ResizeObserver === "function") {
      var resizeObserver = new ResizeObserver(function () {
        return handleResize();
      });
      resizeObserver.observe(element);
      return function () {
        if (!resizeObserver) {
          return;
        }
        resizeObserver.disconnect();
        resizeObserver = null;
      };
    }
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref, handleResize]);
  return rect;
});
function getRect(element) {
  if (!element) {
    return {
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0
    };
  }
  return element.getBoundingClientRect();
}

/**
 * Returns the cookieName value based on the _lingoConfig environment
 */

var apiCSRFCookieNames = {
  development: "api_dev_csrftoken",
  staging: "api_staging_csrftoken",
  test: "api_test_csrftoken",
  production: "api_csrftoken"
};
var getCSRFCookieName = function getCSRFCookieName() {
  var env = _lingoConfig.environment;
  if (!env) throw new Error("Environment missing from config");
  return apiCSRFCookieNames[env] || apiCSRFCookieNames.production;
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Code$1 = {
  unknown: 1,
  invalidParams: 103,
  unauthorized: 401,
  permissionDenied: 403,
  objectNotFound: 404,
  rateLimited: 429,
  serverError: 500,
  serviceUnavailable: 503,
  needsAdditionalConfirmation: 444,
  deprecatedAction: 900,
  deprecatedApi: 901,
  kitNotFound: 1100,
  kitAleadyExists: 1101,
  kitNotAccepted: 1102,
  versionNotFound: 1200,
  sectionNotFound: 2100,
  sectionAlreadyExists: 2101,
  sectionNotAccepted: 2102,
  assetNotFound: 3100,
  assetAlreadyExists: 3101,
  assetNotAccepted: 3102,
  assetReferenceDenied: 3106,
  fileTooLarge: 413,
  fileNotValid: 3300,
  fileNotAccepted: 3302,
  fileCutUnavailable: 3304,
  itemNotFound: 3200,
  itemAlreadyExists: 3201,
  itemNotAccepted: 3202,
  userNotFound: 5100,
  userAlreadyExists: 5101,
  userNotActive: 5102,
  spaceNotAccepted: 7102,
  spaceNotFound: 7101,
  spaceMemberLimitReached: 7103,
  featureUnavailable: 7104,
  invitationAlreadyAccepted: 7201,
  invitationNotFound: 7204,
  joinLinkNotValid: 7304,
  organizationNotFound: 8101,
  organizationNotConfigured: 8304,
  invalidSsoToken: 8305,
  figmaInvalidType: 11103,
  figmaNotFound: 11404,
  figmaRateLimited: 11503,
  googleAuthConfirmationRequired: 15101,
  totpRequired: 14403,
  totpInvalid: 14401,
  totpAlreadyUsed: 14101
};
var LingoError = /*#__PURE__*/function (_Error) {
  _inherits(LingoError, _Error);
  var _super = _createSuper(LingoError);
  function LingoError(json) {
    var _this;
    _classCallCheck(this, LingoError);
    _this = _super.call(this, json.message || "An unexpected error occured");
    _this.code = json.code || 1;
    _this.details = json.details;
    _this.recovery = json.recover;
    _this.LINGO_ERROR = true;
    return _this;
  }
  _createClass(LingoError, null, [{
    key: "isError",
    value: function isError(obj) {
      return obj && obj.LINGO_ERROR === true || false;
    }
  }]);
  return LingoError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
_defineProperty(LingoError, "Code", Code$1);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var errorMessageWhitelist = ["field_errors", "invalid_login", "Previously purchased", "User with that email already exists.", "Space name cannot be empty."];
var callApi = function callApi(endpoint, schema) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var formData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  if (data && formData) {
    throw new Error("Cannot dispatch CALL_API action with both data and formData.");
  }
  return new Promise(function (resolve) {
    var fullUrl = getApiServiceURL(endpoint),
      xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    xhr.withCredentials = true;
    setRequestHeaders(xhr, data, method);
    xhr.onload = function () {
      try {
        if (!this.responseText) {
          resolve({
            error: true,
            code: this.status,
            message: "An error occured"
          });
          return;
        }
        var response = JSON.parse(this.responseText);
        if (this.status === 400) {
          reportError(fullUrl, data, this.status, response.error);
        }
        if (response.success) {
          return schema ? resolve(normalizeResponse(response, schema)) : resolve(response.result);
        }
        var error = response.error;
        if (typeof error === "string") {
          error = {
            message: error,
            code: 0
          };
        }
        return resolve(_objectSpread$4({
          error: true
        }, error));
      } catch (e) {
        if (_lingoConfig.sentryEnabled) {
          Raven.captureException(e);
        } else {
          console.error(e.stack);
        }
        return resolve({
          error: true,
          code: 0
        });
      }
    };
    xhr.onerror = function () {
      resolve({
        code: LingoError.Code.unknown,
        error: true,
        message: "Unable to complete request",
        status: xhr.statusText
      });
    };
    xhr.send(getRequestBody(data, formData));
  });
};
var callApiWithRawResponse = function callApiWithRawResponse(endpoint) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (data && formData) {
    throw new Error("Cannot dispatch CALL_API action with both data and formData.");
  }
  return new Promise(function (resolve) {
    var fullUrl = getApiServiceURL(endpoint),
      xhr = new XMLHttpRequest();
    xhr.open(method, fullUrl, true);
    xhr.withCredentials = true;
    setRequestHeaders(xhr, data, method);
    xhr.onload = function () {
      try {
        if (!this.responseText) {
          resolve({
            error: true,
            code: this.status,
            message: "An error occured"
          });
          return;
        }
        var response = JSON.parse(this.responseText);
        if (this.status === 400) {
          reportError(fullUrl, data, this.status, response.error);
        }
        return resolve(response);
      } catch (e) {
        if (_lingoConfig.sentryEnabled) {
          Raven.captureException(e);
        } else {
          console.error(e.stack);
        }
        return resolve({
          error: true,
          code: 0
        });
      }
    };
    xhr.onerror = function () {
      resolve({
        code: LingoError.Code.unknown,
        error: true,
        message: "Unable to complete request",
        status: xhr.statusText
      });
    };
    xhr.send(getRequestBody(data, formData));
  });
};
var getRequestBody = function getRequestBody(data, formData) {
  if (formData) return formData;
  if (data) return JSON.stringify(data);
  return null;
};
var getFingerprint = function getFingerprint() {
  var fingerprint = Cookie.get("user_fingerprint");
  if (!fingerprint) {
    fingerprint = v4();
    Cookie.set("user_fingerprint", fingerprint, {
      expires: 365
    });
  }
  return fingerprint;
};
var setRequestHeaders = function setRequestHeaders(xhr, data, method) {
  var accessToken = localStorage.getItem("token");
  if (accessToken) {
    xhr.setRequestHeader("Authorization", "Bearer ".concat(accessToken));
  }
  xhr.setRequestHeader("X-lingo-fingerprint", getFingerprint());
  var csrfCookieName = getCSRFCookieName(),
    csrfCookieValue = Cookie.get(csrfCookieName);
  if (csrfCookieValue && !csrfSafeMethod(method)) {
    xhr.setRequestHeader("X-CSRFToken", csrfCookieValue);
  }
  if (data) {
    xhr.setRequestHeader("Content-Type", "application/json");
  }
  return xhr;
};
var csrfSafeMethod = function csrfSafeMethod(method) {
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
};
var reportError = function reportError(url, data, statusCode, errorObj) {
  var messageForLogs = getResponseErrorMessage(errorObj);
  if (_lingoConfig.sentryEnabled) {
    reportToErrorService(url, data, statusCode, errorObj, messageForLogs);
  } else {
    console.error("Error from ".concat(url, ": ").concat(messageForLogs));
  }
};
var getResponseErrorMessage = function getResponseErrorMessage(error) {
  if (typeof error === "string") return error;
  if (error.message) return error.message;
  if (error.field_errors) {
    if (error.field_errors.__all__) return error.field_errors.__all__[0].code;
    return "field_errors";
  }
};
var reportToErrorService = function reportToErrorService(fullUrl, data, statusCode, errorObj, message) {
  if (errorMessageWhitelist.includes(message)) return;
  Raven.setExtraContext({
    Endpoint: fullUrl,
    "Request data": data,
    "Status code": statusCode,
    Response: errorObj
  });
  try {
    throw new Error("".concat(message, " [api]"));
  } catch (e) {
    var errorData = errorObj.code ? {
      fingerprint: ["api", errorObj.code]
    } : {};
    Raven.captureException(e, errorData);
  }
};
var normalizeResponse = function normalizeResponse(response, schema) {
  return schema.normalizer(response.result, schema.schema);
};
var CALL_API = Symbol("Call API");
function makeAction(props) {
  return _defineProperty({}, CALL_API, props);
}
var apiMiddleware = (function (store) {
  return function (next) {
    return function (action) {
      var callAPI = action[CALL_API];
      if (typeof callAPI === "undefined") {
        return next(action);
      }
      var endpoint = callAPI.endpoint;
      var schema = callAPI.schema,
        types = callAPI.types,
        data = callAPI.data,
        method = callAPI.method,
        formData = callAPI.formData;
      if (typeof endpoint === "function") {
        endpoint = endpoint(store.getState());
      }
      if (typeof endpoint !== "string") {
        throw new Error("Specify a string endpoint URL.");
      }
      if (!Array.isArray(types) || types.length !== 3) {
        throw new Error("Expected an array of three action types.");
      }
      if (!types.every(function (type) {
        return typeof type === "string";
      })) {
        throw new Error("Expected action types to be strings.");
      }
      function actionWith(props) {
        var finalAction = _objectSpread$4(_objectSpread$4({}, action), props);
        delete finalAction[CALL_API];
        return finalAction;
      }
      var _types = _slicedToArray(types, 3),
        requestType = _types[0],
        successType = _types[1],
        failureType = _types[2];
      next(actionWith({
        type: requestType,
        apiRequest: true
      }));
      return callApi(endpoint, schema, method, data, formData).then(function (response) {
        if (response.error) {
          return next(actionWith({
            type: failureType,
            apiResponse: true,
            statusCode: response.code,
            error: response
          }));
        }
        return next(actionWith({
          type: successType,
          response: response,
          apiResponse: true,
          page: callAPI.page
        }));
      });
    };
  };
});

var LottieContainer = styled(Box$1).withConfig({
  displayName: "LottieAnimation__LottieContainer"
})(["position:absolute;top:0;left:0;height:100%;width:100%;opacity:0;transition:opacity 0.3s ease;", ""], function (props) {
  return props.loaded && "\n    opacity: 1;\n  ";
});
var AbsoluteContainer = styled(Box$1).withConfig({
  displayName: "LottieAnimation__AbsoluteContainer"
})(["position:absolute;top:0;left:0;height:100%;width:100%;display:flex;justify-content:center;align-items:center;"]);
var LottieAnimation = function LottieAnimation(_ref) {
  var permalink = _ref.permalink;
  var lottieContainerRef = useRef();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    animationData = _useState2[0],
    setAnimationData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    failed = _useState6[0],
    setFailed = _useState6[1];
  if (!permalink.includes("/v4/")) console.warn("Lottie permalink must be a valid API url");
  var endpoint = permalink.split("/v4/")[1];
  if (endpoint.includes("?")) endpoint += "&response=data";else endpoint += "?response=data";

  /**
   * Need to fetch the raw json from our asset permalink
   */
  useEffect(function () {
    setLoaded(false);
    setFailed(false);
    callApiWithRawResponse(endpoint).then(function (data) {
      if (data.error) return setFailed(true);
      setAnimationData(data);
      setLoaded(true);
    }).catch(function (err) {
      console.log({
        err: err
      });
      setFailed(true);
    });
  }, [endpoint, permalink]);

  /**
   * Once asset json has been fetched, initialize the animation
   */
  useEffect(function () {
    if (!animationData) return;
    var lottieInstance = lottie.loadAnimation({
      container: lottieContainerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData
    });

    /**
     * If the JSON can be fetched, but it's invalid upon loading
     */
    lottieInstance.addEventListener("data_failed", function () {
      return setFailed(true);
    });
    return function () {
      lottieInstance.destroy();
    };
  }, [animationData, permalink]);
  return /*#__PURE__*/React.createElement(Fragment, null, !loaded && !failed && /*#__PURE__*/React.createElement(AbsoluteContainer, null, /*#__PURE__*/React.createElement(ActivityIndicator$1, {
    size: "small",
    color: color.grayDark,
    center: true
  })), failed && /*#__PURE__*/React.createElement(AbsoluteContainer, null, /*#__PURE__*/React.createElement(Notice$1, {
    noticeStyle: "error",
    message: "Oops! Failed to load Lottie JSON."
  })), /*#__PURE__*/React.createElement(LottieContainer, {
    loaded: loaded,
    ref: lottieContainerRef
  }));
};
var LottieAnimation$1 = LottieAnimation;

var VideoInner = Box$1;
var VideoContainer = styled(Box$1).attrs({
  position: "relative"
}).withConfig({
  displayName: "Video__VideoContainer"
})(["margin:0 auto;video,.mask{height:100%;width:100%;position:absolute;top:0;left:0;}.mask{&:after{content:\"\";position:absolute;top:0;left:0;height:100%;width:100%;background:rgba(0,0,0,0.2);z-index:2;}img{position:relative;z-index:0;width:100%;}svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;z-index:5;filter:drop-shadow(0px 4px 14px rgba(42,42,42,0.12)) drop-shadow(0px 1px 4px rgba(42,42,42,0.2));}}"]);
var Video = function Video(_ref) {
  var src = _ref.src,
    placeholder = _ref.placeholder,
    type = _ref.type,
    dimensions = _ref.dimensions,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? true : _ref$muted;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playing = _useState2[0],
    setPlaying = _useState2[1],
    videoRef = useRef(),
    playVideo = useCallback(function () {
      videoRef.current.play().catch(function () {
        videoRef.current.muted = muted;
        return videoRef.current.play();
      });
    }, [muted]);
  var _dimensions$split$map = dimensions.split("x").map(function (d) {
      return Number(d);
    }),
    _dimensions$split$map2 = _slicedToArray(_dimensions$split$map, 2),
    width = _dimensions$split$map2[0],
    height = _dimensions$split$map2[1],
    videoContainerProps = {
      width: "100%",
      maxWidth: width
    },
    videoInnerProps = {
      width: "100%",
      pb: "".concat(height / width * 100, "%")
    };
  if (!src) return null;
  return /*#__PURE__*/React.createElement(VideoContainer, videoContainerProps, /*#__PURE__*/React.createElement(VideoInner, videoInnerProps, playing ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    poster: placeholder,
    controls: true,
    autoPlay: true,
    onCanPlay: playVideo
  }, /*#__PURE__*/React.createElement("source", {
    src: src,
    type: "video/".concat(type.toLowerCase().replace("mov", "mp4"))
  }), /*#__PURE__*/React.createElement("p", null, "Sorry, this video can't be played in this browser.")) : /*#__PURE__*/React.createElement("div", {
    className: "mask"
  }, placeholder && /*#__PURE__*/React.createElement("img", {
    src: placeholder
  }), /*#__PURE__*/React.createElement(Icon$1, {
    onClick: function onClick() {
      return setPlaying(true);
    },
    fill: "white",
    iconId: "play-video",
    size: "60"
  }))));
};
var Video$1 = Video;

var _excluded$5 = ["asset", "className", "background", "maxHeight", "imageSize"];
var stretchingVideoTestId = "stretching-asset-video";
var stretchingImageTestId = "stretching-asset-image";
var stretchingLottieTestId = "stretching-asset-lottie";
var spinning = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(960deg);}"]);
var StretchingAssetContainer = styled(Box$1).attrs({
  width: "100%",
  borderRadius: "default",
  p: "m"
}).withConfig({
  displayName: "StretchingAsset__StretchingAssetContainer"
})(["", ""], function (props) {
  return props.isImage && css(["& svg{animation:", " 1s ease-in-out infinite alternate;transform-origin:50% 50%;}& svg::selection{background:transparent;}"], spinning);
});
var MotionContainer = styled(Box$1).withConfig({
  displayName: "StretchingAsset__MotionContainer"
})(["position:relative;"]);
var LoadingContainer = styled(Box$1).withConfig({
  displayName: "StretchingAsset__LoadingContainer"
})(["width:100%;"]);
var StretchingAsset = function StretchingAsset(_ref) {
  var asset = _ref.asset,
    className = _ref.className,
    background = _ref.background,
    maxHeight = _ref.maxHeight,
    imageSize = _ref.imageSize,
    rest = _objectWithoutProperties(_ref, _excluded$5);
  var measuredRef = useRef(null);
  var _useRect = useRect(measuredRef),
    width = _useRect.width;
  var paddingInt = getContainerPadding(measuredRef.current);
  var height = getStretchingAssetHeight(asset.dimensions, width - paddingInt, maxHeight);
  var isImage = [AssetType.jpg, AssetType.png, AssetType.gif].includes(asset.type),
    isGif = [AssetType.gif].includes(asset.type),
    isLottie = [AssetType.lottie].includes(asset.type),
    isVideo = [AssetType.mp4, AssetType.mov].includes(asset.type);
  var thumbnailMap = {
    large: asset.thumbnails ? asset.thumbnails["1232"] : asset.permalink,
    medium: asset.thumbnails ? asset.thumbnails["480"] : asset.permalink,
    small: asset.thumbnails ? asset.thumbnails["292"] : asset.permalink,
    full: asset.permalink
  };
  var isProcessing = asset.meta && asset.meta.assetProcessing === "processing";
  function responsiveImageUrl() {
    // If it's a GIF, return the original file, as the generated thumbs are static
    if (isGif) return thumbnailMap.full;

    // If an image size has been specified, return that one
    if (imageSize && thumbnailMap[imageSize]) {
      return thumbnailMap[imageSize];
    }

    // If no explicit image size is set, load the proper thumnail size given the ref width
    var _asset$dimensions$spl = asset.dimensions.split("x").map(function (d) {
        return parseInt(d, 10);
      }),
      _asset$dimensions$spl2 = _slicedToArray(_asset$dimensions$spl, 2),
      assetWidth = _asset$dimensions$spl2[0],
      assetHeight = _asset$dimensions$spl2[1];
    var containerSize = Math.max(width, height),
      assetSize = Math.max(assetWidth, assetHeight),
      desiredSize = Math.min(assetSize, containerSize);
    if (desiredSize === 0) return null;
    if (desiredSize <= 292) return thumbnailMap.small;
    if (desiredSize <= 480) return thumbnailMap.medium;
    if (desiredSize <= 1232) return thumbnailMap.large;
    return thumbnailMap.full;
  }
  function renderAssetComponent() {
    // Loading container has an arbitrary fallback height of 120px for when user
    // uploads content and it's still processing without dimension data.

    if (isProcessing) return /*#__PURE__*/React.createElement(LoadingContainer, {
      height: height || "120px"
    }, /*#__PURE__*/React.createElement(ActivityIndicator$1, {
      size: "small",
      center: true,
      color: color.grayDark
    }));
    if (isVideo) return /*#__PURE__*/React.createElement(MotionContainer, {
      "data-testid": stretchingVideoTestId,
      height: height
    }, /*#__PURE__*/React.createElement(Video$1, {
      src: asset.permalink,
      placeholder: responsiveImageUrl(),
      dimensions: asset.dimensions,
      type: asset.type,
      muted: false
    }));
    if (isLottie) return /*#__PURE__*/React.createElement(MotionContainer, {
      "data-testid": stretchingLottieTestId,
      height: height
    }, /*#__PURE__*/React.createElement(LottieAnimation$1, {
      permalink: asset.permalink
    }));
    return /*#__PURE__*/React.createElement(ImageView$1, {
      id: stretchingImageTestId,
      src: responsiveImageUrl(),
      icon: "spinner",
      background: background,
      height: height
    });
  }
  return /*#__PURE__*/React.createElement(StretchingAssetContainer, _extends({
    ref: measuredRef,
    className: className,
    background: background,
    isImage: isImage
  }, rest), renderAssetComponent());
};
var getContainerPadding = function getContainerPadding(el) {
  if (!el) return 0;
  var extractPixelInt = function extractPixelInt(computedStyle, propertyName) {
    var propVal = computedStyle.getPropertyValue(propertyName);
    var propValNum = propVal.match(/[0-9]+/);
    if (propValNum !== null) return parseInt(propValNum[0], 10);
    return 0;
  };
  var compStyle = getComputedStyle(el);
  return extractPixelInt(compStyle, "padding-left") + extractPixelInt(compStyle, "padding-right");
};
var getStretchingAssetHeight = function getStretchingAssetHeight(dimensions, maxWidth) {
  var maxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
  var result = 0;
  var _dimensions$split$map = dimensions.split("x").map(function (d) {
      return parseInt(d, 10);
    }),
    _dimensions$split$map2 = _slicedToArray(_dimensions$split$map, 2),
    width = _dimensions$split$map2[0],
    height = _dimensions$split$map2[1];
  if (width <= maxWidth) {
    result = height;
  } else {
    var scaleBy = maxWidth / width;
    result = height * scaleBy;
  }
  return Math.min(result, maxHeight);
};
var StretchingAsset$1 = StretchingAsset;

function getElement(idOrNode) {
  if (typeof idOrNode === "string") {
    return document.getElementById(idOrNode);
  } else {
    return idOrNode;
  }
}

/**
 * Helper function to focus an input element, and place the users cursor at the end of the predefined content
 * @param {String|Node} idOrNode Dom input node OR its ID value
 */
function focusEndOfInput(idOrNode) {
  var inputEl = getElement(idOrNode);
  if (inputEl) {
    inputEl.focus();
    inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
  } else console.warn("No input element detected - make sure you've applied it on the target node.");
}

/**
 * Helper function to focus an input element, and highlight all text inside of it
 * @param {String|Node} idOrNode Dom input node OR its ID value
 */
function focusAllOfInput(idOrNode) {
  var inputEl = getElement(idOrNode);
  if (inputEl) {
    inputEl.focus();
    inputEl.select();
  } else console.warn("No input element detected - make sure you've applied it on the target node.");
}

var keyCodes = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  delete: 46,
  comma: 188,
  shift: 16,
  meta: 91
};
var keyCodes$1 = keyCodes;

var keyNames = {
  enter: "Enter",
  shift: "Shift",
  meta: "Meta"
};
var keyNames$1 = keyNames;

function shouldSubmit(e, multiline) {
  var enterKey = e.which === keyCodes$1.enter || [e.key, e.code].includes(keyNames$1.enter);
  return multiline ? enterKey && e.metaKey : enterKey;
}
function useSubmitTextKeys(multiline) {
  return useCallback(function (e) {
    if (shouldSubmit(e, multiline)) {
      e.preventDefault();
      e.target.blur();
    }
  }, [multiline]);
}

var _excluded$4 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing", "onInitiateUpload", "align", "children"];
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var RowClear = styled(Box$1).attrs({
  height: 0,
  flex: "1 1 100%"
}).withConfig({
  displayName: "GalleryGuide__RowClear"
})([""]);
var StyledStretchingImage = styled(StretchingAsset$1).attrs({
  background: "grayLightest"
}).withConfig({
  displayName: "GalleryGuide__StyledStretchingImage"
})(["pointer-events:none;"]);
var UploadImageButton = styled(Button$1).attrs(function (props) {
  return {
    p: "m",
    buttonStyle: "tertiary",
    text: "＋ Add Image",
    fontStyle: "ui.regularBold",
    theme: _objectSpread$3(_objectSpread$3({}, props.theme), {}, {
      primaryColor: "grayDark",
      primaryColorDark: "grayDarker"
    }),
    width: "100%"
  };
}).withConfig({
  displayName: "GalleryGuide__UploadImageButton"
})(["&:hover{text-decoration:none;}"]);
var Rule = styled.hr.withConfig({
  displayName: "GalleryGuide__Rule"
})(["border:none;border-top:3px solid ", ";", ";", ";transition:border-color 0.2s ease;"], function (props) {
  return getColor(props.color, "grayDarker");
}, margin.a.none, margin.b.s);
var TextWrapper = styled(Flex$1).attrs({
  pb: 1
}).withConfig({
  displayName: "GalleryGuide__TextWrapper"
})(["", ""], function (props) {
  return props.canEdit && !props.isEditing && "\n    cursor: pointer;\n  ";
});
var Textarea$3 = styled(AutosizeTextarea).withConfig({
  displayName: "GalleryGuide__Textarea"
})(["", ";", ";background:transparent;border-radius:", ";border:none;resize:none;width:100%;", " color:", ";line-height:inherit;margin:0;font-feature-settings:inherit;&:focus{outline:none;}"], padding.x.s, padding.y.none, borderRadius.default, function (props) {
  return getFont(null, "gallery.regular", props);
}, color.black);
var DropDownButton = styled(Flex$1).attrs({
  justifyContent: "space-between",
  alignItems: "center",
  height: 28
}).withConfig({
  displayName: "GalleryGuide__DropDownButton"
})(["cursor:pointer;"]);
var DropDownText = styled(Text).attrs({
  pr: "xs"
}).withConfig({
  displayName: "GalleryGuide__DropDownText"
})(["color:", ";transition:color 0.2s ease;", ":hover &{color:", ";}"], function (props) {
  return getColor(props.color, "grayDarker");
}, DropDownButton, function (props) {
  return getColor(props.color, "grayDarkest");
});
var DropDownIcon = styled(Icon$1).attrs({
  iconId: "triangle-double"
}).withConfig({
  displayName: "GalleryGuide__DropDownIcon"
})(["fill:", ";transition:fill 0.2s ease;", ":hover &{fill:", ";}"], function (props) {
  return getColor(props.fill, "grayDarker");
}, DropDownButton, getColor("grayDarkest"));
var SelectionWrapper$2 = styled(Box$1).attrs(function (props) {
  return {
    borderRadius: "default",
    m: "-2px",
    border: "2px solid ".concat(props.selected ? getColor(props.theme.primaryColor, "primary") : "transparent")
  };
}).withConfig({
  displayName: "GalleryGuide__SelectionWrapper"
})([""]);
var GalleryGuide = function GalleryGuide(_ref) {
  var item = _ref.item,
    selected = _ref.selected,
    canEdit = _ref.canEdit,
    isEditing = _ref.isEditing,
    hasDefaultValue = _ref.hasDefaultValue,
    onBeginEditing = _ref.onBeginEditing,
    onFinishEditing = _ref.onFinishEditing,
    onInitiateUpload = _ref.onInitiateUpload,
    align = _ref.align,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded$4);
  var asset = item.asset,
    _item$data = item.data,
    textContent = _item$data.textContent,
    displayStyle = _item$data.displayStyle,
    accentColor = _item$data.color,
    title = _item$data.title;
  var _useState = useState(textContent),
    _useState2 = _slicedToArray(_useState, 2),
    editValue = _useState2[0],
    setEditValue = _useState2[1],
    _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hovering = _useState4[0],
    setHovering = _useState4[1],
    _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    titleDropdownOpen = _useState6[0],
    setTitleDropdownOpen = _useState6[1],
    _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    styleDropdownOpen = _useState8[0],
    setStyleDropdownOpen = _useState8[1],
    textInputRef = useRef(null);
  var beginEditing = useCallback(function () {
      if (onBeginEditing) onBeginEditing(item.id);
    }, [item, onBeginEditing]),
    finishEditing = useCallback(function () {
      if (!isEditing || !canEdit || !onFinishEditing) return;
      // Do not submit if the original content hasn't changed
      var val = editValue.trim();
      // guides should reset their text if set to empty string
      if (item.data.textContent.trim() === val || val === "") {
        return onFinishEditing(item, null);
      }
      var data = {
        data: {
          content: val
        }
      };
      onFinishEditing(item, data);
    }, [isEditing, canEdit, onFinishEditing, editValue, item]);
  var onInputChange = useCallback(function (e) {
    return setEditValue(e.target.value);
  }, []);
  var onMouseEnter = useCallback(function () {
      return setHovering(true);
    }, []),
    onMouseLeave = useCallback(function () {
      return setHovering(false);
    }, []);
  var onClickTitle = useCallback(function () {
      return setTitleDropdownOpen(true);
    }, []),
    onCloseTitleDropdown = useCallback(function () {
      return setTitleDropdownOpen(false);
    }, []),
    onChangeTitle = function onChangeTitle(newTitle, newColor) {
      if (!onFinishEditing || newTitle === title) return;
      onFinishEditing(item, {
        data: {
          title: newTitle,
          color: newColor
        }
      });
    };
  var onClickStyle = useCallback(function () {
      return setStyleDropdownOpen(true);
    }, []),
    onCloseStyleDropdown = useCallback(function () {
      return setStyleDropdownOpen(false);
    }, []),
    onChangeStyle = function onChangeStyle(newStyle) {
      if (!onFinishEditing || newStyle === displayStyle) return;
      onFinishEditing(item, {
        data: {
          display_style: newStyle
        },
        asset_uuid: null
      });
    };
  var onClickUpload = useCallback(function () {
    return onInitiateUpload(item);
  }, [onInitiateUpload, item]);
  /**
   * Every time the edit mode changes, make sure the latest version
   * of the content prop is hydrated in the editValue state variable.
   */
  useEffect(function () {
    setEditValue(textContent);
  }, [isEditing, textContent]);

  /**
   * Focus and place cursor at the end of the textarea content when it appears.
   * Due to refs not causing a render, this actually fires as a side effect on the following render.
   */
  useEffect(function () {
    if (isEditing) (hasDefaultValue ? focusAllOfInput : focusEndOfInput)(textInputRef.current);
  }, [hasDefaultValue, isEditing]);
  var onKeyDown = useSubmitTextKeys(true);
  var displayColor = !accentColor || ["green", "red"].includes(accentColor) ? color[accentColor || "green"] : accentColor;
  var alignment = {
    pl: align === "right" ? "m" : "s",
    pr: align === "left" ? "m" : "s",
    flex: align === "left" || align === "right" ? "0 0 50%" : "1 1 100%",
    position: "relative"
  };
  function renderImage() {
    if (displayStyle !== "image") return null;
    if (asset) {
      return /*#__PURE__*/React.createElement(StyledStretchingImage, {
        asset: asset,
        maxHeight: 600
      });
    }
    if (canEdit && onInitiateUpload) {
      return /*#__PURE__*/React.createElement(Box$1, {
        background: "grayLightest",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(UploadImageButton, {
        onClick: onClickUpload
      }));
    }
  }
  function renderTitleDropdown() {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(DropDownButton, {
      "data-testid": "guide-title",
      mx: "xs",
      onClick: onClickTitle,
      "data-popup-source": "guide-title-select-".concat(item.id)
    }, /*#__PURE__*/React.createElement(DropDownText, {
      color: displayColor,
      font: "ui.regularBold"
    }, title), /*#__PURE__*/React.createElement(DropDownIcon, {
      fill: hovering ? displayColor : "transparent"
    })), titleDropdownOpen && /*#__PURE__*/React.createElement(PopupMenu, {
      source: "guide-title-select-".concat(item.id),
      close: onCloseTitleDropdown,
      vPos: "alignTop",
      hPos: "alignLeft"
    }, [["DO", "green"], ["DON'T", "red"]].map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        command = _ref3[0],
        commandColor = _ref3[1];
      return /*#__PURE__*/React.createElement(PopupMenu.Item, {
        key: command,
        "data-testid": "guide-title-".concat(command),
        checked: title === command,
        title: command,
        onClick: function onClick() {
          return onChangeTitle(command, commandColor);
        }
      });
    })));
  }
  function renderStyleDropdown() {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(DropDownButton, {
      "data-testid": "guide-style",
      mx: "xs",
      onClick: onClickStyle,
      "data-popup-source": "guide-style-select-".concat(item.id)
    }, /*#__PURE__*/React.createElement(DropDownText, {
      color: hovering ? undefined : "transparent",
      font: "ui.regularSemiBold"
    }, displayStyle === "image" ? "Image & Text" : "Text Only"), /*#__PURE__*/React.createElement(DropDownIcon, {
      fill: hovering ? undefined : "transparent"
    })), styleDropdownOpen && /*#__PURE__*/React.createElement(PopupMenu, {
      source: "guide-style-select-".concat(item.id),
      close: onCloseStyleDropdown,
      vPos: "alignTop",
      hPos: "alignLeft"
    }, [["Image & Text", "image"], ["Text Only", "text_only"]].map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        text = _ref5[0],
        style = _ref5[1];
      return /*#__PURE__*/React.createElement(PopupMenu.Item, {
        key: style,
        "data-testid": "guide-style-".concat(style),
        checked: displayStyle === style,
        title: text,
        onClick: function onClick() {
          return onChangeStyle(style);
        }
      });
    })));
  }
  function renderStatic() {
    return /*#__PURE__*/React.createElement(Box$1, _extends({}, alignment, {
      "data-testid": "guide-static-wrapper",
      mb: "l"
    }, rest), /*#__PURE__*/React.createElement(SelectionWrapper$2, {
      selected: selected
    }, renderImage(), /*#__PURE__*/React.createElement(Rule, {
      color: displayColor
    }), /*#__PURE__*/React.createElement(Text, {
      "data-testid": "guide-title",
      color: displayColor,
      font: "ui.regularBold",
      mb: "s",
      mx: "xs"
    }, title), /*#__PURE__*/React.createElement(Box$1, {
      "data-testid": "guide-text"
    }, /*#__PURE__*/React.createElement(GalleryMarkdown$1, null, textContent))));
  }
  function renderEditable() {
    return /*#__PURE__*/React.createElement(Box$1, _extends({}, alignment, {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      "data-testid": "guide-editable-wrapper",
      mb: "l"
    }, rest), /*#__PURE__*/React.createElement(SelectionWrapper$2, {
      selected: selected
    }, children, renderImage(), /*#__PURE__*/React.createElement(Rule, {
      color: displayColor
    }), /*#__PURE__*/React.createElement(Flex$1, {
      justifyContent: "space-between",
      mb: "s"
    }, renderTitleDropdown(), renderStyleDropdown()), /*#__PURE__*/React.createElement(TextWrapper, {
      canEdit: canEdit,
      isEditing: isEditing
    }, isEditing ? /*#__PURE__*/React.createElement(Textarea$3, {
      ref: textInputRef,
      "data-testid": "guide-editable-text",
      value: editValue,
      onChange: onInputChange,
      onBlur: finishEditing,
      onKeyDown: onKeyDown,
      "aria-label": "Update guide text",
      maxRows: 1000
    }) : /*#__PURE__*/React.createElement(Box$1, {
      width: "100%",
      onDoubleClick: canEdit ? beginEditing : null,
      "data-testid": "guide-text"
    }, /*#__PURE__*/React.createElement(GalleryMarkdown$1, null, textContent)))));
  }
  return /*#__PURE__*/React.createElement(Fragment, null, align === "left" ? /*#__PURE__*/React.createElement(RowClear, null) : null, canEdit ? renderEditable() : renderStatic());
};
var GalleryGuide$1 = GalleryGuide;

var headingTestId = "gallery-heading-text";
var wrapperTestId$3 = "gallery-heading-wrapper";
var editorTestId$2 = "gallery-heading-editor";
var Wrapper$2 = styled(Box$1).attrs(function (props) {
  return {
    mx: "s",
    flex: "1 1 100%",
    background: props.selected && props.canEdit ? "gallerySelection" : null,
    borderRadius: "default"
  };
}).withConfig({
  displayName: "GalleryHeading__Wrapper"
})(["position:\"relative\";", ""], function (props) {
  return !props.canEdit && "\n    pointer-events: none;\n  ";
});
var HeadingText = styled(Text).attrs({
  as: "h2",
  font: "gallery.heading",
  color: "black",
  borderRadius: "default",
  px: "xs"
}).withConfig({
  displayName: "GalleryHeading__HeadingText"
})(["word-break:break-word;", " &:first-child{margin-top:0;}"], function (props) {
  return !props.canEdit ? "\n    pointer-events: none;\n  " : "\n    cursor: pointer;\n  ";
});
var Textarea$2 = styled(AutosizeTextarea).withConfig({
  displayName: "GalleryHeading__Textarea"
})(["min-height:42px;padding:0;background:", ";border-radius:", ";border:none;resize:none;width:100%;", " margin:0;font-feature-settings:inherit;&:focus{outline:none;}"], color.grayLighter, borderRadius.default, function (props) {
  return getFont(null, "gallery.heading", props);
});
var GalleryHeading = function GalleryHeading(_ref) {
  var item = _ref.item,
    selected = _ref.selected,
    canEdit = _ref.canEdit,
    isEditing = _ref.isEditing,
    hasDefaultValue = _ref.hasDefaultValue,
    onBeginEditing = _ref.onBeginEditing,
    onFinishEditing = _ref.onFinishEditing,
    itemId = _ref["data-itemid"],
    onClick = _ref.onClick;
  var _useState = useState(item.data.textContent),
    _useState2 = _slicedToArray(_useState, 2),
    editValue = _useState2[0],
    setEditValue = _useState2[1];

  // Refs
  var editorRef = useRef(null);
  var beginEditing = useCallback(function () {
      if (onBeginEditing) onBeginEditing(item.id);
    }, [item, onBeginEditing]),
    finishEditing = useCallback(function () {
      if (!isEditing || !canEdit || !onFinishEditing) return;

      // Do not submit if the original content hasn't changed
      var val = editValue.trim();
      if (item.data.textContent === val) return onFinishEditing(item, null);
      var data = {
        data: {
          content: val
        }
      };
      onFinishEditing(item, data);
    }, [isEditing, canEdit, onFinishEditing, item, editValue]);

  /**
   * Every time the edit mode changes, make sure the latest version
   * of the content prop is hydrated in the editValue state variable.
   *
   * If opening edit mode, select the text within the textarea for manipulation.
   */
  useEffect(function () {
    setEditValue(item.data.textContent);
    if (isEditing && editorRef.current) {
      (hasDefaultValue ? focusAllOfInput : focusEndOfInput)(editorRef.current);
    }
  }, [hasDefaultValue, isEditing, item.data.textContent]);
  var onKeyDown = useSubmitTextKeys(false);
  var headingTextProps = {
    canEdit: canEdit,
    selected: selected,
    onDoubleClick: canEdit ? beginEditing : undefined
  };
  return /*#__PURE__*/React.createElement(Wrapper$2, {
    id: item.shortId,
    "data-testid": wrapperTestId$3,
    "data-itemid": itemId,
    canEdit: canEdit,
    selected: selected,
    onClick: onClick
  }, isEditing ? /*#__PURE__*/React.createElement(Textarea$2, {
    "aria-label": "Update heading text",
    "data-testid": editorTestId$2,
    ref: editorRef,
    value: editValue,
    onBlur: finishEditing,
    onChange: function onChange(e) {
      return setEditValue(e.target.value);
    },
    onKeyDown: onKeyDown
  }) : /*#__PURE__*/React.createElement(HeadingText, _extends({}, headingTextProps, {
    "data-testid": headingTestId
  }), item.data.textContent));
};
var GalleryHeading$1 = GalleryHeading;

var _excluded$3 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing"];
var noteTestId = "gallery-note-text";
var editorTestId$1 = "gallery-note-editor";
var wrapperTestId$2 = "gallery-note-wrapper";
var Wrapper$1 = styled(Box$1).attrs(function (props) {
  return {
    px: "s",
    flex: "1 1 100%",
    minHeight: props.minHeight
  };
}).withConfig({
  displayName: "GalleryNote__Wrapper"
})(["transition:min-height 0.4s ease;", ""], function (props) {
  return props.canEdit && !props.isEditing && "\n    cursor: pointer;\n  ";
});
var Textarea$1 = styled(AutosizeTextarea).withConfig({
  displayName: "GalleryNote__Textarea"
})(["min-height:42px;padding:0;background:", ";border-radius:", ";border:none;resize:none;width:100%;", ";", " color:", ";line-height:inherit;margin:0;font-feature-settings:inherit;&:focus{outline:none;}"], color.white, borderRadius.default, padding.l.s, function (props) {
  return getFont(null, "ui.regular", props);
}, color.black);
var helperAnimation = keyframes(["from{opacity:0;top:8px;}to{opacity:1;top:0;}"]);
var HelperText = styled(Flex$1).attrs({
  alignItems: "center",
  mt: "m"
}).withConfig({
  displayName: "GalleryNote__HelperText"
})(["animation:", " 0.4s ease;position:relative;"], helperAnimation);
var GalleryNote = function GalleryNote(_ref) {
  var item = _ref.item,
    selected = _ref.selected,
    canEdit = _ref.canEdit,
    isEditing = _ref.isEditing,
    hasDefaultValue = _ref.hasDefaultValue,
    onBeginEditing = _ref.onBeginEditing,
    onFinishEditing = _ref.onFinishEditing,
    rest = _objectWithoutProperties(_ref, _excluded$3);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    preventOnBlur = _useState2[0],
    setPreventOnBlur = _useState2[1];
  var _useState3 = useState("unset"),
    _useState4 = _slicedToArray(_useState3, 2),
    minHeight = _useState4[0],
    setMinHeight = _useState4[1];
  var _useState5 = useState(item.data.textContent),
    _useState6 = _slicedToArray(_useState5, 2),
    editValue = _useState6[0],
    setEditValue = _useState6[1];
  var editorRef = useRef();
  var noteRef = useRef();

  /**
   * Every time the edit mode changes, make sure the latest version
   * of the content prop is hydrated in the editValue state variable.
   *
   * Focus and place cursor at the end of the textara content when entering edit mode
   */
  useEffect(function () {
    setEditValue(item.data.textContent);
    if (isEditing) {
      (hasDefaultValue ? focusAllOfInput : focusEndOfInput)(editorRef.current);
    }
  }, [item, isEditing, hasDefaultValue]);

  /**
   * Every time the edit mode or item changes, watch both the
   * editor and inlineNote wrapper for its height, then set the
   * parent wrapper's minHeight based on it.  This is to prevent
   * odd flashes of the surrounding content when toggling modes.
   */
  useEffect(function () {
    if (!canEdit) return;
    var heightTimer = setTimeout(function () {
      if (!isEditing && noteRef.current) {
        var _noteRef$current;
        setMinHeight("".concat((_noteRef$current = noteRef.current) === null || _noteRef$current === void 0 ? void 0 : _noteRef$current.clientHeight, "px"));
      }
      if (isEditing && editorRef.current) {
        var _editorRef$current;
        setMinHeight("".concat((_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.clientHeight, "px"));
      }
    }, 100);
    return function () {
      return clearTimeout(heightTimer);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, item, editValue]);
  var beginEditing = useCallback(function () {
      if (onBeginEditing) onBeginEditing(item.id);
    }, [item, onBeginEditing]),
    finishEditing = useCallback(function () {
      if (!isEditing || !canEdit || !onFinishEditing) return;
      // Do not submit if the original content hasn't changed
      var val = editValue.trim();
      if (item.data.textContent.trim() === val) {
        return onFinishEditing(item, null);
      }
      var data = {
        data: {
          content: val
        }
      };
      onFinishEditing(item, data);
    }, [canEdit, editValue, isEditing, item, onFinishEditing]);
  var onKeyDown = useSubmitTextKeys(true);
  var noteProps = {
    canEdit: canEdit,
    borderRadius: "default",
    background: selected ? "gallerySelection" : null,
    onDoubleClick: canEdit ? beginEditing : null
  };
  return /*#__PURE__*/React.createElement(Wrapper$1, _extends({
    "data-testid": wrapperTestId$2,
    canEdit: canEdit,
    isEditing: isEditing,
    minHeight: minHeight
  }, rest), isEditing ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Textarea$1, {
    ref: editorRef,
    "data-testid": editorTestId$1,
    "aria-label": "Update inline note",
    value: editValue,
    onKeyDown: onKeyDown,
    onBlur: !preventOnBlur ? finishEditing : function () {
      var _editorRef$current2;
      return (_editorRef$current2 = editorRef.current) === null || _editorRef$current2 === void 0 ? void 0 : _editorRef$current2.focus();
    },
    onChange: function onChange(e) {
      return setEditValue(e.target.value);
    },
    maxRows: 1000
  }), /*#__PURE__*/React.createElement(HelperText, {
    onMouseEnter: function onMouseEnter() {
      return setPreventOnBlur(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setPreventOnBlur(false);
    }
  }, /*#__PURE__*/React.createElement(Text, {
    font: "ui.small"
  }, "Text formatting is supported."), /*#__PURE__*/React.createElement(Button$1, {
    p: "none",
    ml: "s",
    buttonStyle: "tertiary",
    size: "small",
    link: "https://www.lingoapp.com/help/note-formatting",
    text: "Learn more.",
    newWindow: true
  }))) : /*#__PURE__*/React.createElement(Box$1, _extends({}, noteProps, {
    ref: noteRef,
    "data-testid": noteTestId
  }), /*#__PURE__*/React.createElement(GalleryMarkdown$1, null, item.data.textContent)));
};
var GalleryNote$1 = GalleryNote;

function useClipboard(value) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasCopied = _useState2[0],
    setHasCopied = _useState2[1];
  var onCopy = useCallback(function () {
    var didCopy = copy(value);
    setHasCopied(didCopy);
  }, [value]);
  var onClickInputToCopy = useCallback(function (e) {
    e === null || e === void 0 ? void 0 : e.target.select();
    onCopy();
  }, [onCopy]);
  useEffect(function () {
    if (hasCopied) {
      var id = setTimeout(function () {
        setHasCopied(false);
      }, timeout);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [hasCopied, timeout]);
  return {
    value: value,
    onCopy: onCopy,
    hasCopied: hasCopied,
    onClickInputToCopy: onClickInputToCopy
  };
}

var codeLangs = ["Auto", "Plaintext", "Markdown", "JSON", "Javascript", "Typescript", "HTML", "XML", "YAML", "CSS", "Less", "Swift", "ObjectiveC", "Python", "PHP", "Perl", "Java"];
var codeLangs$1 = codeLangs;

hljs.registerLanguage("plaintext", plaintext);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("json", json);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("css", cssLang);
hljs.registerLanguage("less", less);
hljs.registerLanguage("swift", swift);
hljs.registerLanguage("objectivec", objectivec);
hljs.registerLanguage("python", python);
hljs.registerLanguage("php", php);
hljs.registerLanguage("perl", perl);
hljs.registerLanguage("java", java);
function useCodeHighlighting(textContent, language) {
  var codeSnippetRef = useRef(null);
  useLayoutEffect(function () {
    var currentNode = codeSnippetRef.current;
    if (currentNode && textContent) {
      if (!language || language === "Auto") {
        currentNode.innerHTML = hljs.highlightAuto(textContent).value;
      } else currentNode.innerHTML = hljs.highlight(textContent, {
        language: language.toLowerCase()
      }).value;
    }
  }, [language, textContent]);
  return codeSnippetRef;
}

var _excluded$2 = ["item", "selected", "canEdit", "isEditing", "hasDefaultValue", "onBeginEditing", "onFinishEditing"];
var editorTestId = "gallery-code-snippet-editor";
var wrapperTestId$1 = "gallery-code-snippet-wrapper";
var parentTestId = "gallery-code-snippet-parent";
var selectTestId = "gallery-code-snippet-select";
var Wrapper = styled(Box$1).attrs(function (props) {
  return {
    mx: props.mx || "s",
    border: "1px solid ".concat(props.selected ? "transparent" : "border"),
    background: "grayLightest",
    borderRadius: "default",
    width: "100%"
  };
}).withConfig({
  displayName: "GalleryCodeSnippet__Wrapper"
})([""]);
var SelectionWrapper$1 = styled(Box$1).attrs(function (props) {
  return {
    borderRadius: "default",
    m: "-2px",
    border: "2px solid ".concat(props.selected ? getColor(props.theme.primaryColor, "primary") : "transparent")
  };
}).withConfig({
  displayName: "GalleryCodeSnippet__SelectionWrapper"
})([""]);
var Pre = styled(Text).attrs({
  as: "pre",
  p: "none",
  background: "transparent"
}).withConfig({
  displayName: "GalleryCodeSnippet__Pre"
})([""]);
var Code = styled(Text).attrs({
  as: "code",
  font: "gallery.code",
  p: "none"
}).withConfig({
  displayName: "GalleryCodeSnippet__Code"
})(["word-break:break-word;"]);
var Toolbar = styled(Flex$1).attrs({
  p: "s",
  borderTop: "default",
  justifyContent: "flex-end",
  alignItems: "center"
}).withConfig({
  displayName: "GalleryCodeSnippet__Toolbar"
})([""]);
var EditorWrapper = styled(Box$1).attrs(function (props) {
  return {
    p: "s",
    background: "transparent",
    minHeight: props.minHeight
  };
}).withConfig({
  displayName: "GalleryCodeSnippet__EditorWrapper"
})(["", ""], function (props) {
  return props.canEdit && "\n    cursor: pointer;\n  ";
});
var LangSelect = styled.select.withConfig({
  displayName: "GalleryCodeSnippet__LangSelect"
})(["color:", ";", " ", ";", ";", ";background:transparent;opacity:0.5;width:auto;border:none;appearance:none;", ""], function (props) {
  return props.theme.primaryColor || color.primary;
}, function (props) {
  return getFont(null, "ui.small", props);
}, margin.r.s, padding.r.s, padding.y.none, function (props) {
  return !props.canEdit && "\n    user-select: none;\n    pointer-events: none;\n  ";
});
var SelectIcon = styled(Icon$1).withConfig({
  displayName: "GalleryCodeSnippet__SelectIcon"
})(["fill:", ";pointer-events:none;position:absolute;right:0;top:calc(50% - 6px);"], function (props) {
  return props.theme.primaryColor || color.primary;
});
var Textarea = styled(AutosizeTextarea).withConfig({
  displayName: "GalleryCodeSnippet__Textarea"
})(["min-height:18px;padding:0;background:transparent;border:none;width:100%;", ";color:", ";resize:none;vertical-align:top;margin:0;&:focus{outline:none;}"], font.gallery.code, color.grayDarkest);
var GalleryCodeSnippet = function GalleryCodeSnippet(_ref) {
  var item = _ref.item,
    selected = _ref.selected,
    canEdit = _ref.canEdit,
    isEditing = _ref.isEditing,
    hasDefaultValue = _ref.hasDefaultValue,
    onBeginEditing = _ref.onBeginEditing,
    onFinishEditing = _ref.onFinishEditing,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var _item$data = item.data,
    textContent = _item$data.textContent,
    codeLanguage = _item$data.codeLanguage;
  var _useState = useState(textContent),
    _useState2 = _slicedToArray(_useState, 2),
    editValue = _useState2[0],
    setEditValue = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    minHeight = _useState4[0],
    setMinHeight = _useState4[1];

  // Refs
  var codeRef = useCodeHighlighting(textContent, codeLanguage);
  var editorRef = useRef(null);
  var _useClipboard = useClipboard(textContent),
    onCopy = _useClipboard.onCopy,
    hasCopied = _useClipboard.hasCopied;
  var wrapperId = item.id.concat("-code-snippet");
  var langOpts = codeLangs$1.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c);
  });
  var beginEditing = useCallback(function () {
      if (onBeginEditing) onBeginEditing(item.id);
    }, [item, onBeginEditing]),
    finishEditing = useCallback(function () {
      if (!isEditing || !canEdit || !onFinishEditing) return;

      // Do not submit if the original content hasn't changed
      var val = editValue.trim();
      if (textContent.trim() === val) {
        return onFinishEditing(item, null);
      }
      var data = {
        data: {
          content: val,
          // original code lang
          codeLanguage: codeLanguage
        }
      };
      onFinishEditing(item, data);
    }, [isEditing, canEdit, onFinishEditing, editValue, textContent, codeLanguage, item]);
  var updateLanguage = useCallback(function (value) {
    if (!canEdit || !onFinishEditing) return;
    // Do not submit if the lang hasn't changed
    if (codeLanguage === value) return;
    var data = {
      data: {
        // current item text content
        content: textContent,
        codeLanguage: value
      }
    };
    onFinishEditing(item, data);
  }, [canEdit, onFinishEditing, codeLanguage, textContent, item]);
  var onKeyDown = useSubmitTextKeys(true);

  /**
   * Rehydrate the editor state vars each time the item in state updates
   * or the editor mode is toggled
   *
   * Focus and place cursor at the end of the textara content when entering edit mode
   */
  useEffect(function () {
    setEditValue(textContent);
    if (isEditing && editorRef.current) {
      (hasDefaultValue ? focusAllOfInput : focusEndOfInput)(editorRef.current);
    }
  }, [textContent, isEditing, hasDefaultValue]);

  /**
   * Set the min-height of the editor container to the initial
   * height to prevent flashes of surrounding content when toggling modes
   */
  useLayoutEffect(function () {
    var heightTimeout = setTimeout(function () {
      var wrapperEl = document.getElementById(wrapperId);
      if (!wrapperEl) return;
      if (isEditing) return setMinHeight(null);
      setMinHeight("".concat(wrapperEl.clientHeight, "px"));
    }, 100);
    return function () {
      return clearTimeout(heightTimeout);
    };
  }, [wrapperId, editValue, item, isEditing]);
  var renderPre = function renderPre() {
    return /*#__PURE__*/React.createElement(Pre, null, /*#__PURE__*/React.createElement(Code, {
      ref: codeRef
    }, textContent));
  };

  /**
   * Watch for shift+enter or meta+enter key tp update snippet
   */

  var wrapperProps = {
    canEdit: canEdit,
    onDoubleClick: canEdit ? beginEditing : undefined
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    selected: selected
  }, rest, {
    "data-testid": parentTestId
  }), /*#__PURE__*/React.createElement(SelectionWrapper$1, {
    selected: selected
  }, /*#__PURE__*/React.createElement(EditorWrapper, _extends({
    id: wrapperId,
    "data-testid": wrapperTestId$1,
    minHeight: minHeight
  }, wrapperProps), isEditing ? /*#__PURE__*/React.createElement(Textarea, {
    ref: editorRef,
    "data-testid": editorTestId,
    "aria-label": "Update code snippet",
    onBlur: finishEditing,
    onKeyDown: onKeyDown,
    onChange: function onChange(e) {
      return setEditValue(e.target.value);
    },
    value: editValue,
    maxRows: 1000
  }) : renderPre()), /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Box$1, {
    position: "relative",
    pr: canEdit ? "s" : "none"
  }, /*#__PURE__*/React.createElement(LangSelect, {
    "data-testid": selectTestId,
    canEdit: canEdit,
    dir: "rtl",
    value: codeLanguage,
    onChange: function onChange(e) {
      return updateLanguage(e.target.value);
    }
  }, langOpts), canEdit && /*#__PURE__*/React.createElement(SelectIcon, {
    size: 14,
    iconId: "triangle-double"
  })), /*#__PURE__*/React.createElement(Button$1, {
    mx: "s",
    onClick: onCopy,
    size: "small",
    text: hasCopied ? "Copied" : "Copy"
  }))));
};
GalleryCodeSnippet.defaultProps = {
  isEditing: false
};
var GalleryCodeSnippet$1 = GalleryCodeSnippet;

var _excluded$1 = ["item", "canEdit", "selected"];
var wrapperTestId = "support-image-wrapper";
var SupportingAssetContainer = styled(StretchingAsset$1).attrs(function (props) {
  return {
    border: props.selected ? "1px solid transparent" : "1px solid grayLight",
    m: "-2px"
  };
}).withConfig({
  displayName: "GallerySupportingAsset__SupportingAssetContainer"
})([""]);
var SelectionWrapper = styled(Box$1).attrs(function (props) {
  return {
    borderRadius: "default",
    background: "white",
    border: props.selected ? "2px solid ".concat(getColor(props.theme.primaryColor, "primary")) : "2px solid transparent"
  };
}).withConfig({
  displayName: "GallerySupportingAsset__SelectionWrapper"
})([""]);
var GallerySupportingAsset = function GallerySupportingAsset(_ref) {
  var item = _ref.item,
    canEdit = _ref.canEdit,
    selected = _ref.selected,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  if (!item) return null;
  if (!item.asset) {
    console.error("Expected item ".concat(item.id, " to have asset"));
    return null;
  }
  var isImage = [AssetType.jpg, AssetType.png, AssetType.gif].includes(item.asset.type);
  var imageStyles = isImage ? {
    pointerEvents: "none"
  } : {}; // Don't interfere with drag & drop

  return /*#__PURE__*/React.createElement(Box$1, _extends({
    "data-testid": wrapperTestId,
    width: "100%",
    px: "s"
  }, rest), /*#__PURE__*/React.createElement(SelectionWrapper, {
    selected: selected,
    canEdit: canEdit
  }, /*#__PURE__*/React.createElement(SupportingAssetContainer, {
    selected: selected,
    canEdit: canEdit,
    asset: item.asset,
    style: imageStyles
  })));
};
var GallerySupportingAsset$1 = GallerySupportingAsset;

var AutocompleteMenu = styled(Box$1).attrs({
  borderRadius: "default",
  position: "absolute",
  top: "100%",
  zIndex: 1,
  width: "100%",
  background: "white",
  border: "default",
  borderTop: "none",
  boxShadow: "panel"
}).withConfig({
  displayName: "AutocompleteMenu"
})([""]);
var Item = styled(Box$1).attrs(function (props) {
  return {
    p: "xs",
    mx: "xs",
    borderRadius: "default",
    background: props.isActive ? "grayLightest" : "none"
  };
}).withConfig({
  displayName: "AutocompleteMenu__Item"
})([""]);
var Divider = styled(Box$1).attrs({
  height: "4px",
  background: "grayLightest"
}).withConfig({
  displayName: "AutocompleteMenu__Divider"
})([""]);
var Component = AutocompleteMenu;
Component.Item = Item;
Component.Divider = Divider;
var AutocompleteMenu$1 = Component;

var _excluded = ["query", "suggestions", "autoFocus", "placeholder", "clearSearch", "submitSearch", "fetchSuggestions", "background", "disabled"];
function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledInput = styled(Element).withConfig({
  displayName: "SearchField__StyledInput"
})(["background:", ";"], function (props) {
  return getColor(props.background, "grayLightest");
});
var SearchField = function SearchField(_ref) {
  var queryProp = _ref.query,
    _ref$suggestions = _ref.suggestions,
    suggestions = _ref$suggestions === void 0 ? [] : _ref$suggestions,
    autoFocus = _ref.autoFocus,
    placeholder = _ref.placeholder,
    clearSearch = _ref.clearSearch,
    submitSearch = _ref.submitSearch,
    fetchSuggestions = _ref.fetchSuggestions,
    background = _ref.background,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(queryProp || ""),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1],
    onQueryChanged = function onQueryChanged(q) {
      setQuery(q);
      if (fetchSuggestions && q) {
        fetchSuggestions(q);
      }
      if (!q) clearSearch();
    },
    clearSearchQuery = function clearSearchQuery() {
      setQuery("");
      clearSearch();
    },
    submitSearchQuery = function submitSearchQuery(q) {
      if (q && q !== query) {
        setQuery(q);
      }
      var qry = q || query;
      if (qry) {
        submitSearch(qry);
      } else {
        // User hit enter with empty query; go back to full kit
        clearSearch();
      }
    };

  /**
   *  If the query prop changes from an outside source (ex. Tags),
   *  update the internal query state variable to match the change
   * */
  useEffect(function () {
    if (queryProp !== query) setQuery(queryProp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryProp]);

  // Normalize the suggestion list into a flat array of objects
  // The normalized list can contain Suggestions or `0` to indicate a divider
  var displayItems = useMemo(function () {
    function validateSuggestionFormat(suggs) {
      if (!suggs) return null;
      if (Array.isArray(suggs[0])) return suggs;
      if (!suggs.length) return [];
      return [suggs];
    }
    var _count = 0;
    var _items = validateSuggestionFormat(suggestions).filter(function (s) {
      return s.length;
    }).reduce(function (res, items) {
      if (res.length) res.push(0);
      var indexedItems = items.map(function (i, idx) {
        return _objectSpread$2(_objectSpread$2({}, i), {}, {
          idx: _count + idx
        });
      });
      _count += items.length;
      return [].concat(_toConsumableArray(res), _toConsumableArray(indexedItems));
    }, []);
    return _items;
  }, [suggestions]);
  var items = displayItems.filter(function (i) {
    return i !== 0;
  });
  var _useCombobox = useCombobox({
      items: items,
      inputValue: query,
      onInputValueChange: function onInputValueChange(_ref2) {
        var inputValue = _ref2.inputValue;
        return onQueryChanged(inputValue);
      },
      onHighlightedIndexChange: function onHighlightedIndexChange(event) {
        var isArrowEvent = event.type === useCombobox.stateChangeTypes.InputKeyDownArrowUp || event.type === useCombobox.stateChangeTypes.InputKeyDownArrowDown;
        if (isArrowEvent) {
          var item = items[event.highlightedIndex];
          if (item) {
            setQuery(item.display);
          }
        }
      },
      onSelectedItemChange: function onSelectedItemChange(_ref3) {
        var selectedItem = _ref3.selectedItem;
        if (selectedItem) {
          submitSearchQuery(selectedItem.token);
        }
      },
      itemToString: function itemToString(i) {
        return i ? i.token : "";
      }
    }),
    isOpen = _useCombobox.isOpen,
    closeMenu = _useCombobox.closeMenu,
    getMenuProps = _useCombobox.getMenuProps,
    getInputProps = _useCombobox.getInputProps,
    selectedItem = _useCombobox.selectedItem,
    highlightedIndex = _useCombobox.highlightedIndex,
    getItemProps = _useCombobox.getItemProps;
  function renderResetButton() {
    return query ? /*#__PURE__*/React.createElement(Button$1, {
      id: "search-field-clear-button",
      buttonStyle: "tertiary",
      size: "regular",
      position: "absolute",
      top: "calc(50% - 12px)",
      right: "6px",
      onClick: clearSearchQuery,
      icon: "close"
    }) : /*#__PURE__*/React.createElement(Icon$1, {
      "data-testid": "search-field-icon",
      iconId: "search",
      fill: "grayDark",
      position: "absolute",
      right: "6px",
      top: "calc(50% - 12px)"
    });
  }
  var showMenu = isOpen && query && items.length;
  return /*#__PURE__*/React.createElement(Flex$1, _extends({
    width: "100%"
  }, rest), /*#__PURE__*/React.createElement(StyledInput, _extends({
    pr: "28px",
    background: background,
    "data-testid": "search-field-input",
    disabled: disabled
  }, getInputProps({
    id: "search-input",
    autoFocus: autoFocus,
    type: "search",
    placeholder: placeholder,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" && highlightedIndex < 0) {
        closeMenu();
        submitSearchQuery();
      }
    }
  }))), renderResetButton(), /*#__PURE__*/React.createElement(AutocompleteMenu$1, _extends({
    "data-testid": "search-field-autocomplete",
    display: showMenu ? "visible" : "none"
  }, getMenuProps()), displayItems.map(function (item, idx) {
    return item === 0 ? /*#__PURE__*/React.createElement(AutocompleteMenu$1.Divider, {
      key: "divider-".concat(idx),
      "data-testid": "search-field-divider"
    }) : /*#__PURE__*/React.createElement(AutocompleteMenu$1.Item, _extends({
      "data-testid": "search-field-suggestion",
      key: "item-".concat(item.idx),
      isActive: highlightedIndex === item.idx
    }, getItemProps({
      item: item,
      index: item.idx,
      isSelected: selectedItem === item.idx
    })), /*#__PURE__*/React.createElement(Text, {
      truncate: true
    }, item.display));
  })));
};
SearchField.defaultProps = {
  autoFocus: false,
  suggestions: [],
  query: "",
  placeholder: "Search"
};
var SearchField$1 = SearchField;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var theme = _objectSpread$1(_objectSpread$1({}, defaultRebootTheme), {}, {
  black: color.black,
  fontFamilyBase: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  fontFamilyMonospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontSizeBase: "14px",
  fontWeightBase: 400,
  lineHeightBase: 1.5,
  bodyColor: color.black,
  bodyBg: color.white,
  linkColor: color.primary,
  linkDecoration: "none",
  linkHoverColor: color.primaryDark,
  linkHoverDecoration: "underline"
});
var StyleWrapper = createGlobalStyle(["", " html{font-feature-settings:\"dlig\",\"zero\",\"ss01\",\"cv05\",\"cv10\";}img{max-width:100%;}"], reboot);
var GlobalStyle = function GlobalStyle() {
  return React.createElement(StyleWrapper, {
    theme: theme
  });
};
var GlobalStyle$1 = GlobalStyle;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getShortIdsFromEntities = function getShortIdsFromEntities(entities) {
  var objectMap = {
    sections: {
      key: "id",
      type: "sections"
    },
    items: {
      key: "id",
      type: "items"
    },
    kits: {
      key: "kitId",
      type: "kits"
    },
    kitCollections: {
      key: "uuid",
      type: "kitCollections"
    }
  };
  return Object.keys(entities).reduce(function (res, entitityType) {
    // We only care object types with an id mapping defined above
    var mapping = objectMap[entitityType];
    if (!mapping) return res;
    var key = mapping.key,
      type = mapping.type;
    var objects = Object.values(entities[entitityType]);
    res[type] = objects.reduce(function (objAcc, obj) {
      // This check ensures values because inserting null or undefined values would produce strange bugs
      if (!obj[key] || !obj.shortId) throw new Error("".concat(type, " object missing expected shortID or ").concat(key));
      objAcc[obj.shortId] = obj[key];
      return objAcc;
    }, res[type] || {});
    return res;
  }, {});
};
var Repo = /*#__PURE__*/function () {
  function Repo(state) {
    _classCallCheck(this, Repo);
    this.entities = state.entities || {};
    this.shortIds = this.entities.shortIds || getShortIdsFromEntities(this.entities);
  }

  /**
   * Clean ids formatted as uuid-version, returning only the uuid.
   *
   * @param {String} idString a string object identifier
   */
  _createClass(Repo, [{
    key: "parseIdentifier",
    value: function parseIdentifier(id, version) {
      var uuidPattern = "^(X{8}-X{4}-4X{3}-[89abAB]X{3}-X{12})(?:-(\\d+))?".replace(/X/g, "[0-9a-fA-F]");
      var match = id.match(uuidPattern) || [];
      return {
        id: match[1] || id,
        version: [version, match[2]].map(function (v) {
          return Number(v);
        }).find(function (v) {
          return !Number.isNaN(v);
        })
      };
    }
  }, {
    key: "getUser",
    value: function getUser(id) {
      if (!id) return null;
      return this._users[id] || null;
    }
  }, {
    key: "getSpace",
    value: function getSpace(id) {
      if (!id) return null;
      var spaces = this._spaces;
      if (spaces[id]) return spaces[id];
      return Object.values(spaces).find(function (s) {
        return s.subdomain === id;
      }) || null;
    }
  }, {
    key: "getJoinLink",
    value: function getJoinLink(token) {
      if (!token) return null;
      return this._joinLinks[token] || null;
    }

    /**
     *
     * @param {string|number} spaceId A space id OR `spaceId-userId`
     * @param {number} userId a user id or if spaceId is merged, undefined
     * @returns
     */
  }, {
    key: "getSpaceMember",
    value: function getSpaceMember(spaceId, userId) {
      var members = this._spaceMembers,
        member = members[spaceId] || members[[spaceId, userId].join("-")];
      return member ? _objectSpread(_objectSpread({}, member), {}, {
        user: this.getUser(member.userId)
      }) : null;
    }
  }, {
    key: "getSpaceMembers",
    value: function getSpaceMembers(spaceId) {
      var _this$getSpace,
        _this = this;
      var normalizedId = ((_this$getSpace = this.getSpace(spaceId)) === null || _this$getSpace === void 0 ? void 0 : _this$getSpace.id) || spaceId;
      var members = Object.values(this._spaceMembers);
      return members.filter(function (m) {
        return m.spaceId === normalizedId;
      }).map(function (m) {
        return _objectSpread(_objectSpread({}, m), {}, {
          user: _this.getUser(m.userId)
        });
      });
    }
  }, {
    key: "getInvitation",
    value: function getInvitation(id) {
      if (!id) return null;
      return this._invitations[id] || null;
    }
  }, {
    key: "getKit",
    value: function getKit(identifier, _spaceId) {
      if (!identifier) return null;
      var uuid = this._kitShortIds[identifier] || identifier;
      return this._kits[uuid] || null;
    }
  }, {
    key: "getKitMember",
    value: function getKitMember(userId, kitIdentifier, spaceId) {
      var uuid = this._kitShortIds[kitIdentifier] || kitIdentifier;
      var id = [spaceId, userId, uuid].join("-");
      var member = this._kitMembers[id];
      return member ? _objectSpread(_objectSpread({}, member), {}, {
        user: this.getUser(userId)
      }) : null;
    }
  }, {
    key: "getKitMembers",
    value: function getKitMembers(kitIdentifier, spaceId) {
      var _this2 = this;
      var uuid = this._kitShortIds[kitIdentifier] || kitIdentifier;
      return Object.values(this._kitMembers).filter(function (m) {
        return m.kitId === uuid && m.spaceId === spaceId;
      }).map(function (m) {
        return _objectSpread(_objectSpread({}, m), {}, {
          user: _this2.getUser(m.userId)
        });
      });
    }
  }, {
    key: "getKitVersions",
    value: function getKitVersions(identifier, spaceId) {
      var kit = this.getKit(identifier, spaceId);
      if (!kit) return [];
      return this.fetchVersions(kit.versions || []);
    }
  }, {
    key: "fetchVersions",
    value: function fetchVersions(versionIdentifiers) {
      var versions = this._versions;
      return versionIdentifiers.map(function (versionId) {
        return versions[versionId];
      }).sort(function (a, b) {
        return a.version - b.version;
      });
    }
  }, {
    key: "getVersion",
    value: function getVersion(identifier, versionNumber) {
      if (!identifier) return null;
      var _this$parseIdentifier = this.parseIdentifier(identifier, versionNumber),
        id = _this$parseIdentifier.id,
        version = _this$parseIdentifier.version;
      if (version == null) return null;
      var uuid = this._kitShortIds[id] || id;
      var idVersion = "".concat(uuid, "-").concat(version);
      return this._versions[idVersion] || null;
    }
  }, {
    key: "getSection",
    value: function getSection(identifier) {
      var versionNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!identifier) return null;
      var _this$parseIdentifier2 = this.parseIdentifier(identifier, versionNumber),
        id = _this$parseIdentifier2.id,
        version = _this$parseIdentifier2.version;
      if (version == null) return null;
      var uuid = this._sectionShortIds[id] || id;
      var idVersion = "".concat(uuid, "-").concat(version);
      return this._sections[idVersion] || null;
    }
  }, {
    key: "getItem",
    value: function getItem(identifier, versionNumber) {
      if (!identifier) return null;
      var _this$parseIdentifier3 = this.parseIdentifier(identifier, versionNumber),
        id = _this$parseIdentifier3.id,
        version = _this$parseIdentifier3.version;
      if (version == null) return null;
      var uuid = this._itemShortIds[id] || id;
      var idVersion = "".concat(uuid, "-").concat(version);
      var item = this._items[idVersion];
      if (!item) return null;
      var asset = this._assets[item.assetId];
      if (asset) {
        var itemWithAsset = _objectSpread(_objectSpread({}, item), {}, {
          asset: asset
        });
        return itemWithAsset;
      }
      return item;
    }
  }, {
    key: "getAsset",
    value: function getAsset(identifier) {
      if (!identifier) return null;
      var asset = this._assets[identifier];
      if (asset) {
        return asset;
      }
      return null;
    }
  }, {
    key: "getKits",
    value: function getKits(spaceId) {
      var _this3 = this;
      var space = this.getSpace(spaceId);
      if (!space || !space.kits) return [];
      return space.kits.map(function (kitUuid) {
        return _this3.getKit(kitUuid, spaceId);
      });
    }
  }, {
    key: "getKitCollection",
    value: function getKitCollection(identifier) {
      var uuid = this._kitCollectionShortIds[identifier] || identifier;
      return this._kitCollections[uuid] || null;
    }

    // MARK : Private getters
    /*-------------------------------------------------------------------------------*/
  }, {
    key: "_getObjects",
    value: function _getObjects(type) {
      return this.entities[type] || {};
    }
  }, {
    key: "_assets",
    get: function get() {
      return this._getObjects("assets");
    }
  }, {
    key: "_users",
    get: function get() {
      return this._getObjects("users");
    }
  }, {
    key: "_spaces",
    get: function get() {
      return this._getObjects("spaces");
    }
  }, {
    key: "_spaceMembers",
    get: function get() {
      return this._getObjects("spaceMembers");
    }
  }, {
    key: "_invitations",
    get: function get() {
      return this._getObjects("invitations");
    }
  }, {
    key: "_joinLinks",
    get: function get() {
      return this._getObjects("joinLinks");
    }
  }, {
    key: "_kits",
    get: function get() {
      return this._getObjects("kits");
    }
  }, {
    key: "_kitMembers",
    get: function get() {
      return this._getObjects("kitMembers");
    }
  }, {
    key: "_versions",
    get: function get() {
      return this._getObjects("kitVersions");
    }
  }, {
    key: "_items",
    get: function get() {
      return this._getObjects("items");
    }
  }, {
    key: "_sections",
    get: function get() {
      return this._getObjects("sections");
    }
  }, {
    key: "_kitCollections",
    get: function get() {
      return this._getObjects("kitCollections");
    }

    // MARK : Get short Ids
    /*-------------------------------------------------------------------------------*/
  }, {
    key: "_getShortIds",
    value: function _getShortIds(type) {
      return this.shortIds[type] || {};
    }
  }, {
    key: "_itemShortIds",
    get: function get() {
      return this._getShortIds("items");
    }
  }, {
    key: "_sectionShortIds",
    get: function get() {
      return this._getShortIds("sections");
    }
  }, {
    key: "_kitShortIds",
    get: function get() {
      return this._getShortIds("kits");
    }
  }, {
    key: "_kitCollectionShortIds",
    get: function get() {
      return this._getShortIds("kitCollections");
    }
  }]);
  return Repo;
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var RepoClass = Repo;
RepoClass.getShortIdsFromEntities = getShortIdsFromEntities;
var RepoClass$1 = RepoClass;

var API = {
  middleware: apiMiddleware,
  makeAction: makeAction,
  callApi: callApi,
  CALL_API: CALL_API
};

function parseUrl(url) {
  if (url.startsWith("/")) {
    return {
      isDifferentHost: false,
      url: url
    };
  }
  try {
    var _URL = new URL(url),
      target = _URL.hostname,
      pathname = _URL.pathname,
      search = _URL.search;
    var current = window.location.hostname;
    if (target !== current) {
      return {
        isDifferentHost: true,
        url: url
      };
    } else {
      return {
        isDifferentHost: false,
        url: [pathname, search].join("")
      };
    }
  } catch (e) {
    return {
      isDifferentHost: false,
      url: url
    };
  }
}
function useNavigation() {
  var history = useHistory();
  var replace = useCallback(function (_url) {
    var _parseUrl = parseUrl(_url),
      isDifferentHost = _parseUrl.isDifferentHost,
      url = _parseUrl.url;
    if (isDifferentHost) {
      window.location.replace(url);
    } else {
      history.replace(url);
    }
  }, [history]);
  var push = useCallback(function (_url) {
    var _parseUrl2 = parseUrl(_url),
      isDifferentHost = _parseUrl2.isDifferentHost,
      url = _parseUrl2.url;
    if (isDifferentHost) {
      window.location.assign(url);
    } else {
      history.push(url);
    }
  }, [history]);
  return {
    replace: replace,
    push: push
  };
}

/**
 * Hook for determining the browser viewport X and Y scroll position
 * https://github.com/n8tb1t/use-scroll-position
 *
 * Props:
 * effect => Effect callback.
 * deps => For effects to fire on selected dependencies change.
 * element => Get scroll position for a specified element by reference.
 * useWindow => Use window.scroll instead of document.body.getBoundingClientRect() to detect scroll position.
 * wait => 	The timeout in ms. Good for performance.
 */
function getScrollPosition(_ref) {
  var element = _ref.element,
    useWindow = _ref.useWindow;
  if (!isBrowser()) return {
    x: 0,
    y: 0
  };
  var target = element !== null && element !== void 0 ? element : document.body;
  var position = target.getBoundingClientRect();
  return useWindow ? {
    x: window.scrollX,
    y: window.scrollY
  } : {
    x: position.left,
    y: position.top
  };
}
function useScrollPosition(effect, deps, element, useWindow, wait) {
  var position = useRef(getScrollPosition({
    useWindow: useWindow
  }));
  var throttleTimeout = null;
  var callBack = function callBack() {
    var currPos = getScrollPosition({
      element: element,
      useWindow: useWindow
    });
    effect({
      prevPos: position.current,
      currPos: currPos
    });
    position.current = currPos;
    throttleTimeout = null;
  };
  useLayoutEffect(function () {
    var handleScroll = function handleScroll() {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return function () {
      return window.removeEventListener("scroll", handleScroll);
    };
  }, deps);
}

/**
 * A light wrapper around date-fns dateFormat to automate parsing date strings
 * from model objects
 * @param {String} dateString
 * @param {String} format the template to format the date
 * @returns A formatted string date representation
 */
function _dateFormat(dateString, dateFormat) {
  if (!dateString || dateString === "") {
    return "";
  }
  return format(parseISO(dateString), dateFormat);
}

function formatBytes(bytes) {
  if (bytes === 0) return "0 Bytes";
  if (bytes === 1) return "1 Byte";
  var k = 1000;
  var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var decimals = 0;
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  // eslint-disable-next-line no-restricted-properties
  var val = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)),
    unit = sizes[i];
  return "".concat(val, " ").concat(unit);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */

var openIntercom = function openIntercom() {
  var _window;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$launchChat = _ref.launchChat,
    launchChat = _ref$launchChat === void 0 ? true : _ref$launchChat,
    message = _ref.message;
  (_window = window) === null || _window === void 0 ? void 0 : _window.Intercom("update", {
    hide_default_launcher: false
  });

  /**
   * launchChat indicates that the bubble was hidden previously.
   * Add a listener to shut down again when then dialog is closed.
   */
  if (launchChat || message) {
    var _window2, _window4;
    (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.Intercom("show");
    if (message) {
      var _window3;
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.Intercom("showNewMessage", message);
    }
    (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.Intercom("onHide", function () {
      var _window5;
      return (_window5 = window) === null || _window5 === void 0 ? void 0 : _window5.Intercom("update", {
        hide_default_launcher: true
      });
    });
  }
};

/**
 * Encode unicode values to base64
 * https://attacomsian.com/blog/javascript-base64-encode-decode
 * https://developer.mozilla.org/en-US/docs/Web/API/btoa
 */

/**
 * Base 64 encode a value to a string accounting for unicode
 * @param value Any json value
 * @returns
 */
var encode = function encode(value) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  var str = value;
  if (typeof value !== "string") str = JSON.stringify(str);
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(_match, p1) {
    return String.fromCharCode("0x".concat(p1));
  }));
};
var decode = function decode(value) {
  return decodeURIComponent(atob(value).split("").map(function (c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
};
var base64 = {
  encode: encode,
  decode: decode
};

export { API, ActivityIndicator$1 as ActivityIndicator, AssetType, Badge, Box$1 as Box, Button$1 as Button, ButtonStyle, Checkbox$2 as Checkbox, ContextMenu$1 as ContextMenu, CustomFieldOperation, CustomFieldTypes, DropdownButton$1 as DropdownButton, Flex$1 as Flex, GalleryCodeSnippet$1 as GalleryCodeSnippet, GalleryGuide$1 as GalleryGuide, GalleryHeading$1 as GalleryHeading, GalleryMarkdown$1 as GalleryMarkdown, GalleryNote$1 as GalleryNote, GallerySupportingAsset$1 as GallerySupportingAsset, GlobalStyle$1 as GlobalStyle, Grid$1 as Grid, Icon$1 as Icon, ImageView$1 as ImageView, Input$2 as Input, ItemType, KitCard$1 as KitCard, KitPermission, LingoError, LottieAnimation$1 as LottieAnimation, MarkdownText$1 as MarkdownText, Component$6 as Modal, Component$4 as NavPill, normalizers as Normalizers, Notice$1 as Notice, OptionCard$1 as OptionCard, PopupMenu, PrivacyLevel, RepoClass$1 as Repo, Schemas, SearchField$1 as SearchField, SearchFilterTypes, SearchOperators, Select$1 as Select, SpacePermission, SpaceThemeHeaderTitleOptions, SpaceThemeNames, Switch$1 as Switch, Component$2 as TabBar, Text, Textarea$5 as Textarea, ToggleBox$1 as ToggleBox, Tooltip$1 as Tooltip, base64, buildPath, buildURL, formatBytes as bytesToSize, callApi, callApiWithRawResponse, camelCaseKeys, elementIds, elementInViewport, factory, formatAsset, _dateFormat as formatDate, formatItem, getApiServiceURL, getCustomDomainComponents, markdownStyle, openIntercom, pluralize, slugifyName, styles, urlNeedsReload, useBoolean, useClipboard, useCodeHighlighting, useContextMenu, useDrag, useEventListener, useNavigation, useScrollPosition, useSpaceThemeName, useWindowSize, utils };
